/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** The `ID` scalar type represents a unique MongoDB identifier in collection. MongoDB by default use 12-byte ObjectId value (https://docs.mongodb.com/manual/reference/bson-types/#objectid). But MongoDB also may accepts string or integer as correct values for _id field. */
  MongoID: any;
  /** The string representation of JavaScript regexp. You may provide it with flags "/^abc.*\/i" or without flags like "^abc.*". More info about RegExp characters and flags: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions */
  RegExpAsString: any;
};

export type AllLookupMutationDeleteResponse = {
  __typename?: 'AllLookupMutationDeleteResponse';
  deletedCount?: Maybe<Scalars['Int']>;
};

export type AllLookupQuery = {
  __typename?: 'AllLookupQuery';
  _category?: Maybe<PositionStatusCategory>;
  _createdBy?: Maybe<User>;
  _id: Scalars['MongoID'];
  _status?: Maybe<Candidate_Status>;
  _updatedBy?: Maybe<User>;
  abbreviation?: Maybe<Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
  category?: Maybe<Scalars['MongoID']>;
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  createdBy?: Maybe<Scalars['MongoID']>;
  deleted?: Maybe<Scalars['Boolean']>;
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['MongoID']>;
  name?: Maybe<Scalars['String']>;
  oldOrder?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['String']>;
  relationships?: Maybe<Array<LookupRelationships>>;
  status?: Maybe<Scalars['MongoID']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<Scalars['MongoID']>;
};

export type Analytics = {
  __typename?: 'Analytics';
  _id: Scalars['MongoID'];
  agent?: Maybe<Scalars['String']>;
  appVersion?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['Date']>;
  ip?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['JSON']>;
  size?: Maybe<Scalars['JSON']>;
  updatedAt?: Maybe<Scalars['Date']>;
  user?: Maybe<Scalars['JSON']>;
};

export type ApplicantSource = {
  __typename?: 'ApplicantSource';
  _id: Scalars['String'];
  category?: Maybe<ApplicantSourceCategory>;
  count: Scalars['Int'];
  source: Scalars['String'];
};

export type ApplicantSourceCategory = {
  __typename?: 'ApplicantSourceCategory';
  _id: Scalars['String'];
  count: Scalars['Int'];
  name: Scalars['String'];
};

export type ApplicantStage = {
  __typename?: 'ApplicantStage';
  count?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type Attachment = {
  __typename?: 'Attachment';
  _createdBy?: Maybe<User>;
  _id: Scalars['MongoID'];
  /** Link Model Object */
  _link?: Maybe<AttachmentLinkType>;
  _subtype?: Maybe<Attachment_Subtype>;
  _type?: Maybe<Attachment_Type>;
  _updatedBy?: Maybe<User>;
  additional?: Maybe<Scalars['JSON']>;
  contentType?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  createdBy?: Maybe<Scalars['MongoID']>;
  deleted?: Maybe<Scalars['Boolean']>;
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['MongoID']>;
  filename?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['JSON']>;
  model?: Maybe<Scalars['String']>;
  s3?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  subtype?: Maybe<Scalars['MongoID']>;
  type?: Maybe<Scalars['MongoID']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<Scalars['MongoID']>;
  /** AWS S3 Attachment Signed URL */
  url?: Maybe<Scalars['String']>;
};

export type AttachmentLinkType = Candidate | Distribution | Position;

export type Attachment_Subtype = {
  __typename?: 'Attachment_Subtype';
  _id: Scalars['MongoID'];
  createdAt?: Maybe<Scalars['Date']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['MongoID']>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type Attachment_Type = {
  __typename?: 'Attachment_Type';
  _id: Scalars['MongoID'];
  createdAt?: Maybe<Scalars['Date']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type AverageTimeToFill = {
  __typename?: 'AverageTimeToFill';
  avg: Scalars['Int'];
  days?: Maybe<Array<Maybe<Scalars['Int']>>>;
  groups?: Maybe<Array<AverageTimeToFillGroup>>;
};

export type AverageTimeToFillGroup = {
  __typename?: 'AverageTimeToFillGroup';
  avg?: Maybe<Scalars['Int']>;
  days?: Maybe<Array<Maybe<Scalars['Int']>>>;
  group?: Maybe<Scalars['String']>;
};

/** The table and field to group by */
export type AverageTimeToFillGroupBy = {
  from: Scalars['String'];
  group: Scalars['String'];
  path: Scalars['String'];
  value: Scalars['String'];
};

export type Candidate = {
  __typename?: 'Candidate';
  _clearance?: Maybe<Clearance>;
  _createdBy?: Maybe<User>;
  _distribution?: Maybe<Distribution>;
  _id: Scalars['MongoID'];
  _position?: Maybe<Position>;
  _rank?: Maybe<Candidate_Rank>;
  _status?: Maybe<Candidate_Status>;
  _substatus?: Maybe<Candidate_Substatus>;
  _type?: Maybe<Candidate_Type>;
  _updatedBy?: Maybe<User>;
  address?: Maybe<CandidateAddress>;
  attachments_count?: Maybe<Scalars['Int']>;
  bill_rate?: Maybe<CandidateBill_Rate>;
  clearance?: Maybe<Scalars['MongoID']>;
  createdAt?: Maybe<Scalars['Date']>;
  createdBy?: Maybe<Scalars['MongoID']>;
  deleted?: Maybe<Scalars['Boolean']>;
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['MongoID']>;
  distribution?: Maybe<Scalars['MongoID']>;
  email?: Maybe<Scalars['String']>;
  exhibit?: Maybe<CandidateExhibit>;
  firstLastName?: Maybe<Scalars['String']>;
  lastFirstName?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  name?: Maybe<CandidateName>;
  nda_signed?: Maybe<CandidateNda_Signed>;
  notes?: Maybe<Scalars['String']>;
  offer_letter?: Maybe<CandidateOffer_Letter>;
  phone?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Float']>;
  rank?: Maybe<Scalars['MongoID']>;
  reapply?: Maybe<Scalars['Boolean']>;
  received_on?: Maybe<Scalars['Date']>;
  rejection_date?: Maybe<Scalars['Date']>;
  resume?: Maybe<CandidateResume>;
  round_1?: Maybe<Scalars['Date']>;
  round_2?: Maybe<Scalars['Date']>;
  round_3?: Maybe<Scalars['Date']>;
  salary?: Maybe<CandidateSalary>;
  status?: Maybe<Scalars['MongoID']>;
  substatus?: Maybe<Scalars['MongoID']>;
  type?: Maybe<Scalars['MongoID']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<Scalars['MongoID']>;
};

export type CandidateAddress = {
  __typename?: 'CandidateAddress';
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type CandidateAddressInput = {
  city?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type CandidateBill_Rate = {
  __typename?: 'CandidateBill_rate';
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
};

export type CandidateBill_RateInput = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type CandidateExhibit = {
  __typename?: 'CandidateExhibit';
  contracts_approved?: Maybe<Scalars['Date']>;
  extended?: Maybe<Scalars['Date']>;
  hm_approved?: Maybe<Scalars['Date']>;
  pmo_approved?: Maybe<Scalars['Date']>;
  sent_for_review?: Maybe<Scalars['Date']>;
  signed?: Maybe<Scalars['Date']>;
};

export type CandidateExhibitInput = {
  contracts_approved?: InputMaybe<Scalars['Date']>;
  extended?: InputMaybe<Scalars['Date']>;
  hm_approved?: InputMaybe<Scalars['Date']>;
  pmo_approved?: InputMaybe<Scalars['Date']>;
  sent_for_review?: InputMaybe<Scalars['Date']>;
  signed?: InputMaybe<Scalars['Date']>;
};

export type CandidateName = {
  __typename?: 'CandidateName';
  first?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['String']>;
};

export type CandidateNameInput = {
  first?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['String']>;
};

export type CandidateNda_Signed = {
  __typename?: 'CandidateNda_signed';
  candidate?: Maybe<Scalars['Date']>;
  staffing_agency?: Maybe<Scalars['Date']>;
};

export type CandidateNda_SignedInput = {
  candidate?: InputMaybe<Scalars['Date']>;
  staffing_agency?: InputMaybe<Scalars['Date']>;
};

export type CandidateOffer_Letter = {
  __typename?: 'CandidateOffer_letter';
  approved?: Maybe<Scalars['Date']>;
  extended?: Maybe<Scalars['Date']>;
  signed?: Maybe<Scalars['Date']>;
};

export type CandidateOffer_LetterInput = {
  approved?: InputMaybe<Scalars['Date']>;
  extended?: InputMaybe<Scalars['Date']>;
  signed?: InputMaybe<Scalars['Date']>;
};

export type CandidateResume = {
  __typename?: 'CandidateResume';
  _reviewed_by?: Maybe<Hiring_Manager>;
  reviewed?: Maybe<Scalars['Date']>;
  reviewed_by?: Maybe<Scalars['MongoID']>;
  sent?: Maybe<Scalars['Date']>;
};

export type CandidateResumeInput = {
  reviewed?: InputMaybe<Scalars['Date']>;
  reviewed_by?: InputMaybe<Scalars['MongoID']>;
  sent?: InputMaybe<Scalars['Date']>;
};

export type CandidateSalary = {
  __typename?: 'CandidateSalary';
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
};

export type CandidateSalaryInput = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type Candidate_Rank = {
  __typename?: 'Candidate_Rank';
  _createdBy?: Maybe<User>;
  _id: Scalars['MongoID'];
  _updatedBy?: Maybe<User>;
  archived?: Maybe<Scalars['Boolean']>;
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  createdBy?: Maybe<Scalars['MongoID']>;
  deleted?: Maybe<Scalars['Boolean']>;
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['MongoID']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<Scalars['MongoID']>;
};

export type Candidate_Status = {
  __typename?: 'Candidate_Status';
  _createdBy?: Maybe<User>;
  _id: Scalars['MongoID'];
  _updatedBy?: Maybe<User>;
  archived?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['Date']>;
  createdBy?: Maybe<Scalars['MongoID']>;
  deleted?: Maybe<Scalars['Boolean']>;
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['MongoID']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<Scalars['MongoID']>;
};

export type Candidate_Substatus = {
  __typename?: 'Candidate_Substatus';
  _createdBy?: Maybe<User>;
  _id: Scalars['MongoID'];
  _status?: Maybe<Candidate_Status>;
  _updatedBy?: Maybe<User>;
  archived?: Maybe<Scalars['Boolean']>;
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  createdBy?: Maybe<Scalars['MongoID']>;
  deleted?: Maybe<Scalars['Boolean']>;
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['MongoID']>;
  name?: Maybe<Scalars['String']>;
  oldOrder?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['JSON']>;
  status?: Maybe<Scalars['MongoID']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<Scalars['MongoID']>;
};

export type Candidate_Type = {
  __typename?: 'Candidate_Type';
  _createdBy?: Maybe<User>;
  _id: Scalars['MongoID'];
  _updatedBy?: Maybe<User>;
  archived?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['Date']>;
  createdBy?: Maybe<Scalars['MongoID']>;
  deleted?: Maybe<Scalars['Boolean']>;
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['MongoID']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<Scalars['MongoID']>;
};

export type Cat_Contract = {
  __typename?: 'Cat_Contract';
  _createdBy?: Maybe<User>;
  _id: Scalars['MongoID'];
  _portfolio_manager?: Maybe<Portfolio_Manager>;
  _program_manager?: Maybe<Program_Manager>;
  _status?: Maybe<Contract_Status>;
  _updatedBy?: Maybe<User>;
  _vehicle?: Maybe<Contract_Vehicle>;
  abbreviation?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  createdBy?: Maybe<Scalars['MongoID']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  onboarding?: Maybe<Cat_ContractOnboarding>;
  pop?: Maybe<Cat_ContractPop>;
  portfolio_manager?: Maybe<Scalars['MongoID']>;
  position_count?: Maybe<Scalars['Int']>;
  primary_address?: Maybe<Cat_ContractPrimary_Address>;
  prime?: Maybe<Scalars['Boolean']>;
  program_manager?: Maybe<Scalars['MongoID']>;
  status?: Maybe<Scalars['MongoID']>;
  subcontractor?: Maybe<Scalars['String']>;
  teamSize?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<Scalars['MongoID']>;
  vehicle?: Maybe<Scalars['MongoID']>;
};

export type Cat_ContractOnboarding = {
  __typename?: 'Cat_ContractOnboarding';
  biProcessTimeframe?: Maybe<Scalars['String']>;
  clearanceReqs?: Maybe<Scalars['Boolean']>;
  days?: Maybe<Scalars['String']>;
  gfeProvided?: Maybe<Scalars['Boolean']>;
  imcEquipment?: Maybe<Scalars['Boolean']>;
};

export type Cat_ContractOnboardingInput = {
  biProcessTimeframe?: InputMaybe<Scalars['String']>;
  clearanceReqs?: InputMaybe<Scalars['Boolean']>;
  days?: InputMaybe<Scalars['String']>;
  gfeProvided?: InputMaybe<Scalars['Boolean']>;
  imcEquipment?: InputMaybe<Scalars['Boolean']>;
};

export type Cat_ContractPop = {
  __typename?: 'Cat_ContractPop';
  base?: Maybe<Cat_ContractPopBase>;
  extensions?: Maybe<Array<Maybe<Cat_ContractPopExtensions>>>;
  options?: Maybe<Array<Maybe<Cat_ContractPopOptions>>>;
  status?: Maybe<Scalars['String']>;
};

export type Cat_ContractPopBase = {
  __typename?: 'Cat_ContractPopBase';
  end?: Maybe<Scalars['Date']>;
  start?: Maybe<Scalars['Date']>;
};

export type Cat_ContractPopBaseInput = {
  end?: InputMaybe<Scalars['Date']>;
  start?: InputMaybe<Scalars['Date']>;
};

export type Cat_ContractPopExtensions = {
  __typename?: 'Cat_ContractPopExtensions';
  _id?: Maybe<Scalars['MongoID']>;
  end?: Maybe<Scalars['Date']>;
  start?: Maybe<Scalars['Date']>;
};

export type Cat_ContractPopExtensionsInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  end?: InputMaybe<Scalars['Date']>;
  start?: InputMaybe<Scalars['Date']>;
};

export type Cat_ContractPopInput = {
  base?: InputMaybe<Cat_ContractPopBaseInput>;
  extensions?: InputMaybe<Array<InputMaybe<Cat_ContractPopExtensionsInput>>>;
  options?: InputMaybe<Array<InputMaybe<Cat_ContractPopOptionsInput>>>;
  status?: InputMaybe<Scalars['String']>;
};

export type Cat_ContractPopOptions = {
  __typename?: 'Cat_ContractPopOptions';
  _id?: Maybe<Scalars['MongoID']>;
  end?: Maybe<Scalars['Date']>;
  start?: Maybe<Scalars['Date']>;
};

export type Cat_ContractPopOptionsInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  end?: InputMaybe<Scalars['Date']>;
  start?: InputMaybe<Scalars['Date']>;
};

export type Cat_ContractPrimary_Address = {
  __typename?: 'Cat_ContractPrimary_address';
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type Cat_ContractPrimary_AddressInput = {
  city?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type Clearance = {
  __typename?: 'Clearance';
  _createdBy?: Maybe<User>;
  _id: Scalars['MongoID'];
  _updatedBy?: Maybe<User>;
  archived?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['Date']>;
  createdBy?: Maybe<Scalars['MongoID']>;
  deleted?: Maybe<Scalars['Boolean']>;
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['MongoID']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<Scalars['MongoID']>;
};

export type ContractInterviewer = {
  __typename?: 'ContractInterviewer';
  _contract?: Maybe<Cat_Contract>;
  _createdBy?: Maybe<User>;
  _id: Scalars['MongoID'];
  _updatedBy?: Maybe<User>;
  contract?: Maybe<Scalars['MongoID']>;
  createdAt?: Maybe<Scalars['Date']>;
  createdBy?: Maybe<Scalars['MongoID']>;
  deleted?: Maybe<Scalars['Boolean']>;
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['MongoID']>;
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<Scalars['MongoID']>;
};

export type Contract_Status = {
  __typename?: 'Contract_Status';
  _createdBy?: Maybe<User>;
  _id: Scalars['MongoID'];
  _updatedBy?: Maybe<User>;
  archived?: Maybe<Scalars['Boolean']>;
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  createdBy?: Maybe<Scalars['MongoID']>;
  deleted?: Maybe<Scalars['Boolean']>;
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['MongoID']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<Scalars['MongoID']>;
};

export type Contract_Type = {
  __typename?: 'Contract_Type';
  _createdBy?: Maybe<User>;
  _id: Scalars['MongoID'];
  _updatedBy?: Maybe<User>;
  archived?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['Date']>;
  createdBy?: Maybe<Scalars['MongoID']>;
  deleted?: Maybe<Scalars['Boolean']>;
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['MongoID']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<Scalars['MongoID']>;
};

export type Contract_Vehicle = {
  __typename?: 'Contract_Vehicle';
  _createdBy?: Maybe<User>;
  _id: Scalars['MongoID'];
  _updatedBy?: Maybe<User>;
  archived?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['Date']>;
  createdBy?: Maybe<Scalars['MongoID']>;
  deleted?: Maybe<Scalars['Boolean']>;
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['MongoID']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<Scalars['MongoID']>;
};

export type CopyCandidateNameInput = {
  first: Scalars['String'];
  last: Scalars['String'];
};

export type CopyCandidateResults = {
  __typename?: 'CopyCandidateResults';
  record?: Maybe<Candidate>;
  recordId: Scalars['MongoID'];
};

export type CreateManyDistributionInput = {
  category?: InputMaybe<Scalars['MongoID']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  date_posted?: InputMaybe<Scalars['Date']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  deletedBy?: InputMaybe<Scalars['MongoID']>;
  notes?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Float']>;
  subcategory?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['MongoID']>;
};

export type CreateManyDistributionPayload = {
  __typename?: 'CreateManyDistributionPayload';
  /** Number of created documents */
  createdCount: Scalars['Int'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']>;
  /** Created documents */
  records?: Maybe<Array<Distribution>>;
};

export type CreateManyDistribution_SubcategoryInput = {
  category?: InputMaybe<Scalars['MongoID']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  deletedBy?: InputMaybe<Scalars['MongoID']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  staffingAgency?: InputMaybe<Distribution_SubcategoryStaffingAgencyInput>;
  status?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['MongoID']>;
};

export type CreateManyDistribution_SubcategoryPayload = {
  __typename?: 'CreateManyDistribution_SubcategoryPayload';
  /** Number of created documents */
  createdCount: Scalars['Int'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']>;
  /** Created documents */
  records?: Maybe<Array<Distribution_Subcategory>>;
};

export type CreateOneAnalyticsInput = {
  agent?: InputMaybe<Scalars['String']>;
  appVersion?: InputMaybe<Scalars['Float']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  ip?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['JSON']>;
  size?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  user?: InputMaybe<Scalars['JSON']>;
};

export type CreateOneAnalyticsPayload = {
  __typename?: 'CreateOneAnalyticsPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Analytics>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type CreateOneCandidateInput = {
  address?: InputMaybe<CandidateAddressInput>;
  bill_rate?: InputMaybe<CandidateBill_RateInput>;
  clearance?: InputMaybe<Scalars['MongoID']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  deletedBy?: InputMaybe<Scalars['MongoID']>;
  distribution?: InputMaybe<Scalars['MongoID']>;
  email?: InputMaybe<Scalars['String']>;
  exhibit?: InputMaybe<CandidateExhibitInput>;
  firstLastName?: InputMaybe<Scalars['String']>;
  lastFirstName?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<CandidateNameInput>;
  nda_signed?: InputMaybe<CandidateNda_SignedInput>;
  notes?: InputMaybe<Scalars['String']>;
  offer_letter?: InputMaybe<CandidateOffer_LetterInput>;
  phone?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Float']>;
  rank?: InputMaybe<Scalars['MongoID']>;
  reapply?: InputMaybe<Scalars['Boolean']>;
  received_on?: InputMaybe<Scalars['Date']>;
  rejection_date?: InputMaybe<Scalars['Date']>;
  resume?: InputMaybe<CandidateResumeInput>;
  round_1?: InputMaybe<Scalars['Date']>;
  round_2?: InputMaybe<Scalars['Date']>;
  round_3?: InputMaybe<Scalars['Date']>;
  salary?: InputMaybe<CandidateSalaryInput>;
  status?: InputMaybe<Scalars['MongoID']>;
  substatus?: InputMaybe<Scalars['MongoID']>;
  type?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['MongoID']>;
};

export type CreateOneCandidatePayload = {
  __typename?: 'CreateOneCandidatePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Candidate>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type CreateOneCat_ContractInput = {
  abbreviation?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  onboarding?: InputMaybe<Cat_ContractOnboardingInput>;
  pop?: InputMaybe<Cat_ContractPopInput>;
  portfolio_manager?: InputMaybe<Scalars['MongoID']>;
  primary_address?: InputMaybe<Cat_ContractPrimary_AddressInput>;
  prime?: InputMaybe<Scalars['Boolean']>;
  program_manager?: InputMaybe<Scalars['MongoID']>;
  status?: InputMaybe<Scalars['MongoID']>;
  subcontractor?: InputMaybe<Scalars['String']>;
  teamSize?: InputMaybe<Scalars['Float']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['MongoID']>;
  vehicle?: InputMaybe<Scalars['MongoID']>;
};

export type CreateOneCat_ContractPayload = {
  __typename?: 'CreateOneCat_ContractPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Cat_Contract>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type CreateOneContractInterviewerInput = {
  contract?: InputMaybe<Scalars['MongoID']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  deletedBy?: InputMaybe<Scalars['MongoID']>;
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['MongoID']>;
};

export type CreateOneContractInterviewerPayload = {
  __typename?: 'CreateOneContractInterviewerPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<ContractInterviewer>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type CreateOnePermissionInput = {
  createdAt?: InputMaybe<Scalars['Date']>;
  key?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type CreateOnePermissionPayload = {
  __typename?: 'CreateOnePermissionPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Permission>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type CreateOnePositionInput = {
  backfill?: InputMaybe<Scalars['Boolean']>;
  bill_rate?: InputMaybe<PositionBill_RateInput>;
  closed_date?: InputMaybe<Scalars['Date']>;
  contract?: InputMaybe<Scalars['MongoID']>;
  contract_type?: InputMaybe<Scalars['MongoID']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  direct_hire?: InputMaybe<Scalars['Boolean']>;
  exemptStatus?: InputMaybe<Scalars['MongoID']>;
  filled_date?: InputMaybe<Scalars['Date']>;
  hiring_manager?: InputMaybe<Scalars['MongoID']>;
  job_desc_finalized?: InputMaybe<Scalars['Date']>;
  job_desc_posted?: InputMaybe<Scalars['Date']>;
  job_desc_received?: InputMaybe<Scalars['Date']>;
  keywords?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  numberOfOpenings?: InputMaybe<Scalars['Float']>;
  pricing?: InputMaybe<PositionPricingInput>;
  priority?: InputMaybe<Scalars['MongoID']>;
  program_manager?: InputMaybe<Scalars['MongoID']>;
  required_clearance?: InputMaybe<Scalars['MongoID']>;
  salary?: InputMaybe<PositionSalaryInput>;
  status?: InputMaybe<Scalars['MongoID']>;
  temp_to_perm?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['MongoID']>;
  workSetting?: InputMaybe<Scalars['MongoID']>;
};

export type CreateOnePositionPayload = {
  __typename?: 'CreateOnePositionPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Position>;
  /** Document ID */
  recordId?: Maybe<Scalars['Int']>;
};

export type CreateOneReportBuilderReportInput = {
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  deletedBy?: InputMaybe<Scalars['MongoID']>;
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  model?: InputMaybe<EnumReportBuilderReportModel>;
  query: Scalars['JSON'];
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['MongoID']>;
};

export type CreateOneReportBuilderReportPayload = {
  __typename?: 'CreateOneReportBuilderReportPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<ReportBuilderReport>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type CreateOneRoleInput = {
  createdAt?: InputMaybe<Scalars['Date']>;
  defaultPage?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type CreateOneRolePayload = {
  __typename?: 'CreateOneRolePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Role>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type CreateOneStaffingAgencyPocInput = {
  address?: InputMaybe<StaffingAgencyPocAddressInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  deletedBy?: InputMaybe<Scalars['MongoID']>;
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  staffingAgency?: InputMaybe<Scalars['MongoID']>;
  timezone?: InputMaybe<Scalars['MongoID']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['MongoID']>;
};

export type CreateOneStaffingAgencyPocPayload = {
  __typename?: 'CreateOneStaffingAgencyPocPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<StaffingAgencyPoc>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type CreateOneUserInput = {
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['JSON']>;
  defaultPage?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  lastActive?: InputMaybe<Scalars['Date']>;
  name?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['JSON']>;
};

export type CreateOneUserPayload = {
  __typename?: 'CreateOneUserPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<User>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type DeleteByIdAttachmentPayload = {
  __typename?: 'DeleteByIdAttachmentPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Deleted document */
  record?: Maybe<Attachment>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type DeleteByIdCandidatePayload = {
  __typename?: 'DeleteByIdCandidatePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Deleted document */
  record?: Maybe<Candidate>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type DeleteByIdContractInterviewerPayload = {
  __typename?: 'DeleteByIdContractInterviewerPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Deleted document */
  record?: Maybe<ContractInterviewer>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type DeleteByIdDistributionPayload = {
  __typename?: 'DeleteByIdDistributionPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Deleted document */
  record?: Maybe<Distribution>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type DeleteByIdReportBuilderReportPayload = {
  __typename?: 'DeleteByIdReportBuilderReportPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Deleted document */
  record?: Maybe<ReportBuilderReport>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type DeleteByIdStaffingAgencyPocPayload = {
  __typename?: 'DeleteByIdStaffingAgencyPocPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Deleted document */
  record?: Maybe<StaffingAgencyPoc>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type DevUpdateTracker = {
  __typename?: 'DevUpdateTracker';
  _id: Scalars['MongoID'];
  copyErrors?: Maybe<Array<Maybe<Scalars['String']>>>;
  createdAt?: Maybe<Scalars['Date']>;
  database?: Maybe<DevUpdateTrackerDatabase>;
  s3?: Maybe<DevUpdateTrackerS3>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type DevUpdateTrackerDatabase = {
  __typename?: 'DevUpdateTrackerDatabase';
  collections?: Maybe<Array<Maybe<DevUpdateTrackerDatabaseCollections>>>;
  copied?: Maybe<Scalars['Float']>;
  from?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Float']>;
};

export type DevUpdateTrackerDatabaseCollections = {
  __typename?: 'DevUpdateTrackerDatabaseCollections';
  _id?: Maybe<Scalars['MongoID']>;
  indexes?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  itemCount?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type DevUpdateTrackerS3 = {
  __typename?: 'DevUpdateTrackerS3';
  copied?: Maybe<Scalars['Float']>;
  from?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Float']>;
};

export type Distribution = {
  __typename?: 'Distribution';
  _category?: Maybe<Distribution_Category>;
  _createdBy?: Maybe<User>;
  _id: Scalars['MongoID'];
  _position?: Maybe<Position>;
  _subcategory?: Maybe<Distribution_Subcategory>;
  _updatedBy?: Maybe<User>;
  attachments_count?: Maybe<Scalars['Int']>;
  /** Number of Candidates */
  candidate_count?: Maybe<Scalars['Int']>;
  category?: Maybe<Scalars['MongoID']>;
  createdAt?: Maybe<Scalars['Date']>;
  createdBy?: Maybe<Scalars['MongoID']>;
  date_posted?: Maybe<Scalars['Date']>;
  deleted?: Maybe<Scalars['Boolean']>;
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['MongoID']>;
  notes?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Float']>;
  subcategory?: Maybe<Scalars['MongoID']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<Scalars['MongoID']>;
};

export type DistributionSubcategoryStatus = {
  __typename?: 'DistributionSubcategoryStatus';
  _createdBy?: Maybe<User>;
  _id: Scalars['MongoID'];
  _updatedBy?: Maybe<User>;
  archived?: Maybe<Scalars['Boolean']>;
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  createdBy?: Maybe<Scalars['MongoID']>;
  deleted?: Maybe<Scalars['Boolean']>;
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['MongoID']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<Scalars['MongoID']>;
};

export type Distribution_Category = {
  __typename?: 'Distribution_Category';
  _createdBy?: Maybe<User>;
  _id: Scalars['MongoID'];
  _updatedBy?: Maybe<User>;
  archived?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['Date']>;
  createdBy?: Maybe<Scalars['MongoID']>;
  deleted?: Maybe<Scalars['Boolean']>;
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['MongoID']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<Scalars['MongoID']>;
};

export type Distribution_Subcategory = {
  __typename?: 'Distribution_Subcategory';
  _category?: Maybe<Distribution_Category>;
  _createdBy?: Maybe<User>;
  _id: Scalars['MongoID'];
  _status?: Maybe<DistributionSubcategoryStatus>;
  _updatedBy?: Maybe<User>;
  category?: Maybe<Scalars['MongoID']>;
  createdAt?: Maybe<Scalars['Date']>;
  createdBy?: Maybe<Scalars['MongoID']>;
  deleted?: Maybe<Scalars['Boolean']>;
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['MongoID']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  position_count?: Maybe<Scalars['Int']>;
  staffingAgency?: Maybe<Distribution_SubcategoryStaffingAgency>;
  status?: Maybe<Scalars['MongoID']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<Scalars['MongoID']>;
};

export type Distribution_SubcategoryStaffingAgency = {
  __typename?: 'Distribution_SubcategoryStaffingAgency';
  _clearedFacility?: Maybe<StaffingAgencyClearedFacility>;
  benefits?: Maybe<Distribution_SubcategoryStaffingAgencyBenefits>;
  clearedFacility?: Maybe<Scalars['MongoID']>;
  msa?: Maybe<Distribution_SubcategoryStaffingAgencyMsa>;
  remit?: Maybe<Distribution_SubcategoryStaffingAgencyRemit>;
  sdvosb?: Maybe<Scalars['Boolean']>;
};

export type Distribution_SubcategoryStaffingAgencyBenefits = {
  __typename?: 'Distribution_SubcategoryStaffingAgencyBenefits';
  _holidays: Array<StaffingAgencyHoliday>;
  healthBenefits?: Maybe<Scalars['Boolean']>;
  holidays?: Maybe<Array<Maybe<Scalars['MongoID']>>>;
  payrollRunTime?: Maybe<Scalars['String']>;
  pto?: Maybe<Scalars['String']>;
};


export type Distribution_SubcategoryStaffingAgencyBenefits_HolidaysArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyStaffingAgencyHolidayInput>;
};

export type Distribution_SubcategoryStaffingAgencyBenefitsInput = {
  healthBenefits?: InputMaybe<Scalars['Boolean']>;
  holidays?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  payrollRunTime?: InputMaybe<Scalars['String']>;
  pto?: InputMaybe<Scalars['String']>;
};

export type Distribution_SubcategoryStaffingAgencyInput = {
  benefits?: InputMaybe<Distribution_SubcategoryStaffingAgencyBenefitsInput>;
  clearedFacility?: InputMaybe<Scalars['MongoID']>;
  msa?: InputMaybe<Distribution_SubcategoryStaffingAgencyMsaInput>;
  remit?: InputMaybe<Distribution_SubcategoryStaffingAgencyRemitInput>;
  sdvosb?: InputMaybe<Scalars['Boolean']>;
};

export type Distribution_SubcategoryStaffingAgencyMsa = {
  __typename?: 'Distribution_SubcategoryStaffingAgencyMsa';
  conversionFees?: Maybe<Scalars['String']>;
  conversionTimeframe?: Maybe<Scalars['String']>;
  dateSigned?: Maybe<Scalars['Date']>;
  dhAvailable?: Maybe<Scalars['Boolean']>;
  dhWarranty?: Maybe<Scalars['String']>;
  nonSolicitationDuration?: Maybe<Scalars['String']>;
};

export type Distribution_SubcategoryStaffingAgencyMsaInput = {
  conversionFees?: InputMaybe<Scalars['String']>;
  conversionTimeframe?: InputMaybe<Scalars['String']>;
  dateSigned?: InputMaybe<Scalars['Date']>;
  dhAvailable?: InputMaybe<Scalars['Boolean']>;
  dhWarranty?: InputMaybe<Scalars['String']>;
  nonSolicitationDuration?: InputMaybe<Scalars['String']>;
};

export type Distribution_SubcategoryStaffingAgencyRemit = {
  __typename?: 'Distribution_SubcategoryStaffingAgencyRemit';
  address?: Maybe<Distribution_SubcategoryStaffingAgencyRemitAddress>;
  name?: Maybe<Scalars['String']>;
  paymentDetails?: Maybe<Scalars['String']>;
  paymentTerms?: Maybe<Scalars['String']>;
};

export type Distribution_SubcategoryStaffingAgencyRemitAddress = {
  __typename?: 'Distribution_SubcategoryStaffingAgencyRemitAddress';
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type Distribution_SubcategoryStaffingAgencyRemitAddressInput = {
  city?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type Distribution_SubcategoryStaffingAgencyRemitInput = {
  address?: InputMaybe<Distribution_SubcategoryStaffingAgencyRemitAddressInput>;
  name?: InputMaybe<Scalars['String']>;
  paymentDetails?: InputMaybe<Scalars['String']>;
  paymentTerms?: InputMaybe<Scalars['String']>;
};

export type Eeoc = {
  __typename?: 'Eeoc';
  _candidate?: Maybe<Candidate>;
  _createdBy?: Maybe<User>;
  _id: Scalars['MongoID'];
  _updatedBy?: Maybe<User>;
  candidate?: Maybe<Scalars['MongoID']>;
  createdAt?: Maybe<Scalars['Date']>;
  createdBy?: Maybe<Scalars['JSON']>;
  dateApplied?: Maybe<Scalars['Date']>;
  documentData?: Maybe<Scalars['JSON']>;
  documents?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  envelope?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  signedOn?: Maybe<Scalars['Date']>;
  status?: Maybe<EnumEeocStatus>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<Scalars['JSON']>;
  voidReason?: Maybe<Scalars['String']>;
  voidedOn?: Maybe<Scalars['Date']>;
};

export enum EnumEeocStatus {
  Sent = 'sent',
  Signed = 'signed',
  Voided = 'voided'
}

export enum EnumReportBuilderReportModel {
  Candidate = 'candidate',
  Distribution = 'distribution',
  Position = 'position'
}

export type ErrorInterface = {
  /** Generic error message */
  message?: Maybe<Scalars['String']>;
};

export type FilterFindManyAttachmentCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyAttachmentInput = {
  AND?: InputMaybe<Array<FilterFindManyAttachmentInput>>;
  OR?: InputMaybe<Array<FilterFindManyAttachmentInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyAttachmentOperatorsInput>;
  additional?: InputMaybe<Scalars['JSON']>;
  contentType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  deletedBy?: InputMaybe<Scalars['MongoID']>;
  filename?: InputMaybe<Scalars['String']>;
  link?: InputMaybe<Scalars['JSON']>;
  model?: InputMaybe<Scalars['String']>;
  s3?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  subtype?: InputMaybe<Scalars['MongoID']>;
  type?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['MongoID']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyAttachmentOperatorsInput = {
  _id?: InputMaybe<FilterFindManyAttachment_IdOperatorsInput>;
  createdAt?: InputMaybe<FilterFindManyAttachmentCreatedAtOperatorsInput>;
};

export type FilterFindManyAttachment_SubtypeInput = {
  AND?: InputMaybe<Array<FilterFindManyAttachment_SubtypeInput>>;
  OR?: InputMaybe<Array<FilterFindManyAttachment_SubtypeInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyAttachment_SubtypeOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type FilterFindManyAttachment_SubtypeNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyAttachment_SubtypeOperatorsInput = {
  _id?: InputMaybe<FilterFindManyAttachment_Subtype_IdOperatorsInput>;
  name?: InputMaybe<FilterFindManyAttachment_SubtypeNameOperatorsInput>;
};

export type FilterFindManyAttachment_Subtype_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyAttachment_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyCandidateAddressInput = {
  city?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyCandidateBill_RateInput = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyCandidateCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyCandidateExhibitInput = {
  contracts_approved?: InputMaybe<Scalars['Date']>;
  extended?: InputMaybe<Scalars['Date']>;
  hm_approved?: InputMaybe<Scalars['Date']>;
  pmo_approved?: InputMaybe<Scalars['Date']>;
  sent_for_review?: InputMaybe<Scalars['Date']>;
  signed?: InputMaybe<Scalars['Date']>;
};

export type FilterFindManyCandidateInput = {
  AND?: InputMaybe<Array<FilterFindManyCandidateInput>>;
  OR?: InputMaybe<Array<FilterFindManyCandidateInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyCandidateOperatorsInput>;
  address?: InputMaybe<FilterFindManyCandidateAddressInput>;
  bill_rate?: InputMaybe<FilterFindManyCandidateBill_RateInput>;
  clearance?: InputMaybe<Scalars['MongoID']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  deletedBy?: InputMaybe<Scalars['MongoID']>;
  distribution?: InputMaybe<Scalars['MongoID']>;
  email?: InputMaybe<Scalars['String']>;
  exhibit?: InputMaybe<FilterFindManyCandidateExhibitInput>;
  firstLastName?: InputMaybe<Scalars['String']>;
  lastFirstName?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<FilterFindManyCandidateNameInput>;
  nda_signed?: InputMaybe<FilterFindManyCandidateNda_SignedInput>;
  notes?: InputMaybe<Scalars['String']>;
  offer_letter?: InputMaybe<FilterFindManyCandidateOffer_LetterInput>;
  phone?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Float']>;
  rank?: InputMaybe<Scalars['MongoID']>;
  reapply?: InputMaybe<Scalars['Boolean']>;
  received_on?: InputMaybe<Scalars['Date']>;
  rejection_date?: InputMaybe<Scalars['Date']>;
  resume?: InputMaybe<FilterFindManyCandidateResumeInput>;
  round_1?: InputMaybe<Scalars['Date']>;
  round_2?: InputMaybe<Scalars['Date']>;
  round_3?: InputMaybe<Scalars['Date']>;
  salary?: InputMaybe<FilterFindManyCandidateSalaryInput>;
  status?: InputMaybe<Scalars['MongoID']>;
  substatus?: InputMaybe<Scalars['MongoID']>;
  type?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['MongoID']>;
};

export type FilterFindManyCandidateNameFirstOperatorsInput = {
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyCandidateNameInput = {
  first?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyCandidateNameLastOperatorsInput = {
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyCandidateNameOperatorsInput = {
  first?: InputMaybe<FilterFindManyCandidateNameFirstOperatorsInput>;
  last?: InputMaybe<FilterFindManyCandidateNameLastOperatorsInput>;
};

export type FilterFindManyCandidateNda_SignedInput = {
  candidate?: InputMaybe<Scalars['Date']>;
  staffing_agency?: InputMaybe<Scalars['Date']>;
};

export type FilterFindManyCandidateOffer_LetterInput = {
  approved?: InputMaybe<Scalars['Date']>;
  extended?: InputMaybe<Scalars['Date']>;
  signed?: InputMaybe<Scalars['Date']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyCandidateOperatorsInput = {
  _id?: InputMaybe<FilterFindManyCandidate_IdOperatorsInput>;
  createdAt?: InputMaybe<FilterFindManyCandidateCreatedAtOperatorsInput>;
  name?: InputMaybe<FilterFindManyCandidateNameOperatorsInput>;
};

export type FilterFindManyCandidateResumeInput = {
  reviewed?: InputMaybe<Scalars['Date']>;
  reviewed_by?: InputMaybe<Scalars['MongoID']>;
  sent?: InputMaybe<Scalars['Date']>;
};

export type FilterFindManyCandidateSalaryInput = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyCandidate_RankInput = {
  AND?: InputMaybe<Array<FilterFindManyCandidate_RankInput>>;
  OR?: InputMaybe<Array<FilterFindManyCandidate_RankInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyCandidate_RankOperatorsInput>;
  archived?: InputMaybe<Scalars['Boolean']>;
  color?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  deletedBy?: InputMaybe<Scalars['MongoID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['MongoID']>;
};

export type FilterFindManyCandidate_RankNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyCandidate_RankOperatorsInput = {
  _id?: InputMaybe<FilterFindManyCandidate_Rank_IdOperatorsInput>;
  name?: InputMaybe<FilterFindManyCandidate_RankNameOperatorsInput>;
  order?: InputMaybe<FilterFindManyCandidate_RankOrderOperatorsInput>;
};

export type FilterFindManyCandidate_RankOrderOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyCandidate_Rank_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyCandidate_StatusInput = {
  AND?: InputMaybe<Array<FilterFindManyCandidate_StatusInput>>;
  OR?: InputMaybe<Array<FilterFindManyCandidate_StatusInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyCandidate_StatusOperatorsInput>;
  archived?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  deletedBy?: InputMaybe<Scalars['MongoID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['MongoID']>;
};

export type FilterFindManyCandidate_StatusNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyCandidate_StatusOperatorsInput = {
  _id?: InputMaybe<FilterFindManyCandidate_Status_IdOperatorsInput>;
  name?: InputMaybe<FilterFindManyCandidate_StatusNameOperatorsInput>;
  order?: InputMaybe<FilterFindManyCandidate_StatusOrderOperatorsInput>;
};

export type FilterFindManyCandidate_StatusOrderOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyCandidate_Status_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyCandidate_SubstatusInput = {
  AND?: InputMaybe<Array<FilterFindManyCandidate_SubstatusInput>>;
  OR?: InputMaybe<Array<FilterFindManyCandidate_SubstatusInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyCandidate_SubstatusOperatorsInput>;
  archived?: InputMaybe<Scalars['Boolean']>;
  color?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  deletedBy?: InputMaybe<Scalars['MongoID']>;
  name?: InputMaybe<Scalars['String']>;
  oldOrder?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['JSON']>;
  status?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['MongoID']>;
};

export type FilterFindManyCandidate_SubstatusNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyCandidate_SubstatusOldOrderOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyCandidate_SubstatusOperatorsInput = {
  _id?: InputMaybe<FilterFindManyCandidate_Substatus_IdOperatorsInput>;
  name?: InputMaybe<FilterFindManyCandidate_SubstatusNameOperatorsInput>;
  oldOrder?: InputMaybe<FilterFindManyCandidate_SubstatusOldOrderOperatorsInput>;
  order?: InputMaybe<FilterFindManyCandidate_SubstatusOrderOperatorsInput>;
};

export type FilterFindManyCandidate_SubstatusOrderOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['JSON']>;
  gte?: InputMaybe<Scalars['JSON']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  lt?: InputMaybe<Scalars['JSON']>;
  lte?: InputMaybe<Scalars['JSON']>;
  ne?: InputMaybe<Scalars['JSON']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type FilterFindManyCandidate_Substatus_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyCandidate_TypeInput = {
  AND?: InputMaybe<Array<FilterFindManyCandidate_TypeInput>>;
  OR?: InputMaybe<Array<FilterFindManyCandidate_TypeInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyCandidate_TypeOperatorsInput>;
  archived?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  deletedBy?: InputMaybe<Scalars['MongoID']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['MongoID']>;
};

export type FilterFindManyCandidate_TypeNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyCandidate_TypeOperatorsInput = {
  _id?: InputMaybe<FilterFindManyCandidate_Type_IdOperatorsInput>;
  name?: InputMaybe<FilterFindManyCandidate_TypeNameOperatorsInput>;
};

export type FilterFindManyCandidate_Type_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyCandidate_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyCat_ContractAbbreviationOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyCat_ContractCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyCat_ContractInput = {
  AND?: InputMaybe<Array<FilterFindManyCat_ContractInput>>;
  OR?: InputMaybe<Array<FilterFindManyCat_ContractInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyCat_ContractOperatorsInput>;
  abbreviation?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  onboarding?: InputMaybe<FilterFindManyCat_ContractOnboardingInput>;
  pop?: InputMaybe<FilterFindManyCat_ContractPopInput>;
  portfolio_manager?: InputMaybe<Scalars['MongoID']>;
  primary_address?: InputMaybe<FilterFindManyCat_ContractPrimary_AddressInput>;
  prime?: InputMaybe<Scalars['Boolean']>;
  program_manager?: InputMaybe<Scalars['MongoID']>;
  status?: InputMaybe<Scalars['MongoID']>;
  subcontractor?: InputMaybe<Scalars['String']>;
  teamSize?: InputMaybe<Scalars['Float']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['MongoID']>;
  vehicle?: InputMaybe<Scalars['MongoID']>;
};

export type FilterFindManyCat_ContractNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyCat_ContractOnboardingInput = {
  biProcessTimeframe?: InputMaybe<Scalars['String']>;
  clearanceReqs?: InputMaybe<Scalars['Boolean']>;
  days?: InputMaybe<Scalars['String']>;
  gfeProvided?: InputMaybe<Scalars['Boolean']>;
  imcEquipment?: InputMaybe<Scalars['Boolean']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyCat_ContractOperatorsInput = {
  _id?: InputMaybe<FilterFindManyCat_Contract_IdOperatorsInput>;
  abbreviation?: InputMaybe<FilterFindManyCat_ContractAbbreviationOperatorsInput>;
  createdAt?: InputMaybe<FilterFindManyCat_ContractCreatedAtOperatorsInput>;
  name?: InputMaybe<FilterFindManyCat_ContractNameOperatorsInput>;
};

export type FilterFindManyCat_ContractPopBaseInput = {
  end?: InputMaybe<Scalars['Date']>;
  start?: InputMaybe<Scalars['Date']>;
};

export type FilterFindManyCat_ContractPopExtensionsInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  end?: InputMaybe<Scalars['Date']>;
  start?: InputMaybe<Scalars['Date']>;
};

export type FilterFindManyCat_ContractPopInput = {
  base?: InputMaybe<FilterFindManyCat_ContractPopBaseInput>;
  extensions?: InputMaybe<Array<InputMaybe<FilterFindManyCat_ContractPopExtensionsInput>>>;
  options?: InputMaybe<Array<InputMaybe<FilterFindManyCat_ContractPopOptionsInput>>>;
  status?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyCat_ContractPopOptionsInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  end?: InputMaybe<Scalars['Date']>;
  start?: InputMaybe<Scalars['Date']>;
};

export type FilterFindManyCat_ContractPrimary_AddressInput = {
  city?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyCat_Contract_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyClearanceInput = {
  AND?: InputMaybe<Array<FilterFindManyClearanceInput>>;
  OR?: InputMaybe<Array<FilterFindManyClearanceInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyClearanceOperatorsInput>;
  archived?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  deletedBy?: InputMaybe<Scalars['MongoID']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['MongoID']>;
};

export type FilterFindManyClearanceNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyClearanceOperatorsInput = {
  _id?: InputMaybe<FilterFindManyClearance_IdOperatorsInput>;
  name?: InputMaybe<FilterFindManyClearanceNameOperatorsInput>;
};

export type FilterFindManyClearance_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyContractInterviewerCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyContractInterviewerInput = {
  AND?: InputMaybe<Array<FilterFindManyContractInterviewerInput>>;
  OR?: InputMaybe<Array<FilterFindManyContractInterviewerInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyContractInterviewerOperatorsInput>;
  contract?: InputMaybe<Scalars['MongoID']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  deletedBy?: InputMaybe<Scalars['MongoID']>;
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['MongoID']>;
};

export type FilterFindManyContractInterviewerNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyContractInterviewerOperatorsInput = {
  _id?: InputMaybe<FilterFindManyContractInterviewer_IdOperatorsInput>;
  createdAt?: InputMaybe<FilterFindManyContractInterviewerCreatedAtOperatorsInput>;
  name?: InputMaybe<FilterFindManyContractInterviewerNameOperatorsInput>;
};

export type FilterFindManyContractInterviewer_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyContract_StatusInput = {
  AND?: InputMaybe<Array<FilterFindManyContract_StatusInput>>;
  OR?: InputMaybe<Array<FilterFindManyContract_StatusInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyContract_StatusOperatorsInput>;
  archived?: InputMaybe<Scalars['Boolean']>;
  color?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  deletedBy?: InputMaybe<Scalars['MongoID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['MongoID']>;
};

export type FilterFindManyContract_StatusNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyContract_StatusOperatorsInput = {
  _id?: InputMaybe<FilterFindManyContract_Status_IdOperatorsInput>;
  name?: InputMaybe<FilterFindManyContract_StatusNameOperatorsInput>;
  order?: InputMaybe<FilterFindManyContract_StatusOrderOperatorsInput>;
};

export type FilterFindManyContract_StatusOrderOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyContract_Status_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyContract_TypeInput = {
  AND?: InputMaybe<Array<FilterFindManyContract_TypeInput>>;
  OR?: InputMaybe<Array<FilterFindManyContract_TypeInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyContract_TypeOperatorsInput>;
  archived?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  deletedBy?: InputMaybe<Scalars['MongoID']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['MongoID']>;
};

export type FilterFindManyContract_TypeNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyContract_TypeOperatorsInput = {
  _id?: InputMaybe<FilterFindManyContract_Type_IdOperatorsInput>;
  name?: InputMaybe<FilterFindManyContract_TypeNameOperatorsInput>;
};

export type FilterFindManyContract_Type_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyContract_VehicleInput = {
  AND?: InputMaybe<Array<FilterFindManyContract_VehicleInput>>;
  OR?: InputMaybe<Array<FilterFindManyContract_VehicleInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyContract_VehicleOperatorsInput>;
  archived?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  deletedBy?: InputMaybe<Scalars['MongoID']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['MongoID']>;
};

export type FilterFindManyContract_VehicleNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyContract_VehicleOperatorsInput = {
  _id?: InputMaybe<FilterFindManyContract_Vehicle_IdOperatorsInput>;
  name?: InputMaybe<FilterFindManyContract_VehicleNameOperatorsInput>;
};

export type FilterFindManyContract_Vehicle_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyDevUpdateTrackerDatabaseCollectionsInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  indexes?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  itemCount?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyDevUpdateTrackerDatabaseInput = {
  collections?: InputMaybe<Array<InputMaybe<FilterFindManyDevUpdateTrackerDatabaseCollectionsInput>>>;
  copied?: InputMaybe<Scalars['Float']>;
  from?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
  total?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyDevUpdateTrackerInput = {
  AND?: InputMaybe<Array<FilterFindManyDevUpdateTrackerInput>>;
  OR?: InputMaybe<Array<FilterFindManyDevUpdateTrackerInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyDevUpdateTrackerOperatorsInput>;
  copyErrors?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAt?: InputMaybe<Scalars['Date']>;
  database?: InputMaybe<FilterFindManyDevUpdateTrackerDatabaseInput>;
  s3?: InputMaybe<FilterFindManyDevUpdateTrackerS3Input>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyDevUpdateTrackerOperatorsInput = {
  _id?: InputMaybe<FilterFindManyDevUpdateTracker_IdOperatorsInput>;
};

export type FilterFindManyDevUpdateTrackerS3Input = {
  copied?: InputMaybe<Scalars['Float']>;
  from?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
  total?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyDevUpdateTracker_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyDistributionInput = {
  AND?: InputMaybe<Array<FilterFindManyDistributionInput>>;
  OR?: InputMaybe<Array<FilterFindManyDistributionInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyDistributionOperatorsInput>;
  category?: InputMaybe<Scalars['MongoID']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  date_posted?: InputMaybe<Scalars['Date']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  deletedBy?: InputMaybe<Scalars['MongoID']>;
  notes?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Float']>;
  subcategory?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['MongoID']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyDistributionOperatorsInput = {
  _id?: InputMaybe<FilterFindManyDistribution_IdOperatorsInput>;
};

export type FilterFindManyDistributionSubcategoryStatusInput = {
  AND?: InputMaybe<Array<FilterFindManyDistributionSubcategoryStatusInput>>;
  OR?: InputMaybe<Array<FilterFindManyDistributionSubcategoryStatusInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyDistributionSubcategoryStatusOperatorsInput>;
  archived?: InputMaybe<Scalars['Boolean']>;
  color?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  deletedBy?: InputMaybe<Scalars['MongoID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['MongoID']>;
};

export type FilterFindManyDistributionSubcategoryStatusNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyDistributionSubcategoryStatusOperatorsInput = {
  _id?: InputMaybe<FilterFindManyDistributionSubcategoryStatus_IdOperatorsInput>;
  name?: InputMaybe<FilterFindManyDistributionSubcategoryStatusNameOperatorsInput>;
  order?: InputMaybe<FilterFindManyDistributionSubcategoryStatusOrderOperatorsInput>;
};

export type FilterFindManyDistributionSubcategoryStatusOrderOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyDistributionSubcategoryStatus_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyDistribution_CategoryInput = {
  AND?: InputMaybe<Array<FilterFindManyDistribution_CategoryInput>>;
  OR?: InputMaybe<Array<FilterFindManyDistribution_CategoryInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyDistribution_CategoryOperatorsInput>;
  archived?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  deletedBy?: InputMaybe<Scalars['MongoID']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['MongoID']>;
};

export type FilterFindManyDistribution_CategoryNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyDistribution_CategoryOperatorsInput = {
  _id?: InputMaybe<FilterFindManyDistribution_Category_IdOperatorsInput>;
  name?: InputMaybe<FilterFindManyDistribution_CategoryNameOperatorsInput>;
};

export type FilterFindManyDistribution_Category_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyDistribution_SubcategoryInput = {
  AND?: InputMaybe<Array<FilterFindManyDistribution_SubcategoryInput>>;
  OR?: InputMaybe<Array<FilterFindManyDistribution_SubcategoryInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyDistribution_SubcategoryOperatorsInput>;
  category?: InputMaybe<Scalars['MongoID']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  deletedBy?: InputMaybe<Scalars['MongoID']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  staffingAgency?: InputMaybe<FilterFindManyDistribution_SubcategoryStaffingAgencyInput>;
  status?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['MongoID']>;
};

export type FilterFindManyDistribution_SubcategoryNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyDistribution_SubcategoryOperatorsInput = {
  _id?: InputMaybe<FilterFindManyDistribution_Subcategory_IdOperatorsInput>;
  name?: InputMaybe<FilterFindManyDistribution_SubcategoryNameOperatorsInput>;
};

export type FilterFindManyDistribution_SubcategoryStaffingAgencyBenefitsInput = {
  healthBenefits?: InputMaybe<Scalars['Boolean']>;
  holidays?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  payrollRunTime?: InputMaybe<Scalars['String']>;
  pto?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyDistribution_SubcategoryStaffingAgencyInput = {
  benefits?: InputMaybe<FilterFindManyDistribution_SubcategoryStaffingAgencyBenefitsInput>;
  clearedFacility?: InputMaybe<Scalars['MongoID']>;
  msa?: InputMaybe<FilterFindManyDistribution_SubcategoryStaffingAgencyMsaInput>;
  remit?: InputMaybe<FilterFindManyDistribution_SubcategoryStaffingAgencyRemitInput>;
  sdvosb?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyDistribution_SubcategoryStaffingAgencyMsaInput = {
  conversionFees?: InputMaybe<Scalars['String']>;
  conversionTimeframe?: InputMaybe<Scalars['String']>;
  dateSigned?: InputMaybe<Scalars['Date']>;
  dhAvailable?: InputMaybe<Scalars['Boolean']>;
  dhWarranty?: InputMaybe<Scalars['String']>;
  nonSolicitationDuration?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyDistribution_SubcategoryStaffingAgencyRemitAddressInput = {
  city?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyDistribution_SubcategoryStaffingAgencyRemitInput = {
  address?: InputMaybe<FilterFindManyDistribution_SubcategoryStaffingAgencyRemitAddressInput>;
  name?: InputMaybe<Scalars['String']>;
  paymentDetails?: InputMaybe<Scalars['String']>;
  paymentTerms?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyDistribution_Subcategory_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyDistribution_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyEeocCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyEeocInput = {
  AND?: InputMaybe<Array<FilterFindManyEeocInput>>;
  OR?: InputMaybe<Array<FilterFindManyEeocInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyEeocOperatorsInput>;
  candidate?: InputMaybe<Scalars['MongoID']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['JSON']>;
  dateApplied?: InputMaybe<Scalars['Date']>;
  documentData?: InputMaybe<Scalars['JSON']>;
  documents?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  envelope?: InputMaybe<Scalars['String']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  signedOn?: InputMaybe<Scalars['Date']>;
  status?: InputMaybe<EnumEeocStatus>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['JSON']>;
  voidReason?: InputMaybe<Scalars['String']>;
  voidedOn?: InputMaybe<Scalars['Date']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyEeocOperatorsInput = {
  _id?: InputMaybe<FilterFindManyEeoc_IdOperatorsInput>;
  createdAt?: InputMaybe<FilterFindManyEeocCreatedAtOperatorsInput>;
};

export type FilterFindManyEeoc_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyHiring_ManagerInput = {
  AND?: InputMaybe<Array<FilterFindManyHiring_ManagerInput>>;
  OR?: InputMaybe<Array<FilterFindManyHiring_ManagerInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyHiring_ManagerOperatorsInput>;
  archived?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  deletedBy?: InputMaybe<Scalars['MongoID']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['MongoID']>;
};

export type FilterFindManyHiring_ManagerNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyHiring_ManagerOperatorsInput = {
  _id?: InputMaybe<FilterFindManyHiring_Manager_IdOperatorsInput>;
  name?: InputMaybe<FilterFindManyHiring_ManagerNameOperatorsInput>;
};

export type FilterFindManyHiring_Manager_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyLookupConfigFieldsComponentInput = {
  props?: InputMaybe<Scalars['JSON']>;
  type?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyLookupConfigFieldsInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  component?: InputMaybe<FilterFindManyLookupConfigFieldsComponentInput>;
  key?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyLookupConfigInput = {
  AND?: InputMaybe<Array<FilterFindManyLookupConfigInput>>;
  OR?: InputMaybe<Array<FilterFindManyLookupConfigInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyLookupConfigOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  fields?: InputMaybe<Array<InputMaybe<FilterFindManyLookupConfigFieldsInput>>>;
  model?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  permissionKey?: InputMaybe<Scalars['String']>;
  relationships?: InputMaybe<Array<InputMaybe<FilterFindManyLookupConfigRelationshipsInput>>>;
  sort?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Float']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyLookupConfigOperatorsInput = {
  _id?: InputMaybe<FilterFindManyLookupConfig_IdOperatorsInput>;
};

export type FilterFindManyLookupConfigRelationshipsInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  key?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<Scalars['String']>;
  link?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  sortKey?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyLookupConfig_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyPermissionInput = {
  AND?: InputMaybe<Array<FilterFindManyPermissionInput>>;
  OR?: InputMaybe<Array<FilterFindManyPermissionInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyPermissionOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  key?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyPermissionOperatorsInput = {
  _id?: InputMaybe<FilterFindManyPermission_IdOperatorsInput>;
};

export type FilterFindManyPermission_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyPortfolio_ManagerInput = {
  AND?: InputMaybe<Array<FilterFindManyPortfolio_ManagerInput>>;
  OR?: InputMaybe<Array<FilterFindManyPortfolio_ManagerInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyPortfolio_ManagerOperatorsInput>;
  archived?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  deletedBy?: InputMaybe<Scalars['MongoID']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['MongoID']>;
};

export type FilterFindManyPortfolio_ManagerNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyPortfolio_ManagerOperatorsInput = {
  _id?: InputMaybe<FilterFindManyPortfolio_Manager_IdOperatorsInput>;
  name?: InputMaybe<FilterFindManyPortfolio_ManagerNameOperatorsInput>;
};

export type FilterFindManyPortfolio_Manager_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyPositionBill_RateInput = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyPositionContractOperatorsInput = {
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyPositionContract_TypeOperatorsInput = {
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyPositionCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyPositionInput = {
  AND?: InputMaybe<Array<FilterFindManyPositionInput>>;
  OR?: InputMaybe<Array<FilterFindManyPositionInput>>;
  _id?: InputMaybe<Scalars['Int']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyPositionOperatorsInput>;
  backfill?: InputMaybe<Scalars['Boolean']>;
  bill_rate?: InputMaybe<FilterFindManyPositionBill_RateInput>;
  closed_date?: InputMaybe<Scalars['Date']>;
  contract?: InputMaybe<Scalars['MongoID']>;
  contract_type?: InputMaybe<Scalars['MongoID']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  direct_hire?: InputMaybe<Scalars['Boolean']>;
  exemptStatus?: InputMaybe<Scalars['MongoID']>;
  filled_date?: InputMaybe<Scalars['Date']>;
  hiring_manager?: InputMaybe<Scalars['MongoID']>;
  id?: InputMaybe<Scalars['String']>;
  job_desc_finalized?: InputMaybe<Scalars['Date']>;
  job_desc_posted?: InputMaybe<Scalars['Date']>;
  job_desc_received?: InputMaybe<Scalars['Date']>;
  keywords?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  numberOfOpenings?: InputMaybe<Scalars['Float']>;
  pricing?: InputMaybe<FilterFindManyPositionPricingInput>;
  priority?: InputMaybe<Scalars['MongoID']>;
  program_manager?: InputMaybe<Scalars['MongoID']>;
  required_clearance?: InputMaybe<Scalars['MongoID']>;
  salary?: InputMaybe<FilterFindManyPositionSalaryInput>;
  status?: InputMaybe<Scalars['MongoID']>;
  temp_to_perm?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['MongoID']>;
  workSetting?: InputMaybe<Scalars['MongoID']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyPositionOperatorsInput = {
  _id?: InputMaybe<FilterFindManyPosition_IdOperatorsInput>;
  contract?: InputMaybe<FilterFindManyPositionContractOperatorsInput>;
  contract_type?: InputMaybe<FilterFindManyPositionContract_TypeOperatorsInput>;
  createdAt?: InputMaybe<FilterFindManyPositionCreatedAtOperatorsInput>;
  status?: InputMaybe<FilterFindManyPositionStatusOperatorsInput>;
};

export type FilterFindManyPositionPricingInput = {
  received?: InputMaybe<Scalars['Date']>;
  requested?: InputMaybe<Scalars['Date']>;
};

export type FilterFindManyPositionSalaryInput = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyPositionStatusCategoryInput = {
  AND?: InputMaybe<Array<FilterFindManyPositionStatusCategoryInput>>;
  OR?: InputMaybe<Array<FilterFindManyPositionStatusCategoryInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyPositionStatusCategoryOperatorsInput>;
  archived?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  deletedBy?: InputMaybe<Scalars['MongoID']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['MongoID']>;
};

export type FilterFindManyPositionStatusCategoryNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyPositionStatusCategoryOperatorsInput = {
  _id?: InputMaybe<FilterFindManyPositionStatusCategory_IdOperatorsInput>;
  name?: InputMaybe<FilterFindManyPositionStatusCategoryNameOperatorsInput>;
};

export type FilterFindManyPositionStatusCategory_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyPositionStatusOperatorsInput = {
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyPositionWorkSettingInput = {
  AND?: InputMaybe<Array<FilterFindManyPositionWorkSettingInput>>;
  OR?: InputMaybe<Array<FilterFindManyPositionWorkSettingInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyPositionWorkSettingOperatorsInput>;
  archived?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  deletedBy?: InputMaybe<Scalars['MongoID']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['MongoID']>;
};

export type FilterFindManyPositionWorkSettingNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyPositionWorkSettingOperatorsInput = {
  _id?: InputMaybe<FilterFindManyPositionWorkSetting_IdOperatorsInput>;
  name?: InputMaybe<FilterFindManyPositionWorkSettingNameOperatorsInput>;
};

export type FilterFindManyPositionWorkSetting_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyPosition_Exempt_StatusInput = {
  AND?: InputMaybe<Array<FilterFindManyPosition_Exempt_StatusInput>>;
  OR?: InputMaybe<Array<FilterFindManyPosition_Exempt_StatusInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyPosition_Exempt_StatusOperatorsInput>;
  archived?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  deletedBy?: InputMaybe<Scalars['MongoID']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['MongoID']>;
};

export type FilterFindManyPosition_Exempt_StatusNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyPosition_Exempt_StatusOperatorsInput = {
  _id?: InputMaybe<FilterFindManyPosition_Exempt_Status_IdOperatorsInput>;
  name?: InputMaybe<FilterFindManyPosition_Exempt_StatusNameOperatorsInput>;
};

export type FilterFindManyPosition_Exempt_Status_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyPosition_PriorityInput = {
  AND?: InputMaybe<Array<FilterFindManyPosition_PriorityInput>>;
  OR?: InputMaybe<Array<FilterFindManyPosition_PriorityInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyPosition_PriorityOperatorsInput>;
  archived?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  deletedBy?: InputMaybe<Scalars['MongoID']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['MongoID']>;
};

export type FilterFindManyPosition_PriorityNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyPosition_PriorityOperatorsInput = {
  _id?: InputMaybe<FilterFindManyPosition_Priority_IdOperatorsInput>;
  name?: InputMaybe<FilterFindManyPosition_PriorityNameOperatorsInput>;
};

export type FilterFindManyPosition_Priority_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyPosition_StatusInput = {
  AND?: InputMaybe<Array<FilterFindManyPosition_StatusInput>>;
  OR?: InputMaybe<Array<FilterFindManyPosition_StatusInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyPosition_StatusOperatorsInput>;
  archived?: InputMaybe<Scalars['Boolean']>;
  category?: InputMaybe<Scalars['MongoID']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  deletedBy?: InputMaybe<Scalars['MongoID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['MongoID']>;
};

export type FilterFindManyPosition_StatusNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyPosition_StatusOperatorsInput = {
  _id?: InputMaybe<FilterFindManyPosition_Status_IdOperatorsInput>;
  name?: InputMaybe<FilterFindManyPosition_StatusNameOperatorsInput>;
  order?: InputMaybe<FilterFindManyPosition_StatusOrderOperatorsInput>;
};

export type FilterFindManyPosition_StatusOrderOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyPosition_Status_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyPosition_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  ne?: InputMaybe<Scalars['Int']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type FilterFindManyProgram_ManagerInput = {
  AND?: InputMaybe<Array<FilterFindManyProgram_ManagerInput>>;
  OR?: InputMaybe<Array<FilterFindManyProgram_ManagerInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyProgram_ManagerOperatorsInput>;
  archived?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  deletedBy?: InputMaybe<Scalars['MongoID']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['MongoID']>;
};

export type FilterFindManyProgram_ManagerNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyProgram_ManagerOperatorsInput = {
  _id?: InputMaybe<FilterFindManyProgram_Manager_IdOperatorsInput>;
  name?: InputMaybe<FilterFindManyProgram_ManagerNameOperatorsInput>;
};

export type FilterFindManyProgram_Manager_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyReportBuilderReportInput = {
  AND?: InputMaybe<Array<FilterFindManyReportBuilderReportInput>>;
  OR?: InputMaybe<Array<FilterFindManyReportBuilderReportInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyReportBuilderReportOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  deletedBy?: InputMaybe<Scalars['MongoID']>;
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  model?: InputMaybe<EnumReportBuilderReportModel>;
  query?: InputMaybe<Scalars['JSON']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['MongoID']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyReportBuilderReportOperatorsInput = {
  _id?: InputMaybe<FilterFindManyReportBuilderReport_IdOperatorsInput>;
};

export type FilterFindManyReportBuilderReport_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyRoleInput = {
  AND?: InputMaybe<Array<FilterFindManyRoleInput>>;
  OR?: InputMaybe<Array<FilterFindManyRoleInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyRoleOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  defaultPage?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyRoleOperatorsInput = {
  _id?: InputMaybe<FilterFindManyRole_IdOperatorsInput>;
};

export type FilterFindManyRole_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyStaffingAgencyClearedFacilityInput = {
  AND?: InputMaybe<Array<FilterFindManyStaffingAgencyClearedFacilityInput>>;
  OR?: InputMaybe<Array<FilterFindManyStaffingAgencyClearedFacilityInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyStaffingAgencyClearedFacilityOperatorsInput>;
  archived?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  deletedBy?: InputMaybe<Scalars['MongoID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Float']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['MongoID']>;
};

export type FilterFindManyStaffingAgencyClearedFacilityNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyStaffingAgencyClearedFacilityOperatorsInput = {
  _id?: InputMaybe<FilterFindManyStaffingAgencyClearedFacility_IdOperatorsInput>;
  name?: InputMaybe<FilterFindManyStaffingAgencyClearedFacilityNameOperatorsInput>;
  order?: InputMaybe<FilterFindManyStaffingAgencyClearedFacilityOrderOperatorsInput>;
};

export type FilterFindManyStaffingAgencyClearedFacilityOrderOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyStaffingAgencyClearedFacility_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyStaffingAgencyHolidayInput = {
  AND?: InputMaybe<Array<FilterFindManyStaffingAgencyHolidayInput>>;
  OR?: InputMaybe<Array<FilterFindManyStaffingAgencyHolidayInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyStaffingAgencyHolidayOperatorsInput>;
  archived?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  deletedBy?: InputMaybe<Scalars['MongoID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Float']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['MongoID']>;
};

export type FilterFindManyStaffingAgencyHolidayNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyStaffingAgencyHolidayOperatorsInput = {
  _id?: InputMaybe<FilterFindManyStaffingAgencyHoliday_IdOperatorsInput>;
  name?: InputMaybe<FilterFindManyStaffingAgencyHolidayNameOperatorsInput>;
  order?: InputMaybe<FilterFindManyStaffingAgencyHolidayOrderOperatorsInput>;
};

export type FilterFindManyStaffingAgencyHolidayOrderOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyStaffingAgencyHoliday_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyStaffingAgencyPocAddressInput = {
  city?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyStaffingAgencyPocCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyStaffingAgencyPocInput = {
  AND?: InputMaybe<Array<FilterFindManyStaffingAgencyPocInput>>;
  OR?: InputMaybe<Array<FilterFindManyStaffingAgencyPocInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyStaffingAgencyPocOperatorsInput>;
  address?: InputMaybe<FilterFindManyStaffingAgencyPocAddressInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  deletedBy?: InputMaybe<Scalars['MongoID']>;
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  staffingAgency?: InputMaybe<Scalars['MongoID']>;
  timezone?: InputMaybe<Scalars['MongoID']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['MongoID']>;
};

export type FilterFindManyStaffingAgencyPocNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyStaffingAgencyPocOperatorsInput = {
  _id?: InputMaybe<FilterFindManyStaffingAgencyPoc_IdOperatorsInput>;
  createdAt?: InputMaybe<FilterFindManyStaffingAgencyPocCreatedAtOperatorsInput>;
  name?: InputMaybe<FilterFindManyStaffingAgencyPocNameOperatorsInput>;
};

export type FilterFindManyStaffingAgencyPocTypeInput = {
  AND?: InputMaybe<Array<FilterFindManyStaffingAgencyPocTypeInput>>;
  OR?: InputMaybe<Array<FilterFindManyStaffingAgencyPocTypeInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyStaffingAgencyPocTypeOperatorsInput>;
  archived?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  deletedBy?: InputMaybe<Scalars['MongoID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Float']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['MongoID']>;
};

export type FilterFindManyStaffingAgencyPocTypeNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyStaffingAgencyPocTypeOperatorsInput = {
  _id?: InputMaybe<FilterFindManyStaffingAgencyPocType_IdOperatorsInput>;
  name?: InputMaybe<FilterFindManyStaffingAgencyPocTypeNameOperatorsInput>;
  order?: InputMaybe<FilterFindManyStaffingAgencyPocTypeOrderOperatorsInput>;
};

export type FilterFindManyStaffingAgencyPocTypeOrderOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyStaffingAgencyPocType_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyStaffingAgencyPoc_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyTimezoneAbbreviationOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyTimezoneInput = {
  AND?: InputMaybe<Array<FilterFindManyTimezoneInput>>;
  OR?: InputMaybe<Array<FilterFindManyTimezoneInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyTimezoneOperatorsInput>;
  abbreviation?: InputMaybe<Scalars['String']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  deletedBy?: InputMaybe<Scalars['MongoID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Float']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['MongoID']>;
};

export type FilterFindManyTimezoneNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyTimezoneOperatorsInput = {
  _id?: InputMaybe<FilterFindManyTimezone_IdOperatorsInput>;
  abbreviation?: InputMaybe<FilterFindManyTimezoneAbbreviationOperatorsInput>;
  name?: InputMaybe<FilterFindManyTimezoneNameOperatorsInput>;
  order?: InputMaybe<FilterFindManyTimezoneOrderOperatorsInput>;
};

export type FilterFindManyTimezoneOrderOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyTimezone_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyUserInput = {
  AND?: InputMaybe<Array<FilterFindManyUserInput>>;
  OR?: InputMaybe<Array<FilterFindManyUserInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyUserOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['JSON']>;
  defaultPage?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  lastActive?: InputMaybe<Scalars['Date']>;
  name?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['JSON']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyUserOperatorsInput = {
  _id?: InputMaybe<FilterFindManyUser_IdOperatorsInput>;
};

export type FilterFindManyUser_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindOnePermissionInput = {
  AND?: InputMaybe<Array<FilterFindOnePermissionInput>>;
  OR?: InputMaybe<Array<FilterFindOnePermissionInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOnePermissionOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  key?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOnePermissionOperatorsInput = {
  _id?: InputMaybe<FilterFindOnePermission_IdOperatorsInput>;
};

export type FilterFindOnePermission_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindOneRoleInput = {
  AND?: InputMaybe<Array<FilterFindOneRoleInput>>;
  OR?: InputMaybe<Array<FilterFindOneRoleInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneRoleOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  defaultPage?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneRoleOperatorsInput = {
  _id?: InputMaybe<FilterFindOneRole_IdOperatorsInput>;
};

export type FilterFindOneRole_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindOneUserInput = {
  AND?: InputMaybe<Array<FilterFindOneUserInput>>;
  OR?: InputMaybe<Array<FilterFindOneUserInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneUserOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['JSON']>;
  defaultPage?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  lastActive?: InputMaybe<Scalars['Date']>;
  name?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['JSON']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneUserOperatorsInput = {
  _id?: InputMaybe<FilterFindOneUser_IdOperatorsInput>;
};

export type FilterFindOneUser_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterUpdateManyPermissionInput = {
  AND?: InputMaybe<Array<FilterUpdateManyPermissionInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyPermissionInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyPermissionOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  key?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyPermissionOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyPermission_IdOperatorsInput>;
};

export type FilterUpdateManyPermission_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterUpdateManyRoleInput = {
  AND?: InputMaybe<Array<FilterUpdateManyRoleInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyRoleInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyRoleOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  defaultPage?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyRoleOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyRole_IdOperatorsInput>;
};

export type FilterUpdateManyRole_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterUpdateManyUserInput = {
  AND?: InputMaybe<Array<FilterUpdateManyUserInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyUserInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyUserOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['JSON']>;
  defaultPage?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  lastActive?: InputMaybe<Scalars['Date']>;
  name?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['JSON']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyUserOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyUser_IdOperatorsInput>;
};

export type FilterUpdateManyUser_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type GlobalSearchFilterArgs = {
  search?: InputMaybe<Scalars['String']>;
};

export type Hiring_Manager = {
  __typename?: 'Hiring_Manager';
  _createdBy?: Maybe<User>;
  _id: Scalars['MongoID'];
  _updatedBy?: Maybe<User>;
  archived?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['Date']>;
  createdBy?: Maybe<Scalars['MongoID']>;
  deleted?: Maybe<Scalars['Boolean']>;
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['MongoID']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<Scalars['MongoID']>;
};

export type LookupConfig = {
  __typename?: 'LookupConfig';
  _id: Scalars['String'];
  createdAt?: Maybe<Scalars['Date']>;
  fields?: Maybe<Array<Maybe<LookupConfigFields>>>;
  model?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  optionsCount?: Maybe<Scalars['Int']>;
  permissionKey?: Maybe<Scalars['String']>;
  relationships?: Maybe<Array<Maybe<LookupConfigRelationships>>>;
  sort?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type LookupConfigFields = {
  __typename?: 'LookupConfigFields';
  _id?: Maybe<Scalars['MongoID']>;
  component?: Maybe<LookupConfigFieldsComponent>;
  key?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type LookupConfigFieldsComponent = {
  __typename?: 'LookupConfigFieldsComponent';
  props?: Maybe<Scalars['JSON']>;
  type?: Maybe<Scalars['String']>;
};

export type LookupConfigRelationships = {
  __typename?: 'LookupConfigRelationships';
  _id?: Maybe<Scalars['MongoID']>;
  key?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  sortKey?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type LookupOptionRelationshipItems = {
  __typename?: 'LookupOptionRelationshipItems';
  _id?: Maybe<Scalars['MongoID']>;
  link?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type LookupOptionRelationshipPageInfo = {
  __typename?: 'LookupOptionRelationshipPageInfo';
  currentPage?: Maybe<Scalars['Int']>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  pageCount?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type LookupOptionRelationships = {
  __typename?: 'LookupOptionRelationships';
  count?: Maybe<Scalars['Int']>;
  items?: Maybe<Array<LookupOptionRelationshipItems>>;
  pageInfo: LookupOptionRelationshipPageInfo;
};

export type LookupRelationships = {
  __typename?: 'LookupRelationships';
  count?: Maybe<Scalars['Int']>;
  label?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
};

export type Migration = {
  __typename?: 'Migration';
  name?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  analytics?: Maybe<MutationAnalytics>;
  attachments?: Maybe<MutationAttachments>;
  cat?: Maybe<MutationCat>;
  dev?: Maybe<MutationDev>;
  lookups?: Maybe<MutationLookups>;
  migrations?: Maybe<MutationMigrations>;
  permission?: Maybe<MutationPermission>;
  role?: Maybe<MutationRole>;
  user?: Maybe<MutationUser>;
};

export type MutationAnalytics = {
  __typename?: 'MutationAnalytics';
  /** Create one document with mongoose defaults, setters, hooks and validation */
  createOne?: Maybe<CreateOneAnalyticsPayload>;
};


export type MutationAnalyticsCreateOneArgs = {
  record: CreateOneAnalyticsInput;
};

export type MutationAttachments = {
  __typename?: 'MutationAttachments';
  /** Delete one document: 1) Retrieve one document and delete with hooks via findByIdAndDelete. 2) Return deleted document. */
  removeById?: Maybe<DeleteByIdAttachmentPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateById?: Maybe<UpdateByIdAttachmentPayload>;
};


export type MutationAttachmentsRemoveByIdArgs = {
  _id: Scalars['MongoID'];
};


export type MutationAttachmentsUpdateByIdArgs = {
  _id: Scalars['MongoID'];
  record: UpdateByIdAttachmentInput;
};

export type MutationCat = {
  __typename?: 'MutationCat';
  candidate?: Maybe<MutationCatCandidate>;
  contract?: Maybe<MutationCatContract>;
  contractInterviewer?: Maybe<MutationCatContractInterviewer>;
  distribution?: Maybe<MutationCatDistribution>;
  distributionSubcategory?: Maybe<MutationCatDistributionSubcategory>;
  eeoc?: Maybe<MutationCatEeoc>;
  position?: Maybe<MutationCatPosition>;
  reporting?: Maybe<MutationCatReporting>;
  staffingAgencyPoc?: Maybe<MutationCatStaffingAgencyPoc>;
};

export type MutationCatCandidate = {
  __typename?: 'MutationCatCandidate';
  copy?: Maybe<CopyCandidateResults>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  createOne?: Maybe<CreateOneCandidatePayload>;
  /** Delete one document: 1) Retrieve one document and delete with hooks via findByIdAndDelete. 2) Return deleted document. */
  removeById?: Maybe<DeleteByIdCandidatePayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateById?: Maybe<UpdateByIdCandidatePayload>;
};


export type MutationCatCandidateCopyArgs = {
  attachments?: InputMaybe<Scalars['Boolean']>;
  contact?: InputMaybe<Scalars['Boolean']>;
  details?: InputMaybe<Scalars['Boolean']>;
  distribution: Scalars['MongoID'];
  id: Scalars['MongoID'];
  name?: InputMaybe<CopyCandidateNameInput>;
  notes?: InputMaybe<Scalars['Boolean']>;
  position: Scalars['Int'];
  rates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCatCandidateCreateOneArgs = {
  record: CreateOneCandidateInput;
};


export type MutationCatCandidateRemoveByIdArgs = {
  _id: Scalars['MongoID'];
};


export type MutationCatCandidateUpdateByIdArgs = {
  _id: Scalars['MongoID'];
  record: UpdateByIdCandidateInput;
};

export type MutationCatContract = {
  __typename?: 'MutationCatContract';
  /** Create one document with mongoose defaults, setters, hooks and validation */
  createOne?: Maybe<CreateOneCat_ContractPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateById?: Maybe<UpdateByIdCat_ContractPayload>;
};


export type MutationCatContractCreateOneArgs = {
  record: CreateOneCat_ContractInput;
};


export type MutationCatContractUpdateByIdArgs = {
  _id: Scalars['MongoID'];
  record: UpdateByIdCat_ContractInput;
};

export type MutationCatContractInterviewer = {
  __typename?: 'MutationCatContractInterviewer';
  /** Create one document with mongoose defaults, setters, hooks and validation */
  createOne?: Maybe<CreateOneContractInterviewerPayload>;
  /** Delete one document: 1) Retrieve one document and delete with hooks via findByIdAndDelete. 2) Return deleted document. */
  deleteById?: Maybe<DeleteByIdContractInterviewerPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateById?: Maybe<UpdateByIdContractInterviewerPayload>;
};


export type MutationCatContractInterviewerCreateOneArgs = {
  record: CreateOneContractInterviewerInput;
};


export type MutationCatContractInterviewerDeleteByIdArgs = {
  _id: Scalars['MongoID'];
};


export type MutationCatContractInterviewerUpdateByIdArgs = {
  _id: Scalars['MongoID'];
  record: UpdateByIdContractInterviewerInput;
};

export type MutationCatDistribution = {
  __typename?: 'MutationCatDistribution';
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  createMany?: Maybe<CreateManyDistributionPayload>;
  /** Delete one document: 1) Retrieve one document and delete with hooks via findByIdAndDelete. 2) Return deleted document. */
  removeById?: Maybe<DeleteByIdDistributionPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateById?: Maybe<UpdateByIdDistributionPayload>;
};


export type MutationCatDistributionCreateManyArgs = {
  records: Array<CreateManyDistributionInput>;
};


export type MutationCatDistributionRemoveByIdArgs = {
  _id: Scalars['MongoID'];
};


export type MutationCatDistributionUpdateByIdArgs = {
  _id: Scalars['MongoID'];
  record: UpdateByIdDistributionInput;
};

export type MutationCatDistributionSubcategory = {
  __typename?: 'MutationCatDistributionSubcategory';
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  createMany?: Maybe<CreateManyDistribution_SubcategoryPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateById?: Maybe<UpdateByIdDistribution_SubcategoryPayload>;
};


export type MutationCatDistributionSubcategoryCreateManyArgs = {
  records: Array<CreateManyDistribution_SubcategoryInput>;
};


export type MutationCatDistributionSubcategoryUpdateByIdArgs = {
  _id: Scalars['MongoID'];
  record: UpdateByIdDistribution_SubcategoryInput;
};

export type MutationCatEeoc = {
  __typename?: 'MutationCatEeoc';
  sendEeocByCandidate?: Maybe<Eeoc>;
  voidEeocByCandidate?: Maybe<Eeoc>;
};


export type MutationCatEeocSendEeocByCandidateArgs = {
  candidate: Scalars['MongoID'];
  voidReason?: InputMaybe<Scalars['String']>;
};


export type MutationCatEeocVoidEeocByCandidateArgs = {
  candidate: Scalars['MongoID'];
  voidReason: Scalars['String'];
};

export type MutationCatPosition = {
  __typename?: 'MutationCatPosition';
  /** Create one document with mongoose defaults, setters, hooks and validation */
  createOne?: Maybe<CreateOnePositionPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateById?: Maybe<UpdateByIdPositionPayload>;
};


export type MutationCatPositionCreateOneArgs = {
  record: CreateOnePositionInput;
};


export type MutationCatPositionUpdateByIdArgs = {
  _id: Scalars['Int'];
  record: UpdateByIdPositionInput;
};

export type MutationCatReporting = {
  __typename?: 'MutationCatReporting';
  builder?: Maybe<MutationCatReportingBuilder>;
};

export type MutationCatReportingBuilder = {
  __typename?: 'MutationCatReportingBuilder';
  report?: Maybe<MutationCatReportingBuilderReport>;
};

export type MutationCatReportingBuilderReport = {
  __typename?: 'MutationCatReportingBuilderReport';
  /** Create one document with mongoose defaults, setters, hooks and validation */
  createOne?: Maybe<CreateOneReportBuilderReportPayload>;
  /** Delete one document: 1) Retrieve one document and delete with hooks via findByIdAndDelete. 2) Return deleted document. */
  deleteById?: Maybe<DeleteByIdReportBuilderReportPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateById?: Maybe<UpdateByIdReportBuilderReportPayload>;
};


export type MutationCatReportingBuilderReportCreateOneArgs = {
  record: CreateOneReportBuilderReportInput;
};


export type MutationCatReportingBuilderReportDeleteByIdArgs = {
  _id: Scalars['MongoID'];
};


export type MutationCatReportingBuilderReportUpdateByIdArgs = {
  _id: Scalars['MongoID'];
  record: UpdateByIdReportBuilderReportInput;
};

export type MutationCatStaffingAgencyPoc = {
  __typename?: 'MutationCatStaffingAgencyPoc';
  /** Create one document with mongoose defaults, setters, hooks and validation */
  createOne?: Maybe<CreateOneStaffingAgencyPocPayload>;
  /** Delete one document: 1) Retrieve one document and delete with hooks via findByIdAndDelete. 2) Return deleted document. */
  deleteById?: Maybe<DeleteByIdStaffingAgencyPocPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateById?: Maybe<UpdateByIdStaffingAgencyPocPayload>;
};


export type MutationCatStaffingAgencyPocCreateOneArgs = {
  record: CreateOneStaffingAgencyPocInput;
};


export type MutationCatStaffingAgencyPocDeleteByIdArgs = {
  _id: Scalars['MongoID'];
};


export type MutationCatStaffingAgencyPocUpdateByIdArgs = {
  _id: Scalars['MongoID'];
  record: UpdateByIdStaffingAgencyPocInput;
};

export type MutationDev = {
  __typename?: 'MutationDev';
  update?: Maybe<DevUpdateTracker>;
};


export type MutationDevUpdateArgs = {
  bucketFrom: Scalars['String'];
  bucketTo: Scalars['String'];
  databaseFrom: Scalars['String'];
  databaseTo: Scalars['String'];
};

export type MutationLookups = {
  __typename?: 'MutationLookups';
  create?: Maybe<AllLookupQuery>;
  delete?: Maybe<AllLookupMutationDeleteResponse>;
  update?: Maybe<AllLookupQuery>;
};


export type MutationLookupsCreateArgs = {
  key: Scalars['String'];
  record: Scalars['JSON'];
};


export type MutationLookupsDeleteArgs = {
  _id: Scalars['MongoID'];
  key: Scalars['String'];
};


export type MutationLookupsUpdateArgs = {
  _id: Scalars['MongoID'];
  key: Scalars['String'];
  record: Scalars['JSON'];
};

export type MutationMigrations = {
  __typename?: 'MutationMigrations';
  down?: Maybe<Array<Maybe<Migration>>>;
  up?: Maybe<Array<Maybe<Migration>>>;
};

export type MutationPermission = {
  __typename?: 'MutationPermission';
  /** Create one document with mongoose defaults, setters, hooks and validation */
  createOne?: Maybe<CreateOnePermissionPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeById?: Maybe<RemoveByIdPermissionPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateById?: Maybe<UpdateByIdPermissionPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  updateMany?: Maybe<UpdateManyPermissionPayload>;
};


export type MutationPermissionCreateOneArgs = {
  record: CreateOnePermissionInput;
};


export type MutationPermissionRemoveByIdArgs = {
  _id: Scalars['MongoID'];
};


export type MutationPermissionUpdateByIdArgs = {
  _id: Scalars['MongoID'];
  record: UpdateByIdPermissionInput;
};


export type MutationPermissionUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyPermissionInput>;
  limit?: InputMaybe<Scalars['Int']>;
  record: UpdateManyPermissionInput;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortUpdateManyPermissionInput>;
};

export type MutationRole = {
  __typename?: 'MutationRole';
  /** Create one document with mongoose defaults, setters, hooks and validation */
  createOne?: Maybe<CreateOneRolePayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeById?: Maybe<RemoveByIdRolePayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateById?: Maybe<UpdateByIdRolePayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  updateMany?: Maybe<UpdateManyRolePayload>;
};


export type MutationRoleCreateOneArgs = {
  record: CreateOneRoleInput;
};


export type MutationRoleRemoveByIdArgs = {
  _id: Scalars['MongoID'];
};


export type MutationRoleUpdateByIdArgs = {
  _id: Scalars['MongoID'];
  record: UpdateByIdRoleInput;
};


export type MutationRoleUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyRoleInput>;
  limit?: InputMaybe<Scalars['Int']>;
  record: UpdateManyRoleInput;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortUpdateManyRoleInput>;
};

export type MutationUser = {
  __typename?: 'MutationUser';
  /** Create one document with mongoose defaults, setters, hooks and validation */
  createOne?: Maybe<CreateOneUserPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeById?: Maybe<RemoveByIdUserPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateById?: Maybe<UpdateByIdUserPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  updateMany?: Maybe<UpdateManyUserPayload>;
};


export type MutationUserCreateOneArgs = {
  record: CreateOneUserInput;
};


export type MutationUserRemoveByIdArgs = {
  _id: Scalars['MongoID'];
};


export type MutationUserUpdateByIdArgs = {
  _id: Scalars['MongoID'];
  record: UpdateByIdUserInput;
};


export type MutationUserUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyUserInput>;
  limit?: InputMaybe<Scalars['Int']>;
  record: UpdateManyUserInput;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortUpdateManyUserInput>;
};

export type PaginationInfo = {
  __typename?: 'PaginationInfo';
  currentPage: Scalars['Int'];
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']>;
  itemCount?: Maybe<Scalars['Int']>;
  pageCount?: Maybe<Scalars['Int']>;
  perPage: Scalars['Int'];
};

export type Permission = {
  __typename?: 'Permission';
  _id: Scalars['MongoID'];
  createdAt?: Maybe<Scalars['Date']>;
  key?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type Portfolio_Manager = {
  __typename?: 'Portfolio_Manager';
  _createdBy?: Maybe<User>;
  _id: Scalars['MongoID'];
  _updatedBy?: Maybe<User>;
  archived?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['Date']>;
  createdBy?: Maybe<Scalars['MongoID']>;
  deleted?: Maybe<Scalars['Boolean']>;
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['MongoID']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<Scalars['MongoID']>;
};

export type Position = {
  __typename?: 'Position';
  _contract?: Maybe<Cat_Contract>;
  _contract_type?: Maybe<Contract_Type>;
  _createdBy?: Maybe<User>;
  _exemptStatus?: Maybe<Position_Exempt_Status>;
  _hiring_manager?: Maybe<Hiring_Manager>;
  _id: Scalars['Int'];
  _priority?: Maybe<Position_Priority>;
  _program_manager?: Maybe<Program_Manager>;
  _required_clearance?: Maybe<Clearance>;
  _status?: Maybe<Position_Status>;
  _updatedBy?: Maybe<User>;
  _workSetting?: Maybe<PositionWorkSetting>;
  backfill?: Maybe<Scalars['Boolean']>;
  bill_rate?: Maybe<PositionBill_Rate>;
  closed_date?: Maybe<Scalars['Date']>;
  contract?: Maybe<Scalars['MongoID']>;
  contract_type?: Maybe<Scalars['MongoID']>;
  createdAt?: Maybe<Scalars['Date']>;
  createdBy?: Maybe<Scalars['MongoID']>;
  direct_hire?: Maybe<Scalars['Boolean']>;
  exemptStatus?: Maybe<Scalars['MongoID']>;
  filled_date?: Maybe<Scalars['Date']>;
  hiring_manager?: Maybe<Scalars['MongoID']>;
  id?: Maybe<Scalars['String']>;
  job_desc_finalized?: Maybe<Scalars['Date']>;
  job_desc_posted?: Maybe<Scalars['Date']>;
  job_desc_received?: Maybe<Scalars['Date']>;
  keywords?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  numberOfOpenings?: Maybe<Scalars['Float']>;
  pricing?: Maybe<PositionPricing>;
  priority?: Maybe<Scalars['MongoID']>;
  program_manager?: Maybe<Scalars['MongoID']>;
  required_clearance?: Maybe<Scalars['MongoID']>;
  salary?: Maybe<PositionSalary>;
  status?: Maybe<Scalars['MongoID']>;
  temp_to_perm?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<Scalars['MongoID']>;
  workSetting?: Maybe<Scalars['MongoID']>;
};

export type PositionBill_Rate = {
  __typename?: 'PositionBill_rate';
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
};

export type PositionBill_RateInput = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type PositionPricing = {
  __typename?: 'PositionPricing';
  received?: Maybe<Scalars['Date']>;
  requested?: Maybe<Scalars['Date']>;
};

export type PositionPricingInput = {
  received?: InputMaybe<Scalars['Date']>;
  requested?: InputMaybe<Scalars['Date']>;
};

export type PositionSalary = {
  __typename?: 'PositionSalary';
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
};

export type PositionSalaryInput = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type PositionStatusCategory = {
  __typename?: 'PositionStatusCategory';
  _createdBy?: Maybe<User>;
  _id: Scalars['MongoID'];
  _updatedBy?: Maybe<User>;
  archived?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['Date']>;
  createdBy?: Maybe<Scalars['MongoID']>;
  deleted?: Maybe<Scalars['Boolean']>;
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['MongoID']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<Scalars['MongoID']>;
};

export type PositionStatusCount = {
  __typename?: 'PositionStatusCount';
  count?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
};

export type PositionSummaryReport = {
  __typename?: 'PositionSummaryReport';
  _id: Scalars['String'];
  report: Scalars['String'];
};

export type PositionWorkSetting = {
  __typename?: 'PositionWorkSetting';
  _createdBy?: Maybe<User>;
  _id: Scalars['MongoID'];
  _updatedBy?: Maybe<User>;
  archived?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['Date']>;
  createdBy?: Maybe<Scalars['MongoID']>;
  deleted?: Maybe<Scalars['Boolean']>;
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['MongoID']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<Scalars['MongoID']>;
};

export type Position_Exempt_Status = {
  __typename?: 'Position_Exempt_Status';
  _createdBy?: Maybe<User>;
  _id: Scalars['MongoID'];
  _updatedBy?: Maybe<User>;
  archived?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['Date']>;
  createdBy?: Maybe<Scalars['MongoID']>;
  deleted?: Maybe<Scalars['Boolean']>;
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['MongoID']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<Scalars['MongoID']>;
};

export type Position_Priority = {
  __typename?: 'Position_Priority';
  _createdBy?: Maybe<User>;
  _id: Scalars['MongoID'];
  _updatedBy?: Maybe<User>;
  archived?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['Date']>;
  createdBy?: Maybe<Scalars['MongoID']>;
  deleted?: Maybe<Scalars['Boolean']>;
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['MongoID']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<Scalars['MongoID']>;
};

export type Position_Status = {
  __typename?: 'Position_Status';
  _category?: Maybe<PositionStatusCategory>;
  _createdBy?: Maybe<User>;
  _id: Scalars['MongoID'];
  _updatedBy?: Maybe<User>;
  archived?: Maybe<Scalars['Boolean']>;
  category?: Maybe<Scalars['MongoID']>;
  createdAt?: Maybe<Scalars['Date']>;
  createdBy?: Maybe<Scalars['MongoID']>;
  deleted?: Maybe<Scalars['Boolean']>;
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['MongoID']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<Scalars['MongoID']>;
};

export type Program_Manager = {
  __typename?: 'Program_Manager';
  _createdBy?: Maybe<User>;
  _id: Scalars['MongoID'];
  _updatedBy?: Maybe<User>;
  archived?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['Date']>;
  createdBy?: Maybe<Scalars['MongoID']>;
  deleted?: Maybe<Scalars['Boolean']>;
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['MongoID']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<Scalars['MongoID']>;
};

export type Query = {
  __typename?: 'Query';
  attachmentSubtypes?: Maybe<QueryAttachmentSubtypes>;
  attachments?: Maybe<QueryAttachments>;
  cat?: Maybe<QueryCat>;
  dev?: Maybe<QueryDev>;
  lookups?: Maybe<QueryLookups>;
  migrations?: Maybe<QueryMigrations>;
  permission?: Maybe<QueryPermission>;
  reporting?: Maybe<QueryReporting>;
  role?: Maybe<QueryRole>;
  search?: Maybe<SearchResultPagination>;
  user?: Maybe<QueryUser>;
};


export type QuerySearchArgs = {
  filter?: InputMaybe<GlobalSearchFilterArgs>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
};

export type QueryAttachmentSubtypes = {
  __typename?: 'QueryAttachmentSubtypes';
  many: Array<Attachment_Subtype>;
};


export type QueryAttachmentSubtypesManyArgs = {
  filter?: InputMaybe<FilterFindManyAttachment_SubtypeInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAttachment_SubtypeInput>;
};

export type QueryAttachments = {
  __typename?: 'QueryAttachments';
  byId?: Maybe<Attachment>;
  many: Array<Attachment>;
};


export type QueryAttachmentsByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryAttachmentsManyArgs = {
  filter?: InputMaybe<FilterFindManyAttachmentInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAttachmentInput>;
};

export type QueryCat = {
  __typename?: 'QueryCat';
  candidate?: Maybe<QueryCatCandidate>;
  contract?: Maybe<QueryCatContract>;
  contractInterviewer?: Maybe<QueryCatContractInterviewer>;
  distribution?: Maybe<QueryCatDistribution>;
  distributionSubcategory?: Maybe<QueryCatDistributionSubcategory>;
  eeoc?: Maybe<QueryCatEeoc>;
  position?: Maybe<QueryCatPosition>;
  reporting?: Maybe<QueryCatReporting>;
  staffingAgencyPoc?: Maybe<QueryCatStaffingAgencyPoc>;
};

export type QueryCatCandidate = {
  __typename?: 'QueryCatCandidate';
  byId?: Maybe<Candidate>;
  many: Array<Candidate>;
};


export type QueryCatCandidateByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryCatCandidateManyArgs = {
  filter?: InputMaybe<FilterFindManyCandidateInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyCandidateInput>;
};

export type QueryCatContract = {
  __typename?: 'QueryCatContract';
  byId?: Maybe<Cat_Contract>;
  countByPositionStatus?: Maybe<Array<Maybe<PositionStatusCount>>>;
  many: Array<Cat_Contract>;
};


export type QueryCatContractByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryCatContractCountByPositionStatusArgs = {
  _id?: InputMaybe<Scalars['MongoID']>;
};


export type QueryCatContractManyArgs = {
  filter?: InputMaybe<FilterFindManyCat_ContractInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyCat_ContractInput>;
};

export type QueryCatContractInterviewer = {
  __typename?: 'QueryCatContractInterviewer';
  byId?: Maybe<ContractInterviewer>;
  many: Array<ContractInterviewer>;
};


export type QueryCatContractInterviewerByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryCatContractInterviewerManyArgs = {
  filter?: InputMaybe<FilterFindManyContractInterviewerInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyContractInterviewerInput>;
};

export type QueryCatDistribution = {
  __typename?: 'QueryCatDistribution';
  byId?: Maybe<Distribution>;
  many: Array<Distribution>;
};


export type QueryCatDistributionByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryCatDistributionManyArgs = {
  filter?: InputMaybe<FilterFindManyDistributionInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyDistributionInput>;
};

export type QueryCatDistributionSubcategory = {
  __typename?: 'QueryCatDistributionSubcategory';
  byId?: Maybe<Distribution_Subcategory>;
  many: Array<Distribution_Subcategory>;
};


export type QueryCatDistributionSubcategoryByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryCatDistributionSubcategoryManyArgs = {
  filter?: InputMaybe<FilterFindManyDistribution_SubcategoryInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyDistribution_SubcategoryInput>;
};

export type QueryCatEeoc = {
  __typename?: 'QueryCatEeoc';
  byId?: Maybe<Eeoc>;
  findEeocByCandidate?: Maybe<Eeoc>;
  many: Array<Eeoc>;
  token?: Maybe<Scalars['String']>;
};


export type QueryCatEeocByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryCatEeocFindEeocByCandidateArgs = {
  candidate: Scalars['MongoID'];
};


export type QueryCatEeocManyArgs = {
  filter?: InputMaybe<FilterFindManyEeocInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyEeocInput>;
};

export type QueryCatPosition = {
  __typename?: 'QueryCatPosition';
  byId?: Maybe<Position>;
  many: Array<Position>;
};


export type QueryCatPositionByIdArgs = {
  _id: Scalars['Int'];
};


export type QueryCatPositionManyArgs = {
  filter?: InputMaybe<FilterFindManyPositionInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPositionInput>;
};

export type QueryCatReporting = {
  __typename?: 'QueryCatReporting';
  builder?: Maybe<QueryCatReportingBuilder>;
};

export type QueryCatReportingBuilder = {
  __typename?: 'QueryCatReportingBuilder';
  aggregate?: Maybe<ReportBuilderAggregateResult>;
  report?: Maybe<QueryCatReportingBuilderReport>;
};


export type QueryCatReportingBuilderAggregateArgs = {
  match?: InputMaybe<Scalars['JSON']>;
  model: Scalars['String'];
  pipeline?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type QueryCatReportingBuilderReport = {
  __typename?: 'QueryCatReportingBuilderReport';
  byId?: Maybe<ReportBuilderReport>;
  many: Array<ReportBuilderReport>;
};


export type QueryCatReportingBuilderReportByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryCatReportingBuilderReportManyArgs = {
  filter?: InputMaybe<FilterFindManyReportBuilderReportInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyReportBuilderReportInput>;
};

export type QueryCatStaffingAgencyPoc = {
  __typename?: 'QueryCatStaffingAgencyPoc';
  byId?: Maybe<StaffingAgencyPoc>;
  many: Array<StaffingAgencyPoc>;
};


export type QueryCatStaffingAgencyPocByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryCatStaffingAgencyPocManyArgs = {
  filter?: InputMaybe<FilterFindManyStaffingAgencyPocInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyStaffingAgencyPocInput>;
};

export type QueryDev = {
  __typename?: 'QueryDev';
  update?: Maybe<QueryDevUpdate>;
};

export type QueryDevUpdate = {
  __typename?: 'QueryDevUpdate';
  byId?: Maybe<DevUpdateTracker>;
  inprogress?: Maybe<DevUpdateTracker>;
  many: Array<DevUpdateTracker>;
};


export type QueryDevUpdateByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryDevUpdateManyArgs = {
  filter?: InputMaybe<FilterFindManyDevUpdateTrackerInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyDevUpdateTrackerInput>;
};

export type QueryLookups = {
  __typename?: 'QueryLookups';
  Candidate_Rank?: Maybe<QueryLookupsCandidate_Rank>;
  Candidate_Status?: Maybe<QueryLookupsCandidate_Status>;
  Candidate_Substatus?: Maybe<QueryLookupsCandidate_Substatus>;
  Candidate_Type?: Maybe<QueryLookupsCandidate_Type>;
  Clearance?: Maybe<QueryLookupsClearance>;
  Contract_Status?: Maybe<QueryLookupsContract_Status>;
  Contract_Type?: Maybe<QueryLookupsContract_Type>;
  Contract_Vehicle?: Maybe<QueryLookupsContract_Vehicle>;
  DistributionSubcategoryStatus?: Maybe<QueryLookupsDistributionSubcategoryStatus>;
  Distribution_Category?: Maybe<QueryLookupsDistribution_Category>;
  Hiring_Manager?: Maybe<QueryLookupsHiring_Manager>;
  Portfolio_Manager?: Maybe<QueryLookupsPortfolio_Manager>;
  PositionStatusCategory?: Maybe<QueryLookupsPositionStatusCategory>;
  PositionWorkSetting?: Maybe<QueryLookupsPositionWorkSetting>;
  Position_Exempt_Status?: Maybe<QueryLookupsPosition_Exempt_Status>;
  Position_Priority?: Maybe<QueryLookupsPosition_Priority>;
  Position_Status?: Maybe<QueryLookupsPosition_Status>;
  Program_Manager?: Maybe<QueryLookupsProgram_Manager>;
  StaffingAgencyClearedFacility?: Maybe<QueryLookupsStaffingAgencyClearedFacility>;
  StaffingAgencyHoliday?: Maybe<QueryLookupsStaffingAgencyHoliday>;
  StaffingAgencyPocType?: Maybe<QueryLookupsStaffingAgencyPocType>;
  Timezone?: Maybe<QueryLookupsTimezone>;
  all?: Maybe<Array<AllLookupQuery>>;
  config?: Maybe<QueryLookupsConfig>;
  relationships: LookupOptionRelationships;
};


export type QueryLookupsAllArgs = {
  key: Scalars['String'];
};


export type QueryLookupsRelationshipsArgs = {
  _id: Scalars['MongoID'];
  key: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  relationshipModel: Scalars['String'];
};

export type QueryLookupsCandidate_Rank = {
  __typename?: 'QueryLookupsCandidate_Rank';
  many: Array<Candidate_Rank>;
};


export type QueryLookupsCandidate_RankManyArgs = {
  filter?: InputMaybe<FilterFindManyCandidate_RankInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyCandidate_RankInput>;
};

export type QueryLookupsCandidate_Status = {
  __typename?: 'QueryLookupsCandidate_Status';
  many: Array<Candidate_Status>;
};


export type QueryLookupsCandidate_StatusManyArgs = {
  filter?: InputMaybe<FilterFindManyCandidate_StatusInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyCandidate_StatusInput>;
};

export type QueryLookupsCandidate_Substatus = {
  __typename?: 'QueryLookupsCandidate_Substatus';
  many: Array<Candidate_Substatus>;
};


export type QueryLookupsCandidate_SubstatusManyArgs = {
  filter?: InputMaybe<FilterFindManyCandidate_SubstatusInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyCandidate_SubstatusInput>;
};

export type QueryLookupsCandidate_Type = {
  __typename?: 'QueryLookupsCandidate_Type';
  many: Array<Candidate_Type>;
};


export type QueryLookupsCandidate_TypeManyArgs = {
  filter?: InputMaybe<FilterFindManyCandidate_TypeInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyCandidate_TypeInput>;
};

export type QueryLookupsClearance = {
  __typename?: 'QueryLookupsClearance';
  many: Array<Clearance>;
};


export type QueryLookupsClearanceManyArgs = {
  filter?: InputMaybe<FilterFindManyClearanceInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyClearanceInput>;
};

export type QueryLookupsConfig = {
  __typename?: 'QueryLookupsConfig';
  byId?: Maybe<LookupConfig>;
  many: Array<LookupConfig>;
};


export type QueryLookupsConfigByIdArgs = {
  _id: Scalars['String'];
};


export type QueryLookupsConfigManyArgs = {
  filter?: InputMaybe<FilterFindManyLookupConfigInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyLookupConfigInput>;
};

export type QueryLookupsContract_Status = {
  __typename?: 'QueryLookupsContract_Status';
  many: Array<Contract_Status>;
};


export type QueryLookupsContract_StatusManyArgs = {
  filter?: InputMaybe<FilterFindManyContract_StatusInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyContract_StatusInput>;
};

export type QueryLookupsContract_Type = {
  __typename?: 'QueryLookupsContract_Type';
  many: Array<Contract_Type>;
};


export type QueryLookupsContract_TypeManyArgs = {
  filter?: InputMaybe<FilterFindManyContract_TypeInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyContract_TypeInput>;
};

export type QueryLookupsContract_Vehicle = {
  __typename?: 'QueryLookupsContract_Vehicle';
  many: Array<Contract_Vehicle>;
};


export type QueryLookupsContract_VehicleManyArgs = {
  filter?: InputMaybe<FilterFindManyContract_VehicleInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyContract_VehicleInput>;
};

export type QueryLookupsDistributionSubcategoryStatus = {
  __typename?: 'QueryLookupsDistributionSubcategoryStatus';
  many: Array<DistributionSubcategoryStatus>;
};


export type QueryLookupsDistributionSubcategoryStatusManyArgs = {
  filter?: InputMaybe<FilterFindManyDistributionSubcategoryStatusInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyDistributionSubcategoryStatusInput>;
};

export type QueryLookupsDistribution_Category = {
  __typename?: 'QueryLookupsDistribution_Category';
  many: Array<Distribution_Category>;
};


export type QueryLookupsDistribution_CategoryManyArgs = {
  filter?: InputMaybe<FilterFindManyDistribution_CategoryInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyDistribution_CategoryInput>;
};

export type QueryLookupsHiring_Manager = {
  __typename?: 'QueryLookupsHiring_Manager';
  many: Array<Hiring_Manager>;
};


export type QueryLookupsHiring_ManagerManyArgs = {
  filter?: InputMaybe<FilterFindManyHiring_ManagerInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyHiring_ManagerInput>;
};

export type QueryLookupsPortfolio_Manager = {
  __typename?: 'QueryLookupsPortfolio_Manager';
  many: Array<Portfolio_Manager>;
};


export type QueryLookupsPortfolio_ManagerManyArgs = {
  filter?: InputMaybe<FilterFindManyPortfolio_ManagerInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPortfolio_ManagerInput>;
};

export type QueryLookupsPositionStatusCategory = {
  __typename?: 'QueryLookupsPositionStatusCategory';
  many: Array<PositionStatusCategory>;
};


export type QueryLookupsPositionStatusCategoryManyArgs = {
  filter?: InputMaybe<FilterFindManyPositionStatusCategoryInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPositionStatusCategoryInput>;
};

export type QueryLookupsPositionWorkSetting = {
  __typename?: 'QueryLookupsPositionWorkSetting';
  many: Array<PositionWorkSetting>;
};


export type QueryLookupsPositionWorkSettingManyArgs = {
  filter?: InputMaybe<FilterFindManyPositionWorkSettingInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPositionWorkSettingInput>;
};

export type QueryLookupsPosition_Exempt_Status = {
  __typename?: 'QueryLookupsPosition_Exempt_Status';
  many: Array<Position_Exempt_Status>;
};


export type QueryLookupsPosition_Exempt_StatusManyArgs = {
  filter?: InputMaybe<FilterFindManyPosition_Exempt_StatusInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPosition_Exempt_StatusInput>;
};

export type QueryLookupsPosition_Priority = {
  __typename?: 'QueryLookupsPosition_Priority';
  many: Array<Position_Priority>;
};


export type QueryLookupsPosition_PriorityManyArgs = {
  filter?: InputMaybe<FilterFindManyPosition_PriorityInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPosition_PriorityInput>;
};

export type QueryLookupsPosition_Status = {
  __typename?: 'QueryLookupsPosition_Status';
  many: Array<Position_Status>;
};


export type QueryLookupsPosition_StatusManyArgs = {
  filter?: InputMaybe<FilterFindManyPosition_StatusInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPosition_StatusInput>;
};

export type QueryLookupsProgram_Manager = {
  __typename?: 'QueryLookupsProgram_Manager';
  many: Array<Program_Manager>;
};


export type QueryLookupsProgram_ManagerManyArgs = {
  filter?: InputMaybe<FilterFindManyProgram_ManagerInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyProgram_ManagerInput>;
};

export type QueryLookupsStaffingAgencyClearedFacility = {
  __typename?: 'QueryLookupsStaffingAgencyClearedFacility';
  many: Array<StaffingAgencyClearedFacility>;
};


export type QueryLookupsStaffingAgencyClearedFacilityManyArgs = {
  filter?: InputMaybe<FilterFindManyStaffingAgencyClearedFacilityInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyStaffingAgencyClearedFacilityInput>;
};

export type QueryLookupsStaffingAgencyHoliday = {
  __typename?: 'QueryLookupsStaffingAgencyHoliday';
  many: Array<StaffingAgencyHoliday>;
};


export type QueryLookupsStaffingAgencyHolidayManyArgs = {
  filter?: InputMaybe<FilterFindManyStaffingAgencyHolidayInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyStaffingAgencyHolidayInput>;
};

export type QueryLookupsStaffingAgencyPocType = {
  __typename?: 'QueryLookupsStaffingAgencyPocType';
  many: Array<StaffingAgencyPocType>;
};


export type QueryLookupsStaffingAgencyPocTypeManyArgs = {
  filter?: InputMaybe<FilterFindManyStaffingAgencyPocTypeInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyStaffingAgencyPocTypeInput>;
};

export type QueryLookupsTimezone = {
  __typename?: 'QueryLookupsTimezone';
  many: Array<Timezone>;
};


export type QueryLookupsTimezoneManyArgs = {
  filter?: InputMaybe<FilterFindManyTimezoneInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyTimezoneInput>;
};

export type QueryMigrations = {
  __typename?: 'QueryMigrations';
  all?: Maybe<Array<Maybe<Migration>>>;
  executed?: Maybe<Array<Maybe<Migration>>>;
  pending?: Maybe<Array<Maybe<Migration>>>;
};

export type QueryPermission = {
  __typename?: 'QueryPermission';
  byId?: Maybe<Permission>;
  many: Array<Permission>;
  one?: Maybe<Permission>;
};


export type QueryPermissionByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryPermissionManyArgs = {
  filter?: InputMaybe<FilterFindManyPermissionInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPermissionInput>;
};


export type QueryPermissionOneArgs = {
  filter?: InputMaybe<FilterFindOnePermissionInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOnePermissionInput>;
};

export type QueryReporting = {
  __typename?: 'QueryReporting';
  applicantSources?: Maybe<Array<ApplicantSource>>;
  applicantStages?: Maybe<Array<ApplicantStage>>;
  averageTimeToFill?: Maybe<AverageTimeToFill>;
  positionSummary: PositionSummaryReport;
};


export type QueryReportingApplicantSourcesArgs = {
  end: Scalars['Date'];
  start: Scalars['Date'];
};


export type QueryReportingApplicantStagesArgs = {
  end: Scalars['Date'];
  start: Scalars['Date'];
};


export type QueryReportingAverageTimeToFillArgs = {
  end: Scalars['Date'];
  groupBy?: InputMaybe<AverageTimeToFillGroupBy>;
  start: Scalars['Date'];
};


export type QueryReportingPositionSummaryArgs = {
  _id: Scalars['Int'];
};

export type QueryRole = {
  __typename?: 'QueryRole';
  byId?: Maybe<Role>;
  many: Array<Role>;
  one?: Maybe<Role>;
};


export type QueryRoleByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryRoleManyArgs = {
  filter?: InputMaybe<FilterFindManyRoleInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyRoleInput>;
};


export type QueryRoleOneArgs = {
  filter?: InputMaybe<FilterFindOneRoleInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneRoleInput>;
};

export type QueryUser = {
  __typename?: 'QueryUser';
  byId?: Maybe<User>;
  many: Array<User>;
  one?: Maybe<User>;
  self?: Maybe<User>;
};


export type QueryUserByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryUserManyArgs = {
  filter?: InputMaybe<FilterFindManyUserInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyUserInput>;
};


export type QueryUserOneArgs = {
  filter?: InputMaybe<FilterFindOneUserInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneUserInput>;
};

export type RemoveByIdPermissionPayload = {
  __typename?: 'RemoveByIdPermissionPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Permission>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type RemoveByIdRolePayload = {
  __typename?: 'RemoveByIdRolePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Role>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type RemoveByIdUserPayload = {
  __typename?: 'RemoveByIdUserPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<User>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type ReportBuilderAggregateResult = {
  __typename?: 'ReportBuilderAggregateResult';
  results?: Maybe<Array<Maybe<Scalars['JSON']>>>;
};

export type ReportBuilderReport = {
  __typename?: 'ReportBuilderReport';
  _createdBy?: Maybe<User>;
  _id: Scalars['MongoID'];
  _updatedBy?: Maybe<User>;
  createdAt?: Maybe<Scalars['Date']>;
  createdBy?: Maybe<Scalars['MongoID']>;
  deleted?: Maybe<Scalars['Boolean']>;
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['MongoID']>;
  fields?: Maybe<Array<Maybe<Scalars['String']>>>;
  model?: Maybe<EnumReportBuilderReportModel>;
  query: Scalars['JSON'];
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<Scalars['MongoID']>;
};

export type Role = {
  __typename?: 'Role';
  _id: Scalars['MongoID'];
  _permissions: Array<Maybe<Permission>>;
  createdAt?: Maybe<Scalars['Date']>;
  defaultPage?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<Scalars['MongoID']>>>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type SearchResult = {
  __typename?: 'SearchResult';
  _id?: Maybe<Scalars['String']>;
  badges?: Maybe<Array<Maybe<SearchResultBadge>>>;
  category?: Maybe<Scalars['String']>;
  rawScore?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
  scoreDetails?: Maybe<Scalars['JSON']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type SearchResultBadge = {
  __typename?: 'SearchResultBadge';
  title?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** List of items with pagination. */
export type SearchResultPagination = {
  __typename?: 'SearchResultPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<SearchResult>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export enum SortFindManyAttachmentInput {
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyAttachment_SubtypeInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyCandidateInput {
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyCandidate_RankInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  OrderAsc = 'ORDER_ASC',
  OrderDesc = 'ORDER_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyCandidate_StatusInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  OrderAsc = 'ORDER_ASC',
  OrderDesc = 'ORDER_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyCandidate_SubstatusInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  OldorderAsc = 'OLDORDER_ASC',
  OldorderDesc = 'OLDORDER_DESC',
  OrderAsc = 'ORDER_ASC',
  OrderDesc = 'ORDER_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyCandidate_TypeInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyCat_ContractInput {
  AbbreviationAsc = 'ABBREVIATION_ASC',
  AbbreviationDesc = 'ABBREVIATION_DESC',
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyClearanceInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyContractInterviewerInput {
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyContract_StatusInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  OrderAsc = 'ORDER_ASC',
  OrderDesc = 'ORDER_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyContract_TypeInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyContract_VehicleInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyDevUpdateTrackerInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyDistributionInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyDistributionSubcategoryStatusInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  OrderAsc = 'ORDER_ASC',
  OrderDesc = 'ORDER_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyDistribution_CategoryInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyDistribution_SubcategoryInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyEeocInput {
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyHiring_ManagerInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyLookupConfigInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyPermissionInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyPortfolio_ManagerInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyPositionInput {
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyPositionStatusCategoryInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyPositionWorkSettingInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyPosition_Exempt_StatusInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyPosition_PriorityInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyPosition_StatusInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  OrderAsc = 'ORDER_ASC',
  OrderDesc = 'ORDER_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyProgram_ManagerInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyReportBuilderReportInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyRoleInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyStaffingAgencyClearedFacilityInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  OrderAsc = 'ORDER_ASC',
  OrderDesc = 'ORDER_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyStaffingAgencyHolidayInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  OrderAsc = 'ORDER_ASC',
  OrderDesc = 'ORDER_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyStaffingAgencyPocInput {
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyStaffingAgencyPocTypeInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  OrderAsc = 'ORDER_ASC',
  OrderDesc = 'ORDER_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyTimezoneInput {
  AbbreviationAsc = 'ABBREVIATION_ASC',
  AbbreviationDesc = 'ABBREVIATION_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  OrderAsc = 'ORDER_ASC',
  OrderDesc = 'ORDER_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyUserInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOnePermissionInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneRoleInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneUserInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyPermissionInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyRoleInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyUserInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export type StaffingAgencyClearedFacility = {
  __typename?: 'StaffingAgencyClearedFacility';
  _createdBy?: Maybe<User>;
  _id: Scalars['MongoID'];
  _updatedBy?: Maybe<User>;
  archived?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['Date']>;
  createdBy?: Maybe<Scalars['MongoID']>;
  deleted?: Maybe<Scalars['Boolean']>;
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['MongoID']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<Scalars['MongoID']>;
};

export type StaffingAgencyHoliday = {
  __typename?: 'StaffingAgencyHoliday';
  _createdBy?: Maybe<User>;
  _id: Scalars['MongoID'];
  _updatedBy?: Maybe<User>;
  archived?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['Date']>;
  createdBy?: Maybe<Scalars['MongoID']>;
  deleted?: Maybe<Scalars['Boolean']>;
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['MongoID']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<Scalars['MongoID']>;
};

export type StaffingAgencyPoc = {
  __typename?: 'StaffingAgencyPoc';
  _createdBy?: Maybe<User>;
  _id: Scalars['MongoID'];
  _timezone?: Maybe<Timezone>;
  _type?: Maybe<StaffingAgencyPocType>;
  _updatedBy?: Maybe<User>;
  address?: Maybe<StaffingAgencyPocAddress>;
  createdAt?: Maybe<Scalars['Date']>;
  createdBy?: Maybe<Scalars['MongoID']>;
  deleted?: Maybe<Scalars['Boolean']>;
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['MongoID']>;
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  staffingAgency?: Maybe<Scalars['MongoID']>;
  timezone?: Maybe<Scalars['MongoID']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['MongoID']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<Scalars['MongoID']>;
};

export type StaffingAgencyPocAddress = {
  __typename?: 'StaffingAgencyPocAddress';
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type StaffingAgencyPocAddressInput = {
  city?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type StaffingAgencyPocType = {
  __typename?: 'StaffingAgencyPocType';
  _createdBy?: Maybe<User>;
  _id: Scalars['MongoID'];
  _updatedBy?: Maybe<User>;
  archived?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['Date']>;
  createdBy?: Maybe<Scalars['MongoID']>;
  deleted?: Maybe<Scalars['Boolean']>;
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['MongoID']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<Scalars['MongoID']>;
};

export type Timezone = {
  __typename?: 'Timezone';
  _createdBy?: Maybe<User>;
  _id: Scalars['MongoID'];
  _updatedBy?: Maybe<User>;
  abbreviation?: Maybe<Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['Date']>;
  createdBy?: Maybe<Scalars['MongoID']>;
  deleted?: Maybe<Scalars['Boolean']>;
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['MongoID']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<Scalars['MongoID']>;
};

export type UpdateByIdAttachmentInput = {
  additional?: InputMaybe<Scalars['JSON']>;
  contentType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  deletedBy?: InputMaybe<Scalars['MongoID']>;
  filename?: InputMaybe<Scalars['String']>;
  link?: InputMaybe<Scalars['JSON']>;
  model?: InputMaybe<Scalars['String']>;
  s3?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  subtype?: InputMaybe<Scalars['MongoID']>;
  type?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['MongoID']>;
};

export type UpdateByIdAttachmentPayload = {
  __typename?: 'UpdateByIdAttachmentPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Attachment>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type UpdateByIdCandidateAddressInput = {
  city?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type UpdateByIdCandidateBill_RateInput = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type UpdateByIdCandidateExhibitInput = {
  contracts_approved?: InputMaybe<Scalars['Date']>;
  extended?: InputMaybe<Scalars['Date']>;
  hm_approved?: InputMaybe<Scalars['Date']>;
  pmo_approved?: InputMaybe<Scalars['Date']>;
  sent_for_review?: InputMaybe<Scalars['Date']>;
  signed?: InputMaybe<Scalars['Date']>;
};

export type UpdateByIdCandidateInput = {
  address?: InputMaybe<UpdateByIdCandidateAddressInput>;
  bill_rate?: InputMaybe<UpdateByIdCandidateBill_RateInput>;
  clearance?: InputMaybe<Scalars['MongoID']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  deletedBy?: InputMaybe<Scalars['MongoID']>;
  distribution?: InputMaybe<Scalars['MongoID']>;
  email?: InputMaybe<Scalars['String']>;
  exhibit?: InputMaybe<UpdateByIdCandidateExhibitInput>;
  firstLastName?: InputMaybe<Scalars['String']>;
  lastFirstName?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<UpdateByIdCandidateNameInput>;
  nda_signed?: InputMaybe<UpdateByIdCandidateNda_SignedInput>;
  notes?: InputMaybe<Scalars['String']>;
  offer_letter?: InputMaybe<UpdateByIdCandidateOffer_LetterInput>;
  phone?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Float']>;
  rank?: InputMaybe<Scalars['MongoID']>;
  reapply?: InputMaybe<Scalars['Boolean']>;
  received_on?: InputMaybe<Scalars['Date']>;
  rejection_date?: InputMaybe<Scalars['Date']>;
  resume?: InputMaybe<UpdateByIdCandidateResumeInput>;
  round_1?: InputMaybe<Scalars['Date']>;
  round_2?: InputMaybe<Scalars['Date']>;
  round_3?: InputMaybe<Scalars['Date']>;
  salary?: InputMaybe<UpdateByIdCandidateSalaryInput>;
  status?: InputMaybe<Scalars['MongoID']>;
  substatus?: InputMaybe<Scalars['MongoID']>;
  type?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['MongoID']>;
};

export type UpdateByIdCandidateNameInput = {
  first?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['String']>;
};

export type UpdateByIdCandidateNda_SignedInput = {
  candidate?: InputMaybe<Scalars['Date']>;
  staffing_agency?: InputMaybe<Scalars['Date']>;
};

export type UpdateByIdCandidateOffer_LetterInput = {
  approved?: InputMaybe<Scalars['Date']>;
  extended?: InputMaybe<Scalars['Date']>;
  signed?: InputMaybe<Scalars['Date']>;
};

export type UpdateByIdCandidatePayload = {
  __typename?: 'UpdateByIdCandidatePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Candidate>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type UpdateByIdCandidateResumeInput = {
  reviewed?: InputMaybe<Scalars['Date']>;
  reviewed_by?: InputMaybe<Scalars['MongoID']>;
  sent?: InputMaybe<Scalars['Date']>;
};

export type UpdateByIdCandidateSalaryInput = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type UpdateByIdCat_ContractInput = {
  abbreviation?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  onboarding?: InputMaybe<UpdateByIdCat_ContractOnboardingInput>;
  pop?: InputMaybe<UpdateByIdCat_ContractPopInput>;
  portfolio_manager?: InputMaybe<Scalars['MongoID']>;
  primary_address?: InputMaybe<UpdateByIdCat_ContractPrimary_AddressInput>;
  prime?: InputMaybe<Scalars['Boolean']>;
  program_manager?: InputMaybe<Scalars['MongoID']>;
  status?: InputMaybe<Scalars['MongoID']>;
  subcontractor?: InputMaybe<Scalars['String']>;
  teamSize?: InputMaybe<Scalars['Float']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['MongoID']>;
  vehicle?: InputMaybe<Scalars['MongoID']>;
};

export type UpdateByIdCat_ContractOnboardingInput = {
  biProcessTimeframe?: InputMaybe<Scalars['String']>;
  clearanceReqs?: InputMaybe<Scalars['Boolean']>;
  days?: InputMaybe<Scalars['String']>;
  gfeProvided?: InputMaybe<Scalars['Boolean']>;
  imcEquipment?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateByIdCat_ContractPayload = {
  __typename?: 'UpdateByIdCat_ContractPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Cat_Contract>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type UpdateByIdCat_ContractPopBaseInput = {
  end?: InputMaybe<Scalars['Date']>;
  start?: InputMaybe<Scalars['Date']>;
};

export type UpdateByIdCat_ContractPopExtensionsInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  end?: InputMaybe<Scalars['Date']>;
  start?: InputMaybe<Scalars['Date']>;
};

export type UpdateByIdCat_ContractPopInput = {
  base?: InputMaybe<UpdateByIdCat_ContractPopBaseInput>;
  extensions?: InputMaybe<Array<InputMaybe<UpdateByIdCat_ContractPopExtensionsInput>>>;
  options?: InputMaybe<Array<InputMaybe<UpdateByIdCat_ContractPopOptionsInput>>>;
  status?: InputMaybe<Scalars['String']>;
};

export type UpdateByIdCat_ContractPopOptionsInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  end?: InputMaybe<Scalars['Date']>;
  start?: InputMaybe<Scalars['Date']>;
};

export type UpdateByIdCat_ContractPrimary_AddressInput = {
  city?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type UpdateByIdContractInterviewerInput = {
  contract?: InputMaybe<Scalars['MongoID']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  deletedBy?: InputMaybe<Scalars['MongoID']>;
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['MongoID']>;
};

export type UpdateByIdContractInterviewerPayload = {
  __typename?: 'UpdateByIdContractInterviewerPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<ContractInterviewer>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type UpdateByIdDistributionInput = {
  category?: InputMaybe<Scalars['MongoID']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  date_posted?: InputMaybe<Scalars['Date']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  deletedBy?: InputMaybe<Scalars['MongoID']>;
  notes?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Float']>;
  subcategory?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['MongoID']>;
};

export type UpdateByIdDistributionPayload = {
  __typename?: 'UpdateByIdDistributionPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Distribution>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type UpdateByIdDistribution_SubcategoryInput = {
  category?: InputMaybe<Scalars['MongoID']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  deletedBy?: InputMaybe<Scalars['MongoID']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  staffingAgency?: InputMaybe<UpdateByIdDistribution_SubcategoryStaffingAgencyInput>;
  status?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['MongoID']>;
};

export type UpdateByIdDistribution_SubcategoryPayload = {
  __typename?: 'UpdateByIdDistribution_SubcategoryPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Distribution_Subcategory>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type UpdateByIdDistribution_SubcategoryStaffingAgencyBenefitsInput = {
  healthBenefits?: InputMaybe<Scalars['Boolean']>;
  holidays?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  payrollRunTime?: InputMaybe<Scalars['String']>;
  pto?: InputMaybe<Scalars['String']>;
};

export type UpdateByIdDistribution_SubcategoryStaffingAgencyInput = {
  benefits?: InputMaybe<UpdateByIdDistribution_SubcategoryStaffingAgencyBenefitsInput>;
  clearedFacility?: InputMaybe<Scalars['MongoID']>;
  msa?: InputMaybe<UpdateByIdDistribution_SubcategoryStaffingAgencyMsaInput>;
  remit?: InputMaybe<UpdateByIdDistribution_SubcategoryStaffingAgencyRemitInput>;
  sdvosb?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateByIdDistribution_SubcategoryStaffingAgencyMsaInput = {
  conversionFees?: InputMaybe<Scalars['String']>;
  conversionTimeframe?: InputMaybe<Scalars['String']>;
  dateSigned?: InputMaybe<Scalars['Date']>;
  dhAvailable?: InputMaybe<Scalars['Boolean']>;
  dhWarranty?: InputMaybe<Scalars['String']>;
  nonSolicitationDuration?: InputMaybe<Scalars['String']>;
};

export type UpdateByIdDistribution_SubcategoryStaffingAgencyRemitAddressInput = {
  city?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type UpdateByIdDistribution_SubcategoryStaffingAgencyRemitInput = {
  address?: InputMaybe<UpdateByIdDistribution_SubcategoryStaffingAgencyRemitAddressInput>;
  name?: InputMaybe<Scalars['String']>;
  paymentDetails?: InputMaybe<Scalars['String']>;
  paymentTerms?: InputMaybe<Scalars['String']>;
};

export type UpdateByIdPermissionInput = {
  createdAt?: InputMaybe<Scalars['Date']>;
  key?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type UpdateByIdPermissionPayload = {
  __typename?: 'UpdateByIdPermissionPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Permission>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type UpdateByIdPositionBill_RateInput = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type UpdateByIdPositionInput = {
  backfill?: InputMaybe<Scalars['Boolean']>;
  bill_rate?: InputMaybe<UpdateByIdPositionBill_RateInput>;
  closed_date?: InputMaybe<Scalars['Date']>;
  contract?: InputMaybe<Scalars['MongoID']>;
  contract_type?: InputMaybe<Scalars['MongoID']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  direct_hire?: InputMaybe<Scalars['Boolean']>;
  exemptStatus?: InputMaybe<Scalars['MongoID']>;
  filled_date?: InputMaybe<Scalars['Date']>;
  hiring_manager?: InputMaybe<Scalars['MongoID']>;
  job_desc_finalized?: InputMaybe<Scalars['Date']>;
  job_desc_posted?: InputMaybe<Scalars['Date']>;
  job_desc_received?: InputMaybe<Scalars['Date']>;
  keywords?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  numberOfOpenings?: InputMaybe<Scalars['Float']>;
  pricing?: InputMaybe<UpdateByIdPositionPricingInput>;
  priority?: InputMaybe<Scalars['MongoID']>;
  program_manager?: InputMaybe<Scalars['MongoID']>;
  required_clearance?: InputMaybe<Scalars['MongoID']>;
  salary?: InputMaybe<UpdateByIdPositionSalaryInput>;
  status?: InputMaybe<Scalars['MongoID']>;
  temp_to_perm?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['MongoID']>;
  workSetting?: InputMaybe<Scalars['MongoID']>;
};

export type UpdateByIdPositionPayload = {
  __typename?: 'UpdateByIdPositionPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Position>;
  /** Document ID */
  recordId?: Maybe<Scalars['Int']>;
};

export type UpdateByIdPositionPricingInput = {
  received?: InputMaybe<Scalars['Date']>;
  requested?: InputMaybe<Scalars['Date']>;
};

export type UpdateByIdPositionSalaryInput = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type UpdateByIdReportBuilderReportInput = {
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  deletedBy?: InputMaybe<Scalars['MongoID']>;
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  model?: InputMaybe<EnumReportBuilderReportModel>;
  query?: InputMaybe<Scalars['JSON']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['MongoID']>;
};

export type UpdateByIdReportBuilderReportPayload = {
  __typename?: 'UpdateByIdReportBuilderReportPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<ReportBuilderReport>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type UpdateByIdRoleInput = {
  createdAt?: InputMaybe<Scalars['Date']>;
  defaultPage?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type UpdateByIdRolePayload = {
  __typename?: 'UpdateByIdRolePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Role>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type UpdateByIdStaffingAgencyPocAddressInput = {
  city?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type UpdateByIdStaffingAgencyPocInput = {
  address?: InputMaybe<UpdateByIdStaffingAgencyPocAddressInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  deletedBy?: InputMaybe<Scalars['MongoID']>;
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  staffingAgency?: InputMaybe<Scalars['MongoID']>;
  timezone?: InputMaybe<Scalars['MongoID']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['MongoID']>;
};

export type UpdateByIdStaffingAgencyPocPayload = {
  __typename?: 'UpdateByIdStaffingAgencyPocPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<StaffingAgencyPoc>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type UpdateByIdUserInput = {
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['JSON']>;
  defaultPage?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  lastActive?: InputMaybe<Scalars['Date']>;
  name?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['JSON']>;
};

export type UpdateByIdUserPayload = {
  __typename?: 'UpdateByIdUserPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<User>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type UpdateManyPermissionInput = {
  createdAt?: InputMaybe<Scalars['Date']>;
  key?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type UpdateManyPermissionPayload = {
  __typename?: 'UpdateManyPermissionPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']>;
};

export type UpdateManyRoleInput = {
  createdAt?: InputMaybe<Scalars['Date']>;
  defaultPage?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type UpdateManyRolePayload = {
  __typename?: 'UpdateManyRolePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']>;
};

export type UpdateManyUserInput = {
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['JSON']>;
  defaultPage?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  lastActive?: InputMaybe<Scalars['Date']>;
  name?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['JSON']>;
};

export type UpdateManyUserPayload = {
  __typename?: 'UpdateManyUserPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']>;
};

export type User = {
  __typename?: 'User';
  _id: Scalars['MongoID'];
  _role?: Maybe<Role>;
  createdAt?: Maybe<Scalars['Date']>;
  createdBy?: Maybe<Scalars['JSON']>;
  defaultPage?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  lastActive?: Maybe<Scalars['Date']>;
  name?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['MongoID']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<Scalars['JSON']>;
};

export type AttachmentByIdQueryVariables = Exact<{
  id: Scalars['MongoID'];
}>;


export type AttachmentByIdQuery = { __typename?: 'Query', attachments?: { __typename?: 'QueryAttachments', byId?: { __typename?: 'Attachment', _id: any, filename?: string | null, type?: any | null, subtype?: any | null } | null } | null };

export type SearchQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<GlobalSearchFilterArgs>;
}>;


export type SearchQuery = { __typename?: 'Query', search?: { __typename?: 'SearchResultPagination', count?: number | null, items?: Array<{ __typename?: 'SearchResult', _id?: string | null, category?: string | null, score?: number | null, title?: string | null, url?: string | null, badges?: Array<{ __typename?: 'SearchResultBadge', title?: string | null, value?: string | null } | null> | null }> | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, itemCount?: number | null, pageCount?: number | null, perPage: number } } | null };

export type UserSelfQueryVariables = Exact<{ [key: string]: never; }>;


export type UserSelfQuery = { __typename?: 'Query', user?: { __typename?: 'QueryUser', self?: { __typename?: 'User', _id: any, email?: string | null, defaultPage?: string | null, createdBy?: any | null, updatedBy?: any | null, _role?: { __typename?: 'Role', defaultPage?: string | null, title?: string | null, _permissions: Array<{ __typename?: 'Permission', _id: any, key?: string | null } | null> } | null } | null } | null };

export type MutateAnalyticsCreateOneMutationVariables = Exact<{
  record: CreateOneAnalyticsInput;
}>;


export type MutateAnalyticsCreateOneMutation = { __typename?: 'Mutation', analytics?: { __typename?: 'MutationAnalytics', createOne?: { __typename?: 'CreateOneAnalyticsPayload', recordId?: any | null } | null } | null };

export type AttachmentSubtypesQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyAttachment_SubtypeInput>;
}>;


export type AttachmentSubtypesQuery = { __typename?: 'Query', attachmentSubtypes?: { __typename?: 'QueryAttachmentSubtypes', many: Array<{ __typename?: 'Attachment_Subtype', _id: any, name?: string | null }> } | null };

export type AttachmentsQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyAttachmentInput>;
  sort?: InputMaybe<SortFindManyAttachmentInput>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type AttachmentsQuery = { __typename?: 'Query', attachments?: { __typename?: 'QueryAttachments', many: Array<{ __typename?: 'Attachment', _id: any, url?: string | null, filename?: string | null, link?: any | null, updatedAt?: any | null, _subtype?: { __typename?: 'Attachment_Subtype', name?: string | null } | null, _link?: { __typename?: 'Candidate' } | { __typename?: 'Distribution' } | { __typename?: 'Position', id?: string | null, title?: string | null, keywords?: string | null, _contract?: { __typename?: 'Cat_Contract', abbreviation?: string | null } | null } | null, _updatedBy?: { __typename?: 'User', name?: string | null } | null }> } | null };

export type MutateRemoveAttachmentMutationVariables = Exact<{
  id: Scalars['MongoID'];
}>;


export type MutateRemoveAttachmentMutation = { __typename?: 'Mutation', attachments?: { __typename?: 'MutationAttachments', removeById?: { __typename?: 'DeleteByIdAttachmentPayload', recordId?: any | null } | null } | null };

export type MutateUpdateAttachmentMutationVariables = Exact<{
  id: Scalars['MongoID'];
  record: UpdateByIdAttachmentInput;
}>;


export type MutateUpdateAttachmentMutation = { __typename?: 'Mutation', attachments?: { __typename?: 'MutationAttachments', updateById?: { __typename?: 'UpdateByIdAttachmentPayload', recordId?: any | null } | null } | null };

export type CandidateContractualDocumentByIdQueryVariables = Exact<{
  id: Scalars['MongoID'];
}>;


export type CandidateContractualDocumentByIdQuery = { __typename?: 'Query', cat?: { __typename?: 'QueryCat', candidate?: { __typename?: 'QueryCatCandidate', byId?: { __typename?: 'Candidate', _id: any, nda_signed?: { __typename?: 'CandidateNda_signed', staffing_agency?: any | null, candidate?: any | null } | null } | null } | null } | null };

export type CandidateCreatedUpdatedByIdQueryVariables = Exact<{
  id: Scalars['MongoID'];
}>;


export type CandidateCreatedUpdatedByIdQuery = { __typename?: 'Query', cat?: { __typename?: 'QueryCat', candidate?: { __typename?: 'QueryCatCandidate', byId?: { __typename?: 'Candidate', _id: any, createdAt?: any | null, updatedAt?: any | null, _createdBy?: { __typename?: 'User', name?: string | null } | null, _updatedBy?: { __typename?: 'User', name?: string | null } | null } | null } | null } | null };

export type CandidateDetailsByIdQueryVariables = Exact<{
  id: Scalars['MongoID'];
}>;


export type CandidateDetailsByIdQuery = { __typename?: 'Query', cat?: { __typename?: 'QueryCat', candidate?: { __typename?: 'QueryCatCandidate', byId?: { __typename?: 'Candidate', _id: any, location?: string | null, lastFirstName?: string | null, email?: string | null, phone?: string | null, received_on?: any | null, type?: any | null, clearance?: any | null, reapply?: boolean | null, status?: any | null, substatus?: any | null, rejection_date?: any | null, name?: { __typename?: 'CandidateName', first?: string | null, last?: string | null } | null, _position?: { __typename?: 'Position', title?: string | null } | null, address?: { __typename?: 'CandidateAddress', street?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null, _type?: { __typename?: 'Candidate_Type', name?: string | null } | null, _clearance?: { __typename?: 'Clearance', name?: string | null } | null, _status?: { __typename?: 'Candidate_Status', name?: string | null } | null, _substatus?: { __typename?: 'Candidate_Substatus', name?: string | null, color?: string | null } | null } | null } | null } | null };

export type CandidateExhibitByIdQueryVariables = Exact<{
  id: Scalars['MongoID'];
}>;


export type CandidateExhibitByIdQuery = { __typename?: 'Query', cat?: { __typename?: 'QueryCat', candidate?: { __typename?: 'QueryCatCandidate', byId?: { __typename?: 'Candidate', _id: any, exhibit?: { __typename?: 'CandidateExhibit', sent_for_review?: any | null, hm_approved?: any | null, contracts_approved?: any | null, extended?: any | null, signed?: any | null, pmo_approved?: any | null } | null } | null } | null } | null };

export type CandidateInterviewByIdQueryVariables = Exact<{
  id: Scalars['MongoID'];
}>;


export type CandidateInterviewByIdQuery = { __typename?: 'Query', cat?: { __typename?: 'QueryCat', candidate?: { __typename?: 'QueryCatCandidate', byId?: { __typename?: 'Candidate', _id: any, round_1?: any | null, round_2?: any | null, round_3?: any | null } | null } | null } | null };

export type CandidateNotesByIdQueryVariables = Exact<{
  id: Scalars['MongoID'];
}>;


export type CandidateNotesByIdQuery = { __typename?: 'Query', cat?: { __typename?: 'QueryCat', candidate?: { __typename?: 'QueryCatCandidate', byId?: { __typename?: 'Candidate', _id: any, notes?: string | null } | null } | null } | null };

export type CandidateOfferLetterByIdQueryVariables = Exact<{
  id: Scalars['MongoID'];
}>;


export type CandidateOfferLetterByIdQuery = { __typename?: 'Query', cat?: { __typename?: 'QueryCat', candidate?: { __typename?: 'QueryCatCandidate', byId?: { __typename?: 'Candidate', _id: any, offer_letter?: { __typename?: 'CandidateOffer_letter', approved?: any | null, extended?: any | null, signed?: any | null } | null } | null } | null } | null };

export type CandidatePositionDetailsByIdQueryVariables = Exact<{
  id: Scalars['MongoID'];
}>;


export type CandidatePositionDetailsByIdQuery = { __typename?: 'Query', cat?: { __typename?: 'QueryCat', candidate?: { __typename?: 'QueryCatCandidate', byId?: { __typename?: 'Candidate', _id: any, position?: number | null, distribution?: any | null, _position?: { __typename?: 'Position', _id: number, id?: string | null, title?: string | null, _contract?: { __typename?: 'Cat_Contract', _id: any, abbreviation?: string | null } | null } | null, _distribution?: { __typename?: 'Distribution', _id: any, _category?: { __typename?: 'Distribution_Category', name?: string | null } | null, _subcategory?: { __typename?: 'Distribution_Subcategory', name?: string | null } | null } | null } | null } | null } | null };

export type CandidateRatesByIdQueryVariables = Exact<{
  id: Scalars['MongoID'];
}>;


export type CandidateRatesByIdQuery = { __typename?: 'Query', cat?: { __typename?: 'QueryCat', candidate?: { __typename?: 'QueryCatCandidate', byId?: { __typename?: 'Candidate', _id: any, bill_rate?: { __typename?: 'CandidateBill_rate', min?: number | null, max?: number | null } | null, salary?: { __typename?: 'CandidateSalary', min?: number | null, max?: number | null } | null, _position?: { __typename?: 'Position', bill_rate?: { __typename?: 'PositionBill_rate', min?: number | null, max?: number | null } | null, salary?: { __typename?: 'PositionSalary', min?: number | null, max?: number | null } | null } | null } | null } | null } | null };

export type CandidateResumeReviewByIdQueryVariables = Exact<{
  id: Scalars['MongoID'];
}>;


export type CandidateResumeReviewByIdQuery = { __typename?: 'Query', cat?: { __typename?: 'QueryCat', candidate?: { __typename?: 'QueryCatCandidate', byId?: { __typename?: 'Candidate', _id: any, rank?: any | null, resume?: { __typename?: 'CandidateResume', sent?: any | null, reviewed?: any | null, reviewed_by?: any | null, _reviewed_by?: { __typename?: 'Hiring_Manager', name?: string | null } | null } | null, _rank?: { __typename?: 'Candidate_Rank', name?: string | null } | null } | null } | null } | null };

export type CandidatesQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyCandidateInput>;
}>;


export type CandidatesQuery = { __typename?: 'Query', cat?: { __typename?: 'QueryCat', candidate?: { __typename?: 'QueryCatCandidate', many: Array<{ __typename?: 'Candidate', _id: any, attachments_count?: number | null, round_1?: any | null, round_2?: any | null, round_3?: any | null, resume?: { __typename?: 'CandidateResume', sent?: any | null } | null, name?: { __typename?: 'CandidateName', first?: string | null, last?: string | null } | null, _distribution?: { __typename?: 'Distribution', _category?: { __typename?: 'Distribution_Category', name?: string | null } | null, _subcategory?: { __typename?: 'Distribution_Subcategory', _id: any, name?: string | null } | null } | null, _status?: { __typename?: 'Candidate_Status', name?: string | null } | null, _substatus?: { __typename?: 'Candidate_Substatus', name?: string | null, color?: string | null } | null, bill_rate?: { __typename?: 'CandidateBill_rate', min?: number | null, max?: number | null } | null, salary?: { __typename?: 'CandidateSalary', min?: number | null, max?: number | null } | null }> } | null } | null };

export type CandidatesByNameQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyCandidateInput>;
}>;


export type CandidatesByNameQuery = { __typename?: 'Query', cat?: { __typename?: 'QueryCat', candidate?: { __typename?: 'QueryCatCandidate', many: Array<{ __typename?: 'Candidate', _id: any, name?: { __typename?: 'CandidateName', first?: string | null, last?: string | null } | null, _position?: { __typename?: 'Position', id?: string | null, title?: string | null } | null }> } | null } | null };

export type MutateCandidateByIdMutationVariables = Exact<{
  id: Scalars['MongoID'];
  record: UpdateByIdCandidateInput;
}>;


export type MutateCandidateByIdMutation = { __typename?: 'Mutation', cat?: { __typename?: 'MutationCat', candidate?: { __typename?: 'MutationCatCandidate', updateById?: { __typename?: 'UpdateByIdCandidatePayload', recordId?: any | null } | null } | null } | null };

export type MutateCopyCandidateMutationVariables = Exact<{
  id: Scalars['MongoID'];
  position: Scalars['Int'];
  distribution: Scalars['MongoID'];
  name: CopyCandidateNameInput;
  details?: InputMaybe<Scalars['Boolean']>;
  contact?: InputMaybe<Scalars['Boolean']>;
  rates?: InputMaybe<Scalars['Boolean']>;
  notes?: InputMaybe<Scalars['Boolean']>;
  attachments?: InputMaybe<Scalars['Boolean']>;
}>;


export type MutateCopyCandidateMutation = { __typename?: 'Mutation', cat?: { __typename?: 'MutationCat', candidate?: { __typename?: 'MutationCatCandidate', copy?: { __typename?: 'CopyCandidateResults', recordId: any } | null } | null } | null };

export type MutateCreateCandidateMutationVariables = Exact<{
  record: CreateOneCandidateInput;
}>;


export type MutateCreateCandidateMutation = { __typename?: 'Mutation', cat?: { __typename?: 'MutationCat', candidate?: { __typename?: 'MutationCatCandidate', createOne?: { __typename?: 'CreateOneCandidatePayload', recordId?: any | null } | null } | null } | null };

export type MutateRemoveCandidateByIdMutationVariables = Exact<{
  id: Scalars['MongoID'];
}>;


export type MutateRemoveCandidateByIdMutation = { __typename?: 'Mutation', cat?: { __typename?: 'MutationCat', candidate?: { __typename?: 'MutationCatCandidate', removeById?: { __typename?: 'DeleteByIdCandidatePayload', recordId?: any | null } | null } | null } | null };

export type ContractDetailsByIdQueryVariables = Exact<{
  id: Scalars['MongoID'];
}>;


export type ContractDetailsByIdQuery = { __typename?: 'Query', cat?: { __typename?: 'QueryCat', contract?: { __typename?: 'QueryCatContract', byId?: { __typename?: 'Cat_Contract', _id: any, name?: string | null, abbreviation?: string | null, teamSize?: number | null, status?: any | null, prime?: boolean | null, subcontractor?: string | null, vehicle?: any | null, portfolio_manager?: any | null, program_manager?: any | null, _vehicle?: { __typename?: 'Contract_Vehicle', _id: any, name?: string | null } | null, _status?: { __typename?: 'Contract_Status', _id: any, name?: string | null } | null, _portfolio_manager?: { __typename?: 'Portfolio_Manager', _id: any, name?: string | null } | null, _program_manager?: { __typename?: 'Program_Manager', _id: any, name?: string | null } | null, primary_address?: { __typename?: 'Cat_ContractPrimary_address', street?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null } | null } | null } | null };

export type ContractNotesByIdQueryVariables = Exact<{
  id: Scalars['MongoID'];
}>;


export type ContractNotesByIdQuery = { __typename?: 'Query', cat?: { __typename?: 'QueryCat', contract?: { __typename?: 'QueryCatContract', byId?: { __typename?: 'Cat_Contract', _id: any, notes?: string | null } | null } | null } | null };

export type ContractOnboardingByIdQueryVariables = Exact<{
  id: Scalars['MongoID'];
}>;


export type ContractOnboardingByIdQuery = { __typename?: 'Query', cat?: { __typename?: 'QueryCat', contract?: { __typename?: 'QueryCatContract', byId?: { __typename?: 'Cat_Contract', _id: any, onboarding?: { __typename?: 'Cat_ContractOnboarding', days?: string | null, clearanceReqs?: boolean | null, biProcessTimeframe?: string | null, gfeProvided?: boolean | null, imcEquipment?: boolean | null } | null } | null } | null } | null };

export type ContractPopByIdQueryVariables = Exact<{
  id: Scalars['MongoID'];
}>;


export type ContractPopByIdQuery = { __typename?: 'Query', cat?: { __typename?: 'QueryCat', contract?: { __typename?: 'QueryCatContract', byId?: { __typename?: 'Cat_Contract', _id: any, pop?: { __typename?: 'Cat_ContractPop', status?: string | null, base?: { __typename?: 'Cat_ContractPopBase', start?: any | null, end?: any | null } | null, options?: Array<{ __typename?: 'Cat_ContractPopOptions', start?: any | null, end?: any | null } | null> | null, extensions?: Array<{ __typename?: 'Cat_ContractPopExtensions', start?: any | null, end?: any | null } | null> | null } | null } | null } | null } | null };

export type ContractPositionCountsByIdQueryVariables = Exact<{
  id: Scalars['MongoID'];
}>;


export type ContractPositionCountsByIdQuery = { __typename?: 'Query', cat?: { __typename?: 'QueryCat', contract?: { __typename?: 'QueryCatContract', countByPositionStatus?: Array<{ __typename?: 'PositionStatusCount', status?: string | null, count?: number | null } | null> | null } | null } | null };

export type ContractsQueryVariables = Exact<{
  sort?: InputMaybe<SortFindManyCat_ContractInput>;
  withPositionCount: Scalars['Boolean'];
}>;


export type ContractsQuery = { __typename?: 'Query', cat?: { __typename?: 'QueryCat', contract?: { __typename?: 'QueryCatContract', many: Array<{ __typename?: 'Cat_Contract', _id: any, name?: string | null, abbreviation?: string | null, position_count?: number | null, _status?: { __typename?: 'Contract_Status', name?: string | null, color?: string | null } | null, _portfolio_manager?: { __typename?: 'Portfolio_Manager', name?: string | null } | null, _program_manager?: { __typename?: 'Program_Manager', name?: string | null } | null }> } | null } | null };

export type MutateContractByIdMutationVariables = Exact<{
  id: Scalars['MongoID'];
  record: UpdateByIdCat_ContractInput;
}>;


export type MutateContractByIdMutation = { __typename?: 'Mutation', cat?: { __typename?: 'MutationCat', contract?: { __typename?: 'MutationCatContract', updateById?: { __typename?: 'UpdateByIdCat_ContractPayload', recordId?: any | null } | null } | null } | null };

export type MutateCreateContractMutationVariables = Exact<{
  record: CreateOneCat_ContractInput;
}>;


export type MutateCreateContractMutation = { __typename?: 'Mutation', cat?: { __typename?: 'MutationCat', contract?: { __typename?: 'MutationCatContract', createOne?: { __typename?: 'CreateOneCat_ContractPayload', recordId?: any | null } | null } | null } | null };

export type ContractInterviewerByIdQueryVariables = Exact<{
  id: Scalars['MongoID'];
}>;


export type ContractInterviewerByIdQuery = { __typename?: 'Query', cat?: { __typename?: 'QueryCat', contractInterviewer?: { __typename?: 'QueryCatContractInterviewer', byId?: { __typename?: 'ContractInterviewer', _id: any, name?: string | null, title?: string | null, email?: string | null } | null } | null } | null };

export type ContractInterviewersQueryVariables = Exact<{
  sort?: InputMaybe<SortFindManyContractInterviewerInput>;
  filter?: InputMaybe<FilterFindManyContractInterviewerInput>;
}>;


export type ContractInterviewersQuery = { __typename?: 'Query', cat?: { __typename?: 'QueryCat', contractInterviewer?: { __typename?: 'QueryCatContractInterviewer', many: Array<{ __typename?: 'ContractInterviewer', _id: any, name?: string | null, title?: string | null, email?: string | null }> } | null } | null };

export type MutateContractInterviewerByIdMutationVariables = Exact<{
  id: Scalars['MongoID'];
  record: UpdateByIdContractInterviewerInput;
}>;


export type MutateContractInterviewerByIdMutation = { __typename?: 'Mutation', cat?: { __typename?: 'MutationCat', contractInterviewer?: { __typename?: 'MutationCatContractInterviewer', updateById?: { __typename?: 'UpdateByIdContractInterviewerPayload', recordId?: any | null } | null } | null } | null };

export type MutateCreateContractInterviewerMutationVariables = Exact<{
  record: CreateOneContractInterviewerInput;
}>;


export type MutateCreateContractInterviewerMutation = { __typename?: 'Mutation', cat?: { __typename?: 'MutationCat', contractInterviewer?: { __typename?: 'MutationCatContractInterviewer', createOne?: { __typename?: 'CreateOneContractInterviewerPayload', recordId?: any | null } | null } | null } | null };

export type MutateDeleteContractInterviewerByIdMutationVariables = Exact<{
  id: Scalars['MongoID'];
}>;


export type MutateDeleteContractInterviewerByIdMutation = { __typename?: 'Mutation', cat?: { __typename?: 'MutationCat', contractInterviewer?: { __typename?: 'MutationCatContractInterviewer', deleteById?: { __typename?: 'DeleteByIdContractInterviewerPayload', recordId?: any | null } | null } | null } | null };

export type DistributionCreatedUpdatedByIdQueryVariables = Exact<{
  id: Scalars['MongoID'];
}>;


export type DistributionCreatedUpdatedByIdQuery = { __typename?: 'Query', cat?: { __typename?: 'QueryCat', distribution?: { __typename?: 'QueryCatDistribution', byId?: { __typename?: 'Distribution', _id: any, createdAt?: any | null, updatedAt?: any | null, _createdBy?: { __typename?: 'User', name?: string | null } | null, _updatedBy?: { __typename?: 'User', name?: string | null } | null } | null } | null } | null };

export type DistributionDetailsByIdQueryVariables = Exact<{
  id: Scalars['MongoID'];
}>;


export type DistributionDetailsByIdQuery = { __typename?: 'Query', cat?: { __typename?: 'QueryCat', distribution?: { __typename?: 'QueryCatDistribution', byId?: { __typename?: 'Distribution', _id: any, category?: any | null, subcategory?: any | null, position?: number | null, date_posted?: any | null, _category?: { __typename?: 'Distribution_Category', name?: string | null } | null, _subcategory?: { __typename?: 'Distribution_Subcategory', name?: string | null } | null, _position?: { __typename?: 'Position', _id: number, id?: string | null, title?: string | null, _contract?: { __typename?: 'Cat_Contract', _id: any, abbreviation?: string | null } | null } | null } | null } | null } | null };

export type DistributionNotesByIdQueryVariables = Exact<{
  id: Scalars['MongoID'];
}>;


export type DistributionNotesByIdQuery = { __typename?: 'Query', cat?: { __typename?: 'QueryCat', distribution?: { __typename?: 'QueryCatDistribution', byId?: { __typename?: 'Distribution', _id: any, notes?: string | null } | null } | null } | null };

export type DistributionsByPositionIdQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyDistributionInput>;
}>;


export type DistributionsByPositionIdQuery = { __typename?: 'Query', cat?: { __typename?: 'QueryCat', distribution?: { __typename?: 'QueryCatDistribution', many: Array<{ __typename?: 'Distribution', _id: any, attachments_count?: number | null, date_posted?: any | null, candidate_count?: number | null, _category?: { __typename?: 'Distribution_Category', name?: string | null } | null, _subcategory?: { __typename?: 'Distribution_Subcategory', _id: any, name?: string | null } | null }> } | null } | null };

export type DistributionsOverviewQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyDistributionInput>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type DistributionsOverviewQuery = { __typename?: 'Query', cat?: { __typename?: 'QueryCat', distribution?: { __typename?: 'QueryCatDistribution', many: Array<{ __typename?: 'Distribution', _id: any, date_posted?: any | null, candidate_count?: number | null, _category?: { __typename?: 'Distribution_Category', name?: string | null } | null, _subcategory?: { __typename?: 'Distribution_Subcategory', _id: any, name?: string | null } | null, _position?: { __typename?: 'Position', _id: number, id?: string | null, title?: string | null, bill_rate?: { __typename?: 'PositionBill_rate', max?: number | null } | null, salary?: { __typename?: 'PositionSalary', max?: number | null } | null, _status?: { __typename?: 'Position_Status', _id: any, name?: string | null } | null, _contract?: { __typename?: 'Cat_Contract', _id: any, abbreviation?: string | null } | null } | null }> } | null } | null };

export type MutateCreateManyDistributionsMutationVariables = Exact<{
  records: Array<CreateManyDistributionInput> | CreateManyDistributionInput;
}>;


export type MutateCreateManyDistributionsMutation = { __typename?: 'Mutation', cat?: { __typename?: 'MutationCat', distribution?: { __typename?: 'MutationCatDistribution', createMany?: { __typename?: 'CreateManyDistributionPayload', recordIds: Array<any> } | null } | null } | null };

export type MutateDistributionByIdMutationVariables = Exact<{
  id: Scalars['MongoID'];
  record: UpdateByIdDistributionInput;
}>;


export type MutateDistributionByIdMutation = { __typename?: 'Mutation', cat?: { __typename?: 'MutationCat', distribution?: { __typename?: 'MutationCatDistribution', updateById?: { __typename?: 'UpdateByIdDistributionPayload', recordId?: any | null } | null } | null } | null };

export type MutateRemoveDistributionByIdMutationVariables = Exact<{
  id: Scalars['MongoID'];
}>;


export type MutateRemoveDistributionByIdMutation = { __typename?: 'Mutation', cat?: { __typename?: 'MutationCat', distribution?: { __typename?: 'MutationCatDistribution', removeById?: { __typename?: 'DeleteByIdDistributionPayload', recordId?: any | null } | null } | null } | null };

export type StaffingAgenciesQueryVariables = Exact<{
  sort?: InputMaybe<SortFindManyDistribution_SubcategoryInput>;
  filter?: InputMaybe<FilterFindManyDistribution_SubcategoryInput>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type StaffingAgenciesQuery = { __typename?: 'Query', cat?: { __typename?: 'QueryCat', distributionSubcategory?: { __typename?: 'QueryCatDistributionSubcategory', many: Array<{ __typename?: 'Distribution_Subcategory', _id: any, name?: string | null, position_count?: number | null, _status?: { __typename?: 'DistributionSubcategoryStatus', _id: any, name?: string | null, color?: string | null } | null, staffingAgency?: { __typename?: 'Distribution_SubcategoryStaffingAgency', sdvosb?: boolean | null } | null }> } | null } | null };

export type StaffingAgencyBenefitsByIdQueryVariables = Exact<{
  id: Scalars['MongoID'];
}>;


export type StaffingAgencyBenefitsByIdQuery = { __typename?: 'Query', cat?: { __typename?: 'QueryCat', distributionSubcategory?: { __typename?: 'QueryCatDistributionSubcategory', byId?: { __typename?: 'Distribution_Subcategory', _id: any, staffingAgency?: { __typename?: 'Distribution_SubcategoryStaffingAgency', benefits?: { __typename?: 'Distribution_SubcategoryStaffingAgencyBenefits', payrollRunTime?: string | null, healthBenefits?: boolean | null, pto?: string | null, holidays?: Array<any | null> | null, _holidays: Array<{ __typename?: 'StaffingAgencyHoliday', _id: any, name?: string | null }> } | null } | null } | null } | null } | null };

export type StaffingAgencyDetailsByIdQueryVariables = Exact<{
  id: Scalars['MongoID'];
}>;


export type StaffingAgencyDetailsByIdQuery = { __typename?: 'Query', cat?: { __typename?: 'QueryCat', distributionSubcategory?: { __typename?: 'QueryCatDistributionSubcategory', byId?: { __typename?: 'Distribution_Subcategory', _id: any, name?: string | null, status?: any | null, _status?: { __typename?: 'DistributionSubcategoryStatus', _id: any, name?: string | null, color?: string | null } | null, staffingAgency?: { __typename?: 'Distribution_SubcategoryStaffingAgency', sdvosb?: boolean | null, clearedFacility?: any | null, _clearedFacility?: { __typename?: 'StaffingAgencyClearedFacility', _id: any, name?: string | null } | null } | null } | null } | null } | null };

export type StaffingAgencyMsaByIdQueryVariables = Exact<{
  id: Scalars['MongoID'];
}>;


export type StaffingAgencyMsaByIdQuery = { __typename?: 'Query', cat?: { __typename?: 'QueryCat', distributionSubcategory?: { __typename?: 'QueryCatDistributionSubcategory', byId?: { __typename?: 'Distribution_Subcategory', _id: any, staffingAgency?: { __typename?: 'Distribution_SubcategoryStaffingAgency', msa?: { __typename?: 'Distribution_SubcategoryStaffingAgencyMsa', dateSigned?: any | null, conversionTimeframe?: string | null, conversionFees?: string | null, dhAvailable?: boolean | null, dhWarranty?: string | null, nonSolicitationDuration?: string | null } | null } | null } | null } | null } | null };

export type StaffingAgencyRemitDetailsByIdQueryVariables = Exact<{
  id: Scalars['MongoID'];
}>;


export type StaffingAgencyRemitDetailsByIdQuery = { __typename?: 'Query', cat?: { __typename?: 'QueryCat', distributionSubcategory?: { __typename?: 'QueryCatDistributionSubcategory', byId?: { __typename?: 'Distribution_Subcategory', _id: any, staffingAgency?: { __typename?: 'Distribution_SubcategoryStaffingAgency', remit?: { __typename?: 'Distribution_SubcategoryStaffingAgencyRemit', name?: string | null, paymentDetails?: string | null, paymentTerms?: string | null, address?: { __typename?: 'Distribution_SubcategoryStaffingAgencyRemitAddress', street?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null } | null } | null } | null } | null } | null };

export type DistributionSubcategoriesQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyDistribution_SubcategoryInput>;
  sort?: InputMaybe<SortFindManyDistribution_SubcategoryInput>;
}>;


export type DistributionSubcategoriesQuery = { __typename?: 'Query', cat?: { __typename?: 'QueryCat', distributionSubcategory?: { __typename?: 'QueryCatDistributionSubcategory', many: Array<{ __typename?: 'Distribution_Subcategory', _id: any, name?: string | null }> } | null } | null };

export type DistributionSubcategoriesAndCategoriesQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyDistribution_SubcategoryInput>;
  sort?: InputMaybe<SortFindManyDistribution_SubcategoryInput>;
}>;


export type DistributionSubcategoriesAndCategoriesQuery = { __typename?: 'Query', cat?: { __typename?: 'QueryCat', distributionSubcategory?: { __typename?: 'QueryCatDistributionSubcategory', many: Array<{ __typename?: 'Distribution_Subcategory', _id: any, name?: string | null, _category?: { __typename?: 'Distribution_Category', _id: any, name?: string | null } | null }> } | null } | null };

export type DistributionSubcategoryCreatedUpdatedByIdQueryVariables = Exact<{
  id: Scalars['MongoID'];
}>;


export type DistributionSubcategoryCreatedUpdatedByIdQuery = { __typename?: 'Query', cat?: { __typename?: 'QueryCat', distributionSubcategory?: { __typename?: 'QueryCatDistributionSubcategory', byId?: { __typename?: 'Distribution_Subcategory', _id: any, createdAt?: any | null, updatedAt?: any | null, _createdBy?: { __typename?: 'User', name?: string | null } | null, _updatedBy?: { __typename?: 'User', name?: string | null } | null } | null } | null } | null };

export type DistributionSubcategoryNotesByIdQueryVariables = Exact<{
  id: Scalars['MongoID'];
}>;


export type DistributionSubcategoryNotesByIdQuery = { __typename?: 'Query', cat?: { __typename?: 'QueryCat', distributionSubcategory?: { __typename?: 'QueryCatDistributionSubcategory', byId?: { __typename?: 'Distribution_Subcategory', _id: any, notes?: string | null } | null } | null } | null };

export type MutateDistributionSubcategoryByIdMutationVariables = Exact<{
  id: Scalars['MongoID'];
  record: UpdateByIdDistribution_SubcategoryInput;
}>;


export type MutateDistributionSubcategoryByIdMutation = { __typename?: 'Mutation', cat?: { __typename?: 'MutationCat', distributionSubcategory?: { __typename?: 'MutationCatDistributionSubcategory', updateById?: { __typename?: 'UpdateByIdDistribution_SubcategoryPayload', recordId?: any | null } | null } | null } | null };

export type EeocByCandidateQueryVariables = Exact<{
  candidate: Scalars['MongoID'];
}>;


export type EeocByCandidateQuery = { __typename?: 'Query', cat?: { __typename?: 'QueryCat', eeoc?: { __typename?: 'QueryCatEeoc', findEeocByCandidate?: { __typename?: 'Eeoc', _id: any, status?: EnumEeocStatus | null, createdAt?: any | null, signedOn?: any | null, documents?: string | null, voidedOn?: any | null, voidReason?: string | null } | null } | null } | null };

export type EeocDocByIdQueryVariables = Exact<{
  id: Scalars['MongoID'];
}>;


export type EeocDocByIdQuery = { __typename?: 'Query', cat?: { __typename?: 'QueryCat', eeoc?: { __typename?: 'QueryCatEeoc', byId?: { __typename?: 'Eeoc', _id: any, envelope?: string | null, documents?: string | null, _candidate?: { __typename?: 'Candidate', lastFirstName?: string | null } | null } | null } | null } | null };

export type EeocsQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyEeocInput>;
  sort?: InputMaybe<SortFindManyEeocInput>;
}>;


export type EeocsQuery = { __typename?: 'Query', cat?: { __typename?: 'QueryCat', eeoc?: { __typename?: 'QueryCatEeoc', many: Array<{ __typename?: 'Eeoc', _id: any, createdAt?: any | null, candidate?: any | null, signedOn?: any | null, status?: EnumEeocStatus | null, documentData?: any | null, voidReason?: string | null, voidedOn?: any | null, _candidate?: { __typename?: 'Candidate', _id: any, lastFirstName?: string | null } | null }> } | null } | null };

export type MutateSendEeocByCandidateMutationVariables = Exact<{
  candidate: Scalars['MongoID'];
  voidReason?: InputMaybe<Scalars['String']>;
}>;


export type MutateSendEeocByCandidateMutation = { __typename?: 'Mutation', cat?: { __typename?: 'MutationCat', eeoc?: { __typename?: 'MutationCatEeoc', sendEeocByCandidate?: { __typename?: 'Eeoc', _id: any, candidate?: any | null } | null } | null } | null };

export type MutateVoidEeocByCandidateMutationVariables = Exact<{
  candidate: Scalars['MongoID'];
  voidReason: Scalars['String'];
}>;


export type MutateVoidEeocByCandidateMutation = { __typename?: 'Mutation', cat?: { __typename?: 'MutationCat', eeoc?: { __typename?: 'MutationCatEeoc', voidEeocByCandidate?: { __typename?: 'Eeoc', _id: any, candidate?: any | null } | null } | null } | null };

export type LookupConfigQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type LookupConfigQuery = { __typename?: 'Query', lookups?: { __typename?: 'QueryLookups', config?: { __typename?: 'QueryLookupsConfig', byId?: { __typename?: 'LookupConfig', _id: string, name?: string | null, fields?: Array<{ __typename?: 'LookupConfigFields', title?: string | null, key?: string | null, component?: { __typename?: 'LookupConfigFieldsComponent', type?: string | null, props?: any | null } | null } | null> | null, relationships?: Array<{ __typename?: 'LookupConfigRelationships', model?: string | null, title?: string | null, key?: string | null, link?: string | null } | null> | null } | null } | null } | null };

export type LookupConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type LookupConfigsQuery = { __typename?: 'Query', lookups?: { __typename?: 'QueryLookups', config?: { __typename?: 'QueryLookupsConfig', many: Array<{ __typename?: 'LookupConfig', _id: string, name?: string | null, optionsCount?: number | null, fields?: Array<{ __typename?: 'LookupConfigFields', title?: string | null, key?: string | null, component?: { __typename?: 'LookupConfigFieldsComponent', type?: string | null, props?: any | null } | null } | null> | null, relationships?: Array<{ __typename?: 'LookupConfigRelationships', model?: string | null, title?: string | null, key?: string | null, link?: string | null } | null> | null }> } | null } | null };

export type LookupRelationshipsQueryVariables = Exact<{
  key: Scalars['String'];
  relationshipModel: Scalars['String'];
  id: Scalars['MongoID'];
  page?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type LookupRelationshipsQuery = { __typename?: 'Query', lookups?: { __typename?: 'QueryLookups', relationships: { __typename?: 'LookupOptionRelationships', count?: number | null, items?: Array<{ __typename?: 'LookupOptionRelationshipItems', _id?: any | null, link?: string | null, title?: string | null }> | null, pageInfo: { __typename?: 'LookupOptionRelationshipPageInfo', currentPage?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, pageCount?: number | null, limit?: number | null, totalCount?: number | null } } } | null };

export type CandidateRanksQueryVariables = Exact<{
  sort?: InputMaybe<SortFindManyCandidate_RankInput>;
}>;


export type CandidateRanksQuery = { __typename?: 'Query', lookups?: { __typename?: 'QueryLookups', Candidate_Rank?: { __typename?: 'QueryLookupsCandidate_Rank', many: Array<{ __typename?: 'Candidate_Rank', _id: any, name?: string | null }> } | null } | null };

export type CandidateStatusesQueryVariables = Exact<{
  sort?: InputMaybe<SortFindManyCandidate_StatusInput>;
}>;


export type CandidateStatusesQuery = { __typename?: 'Query', lookups?: { __typename?: 'QueryLookups', Candidate_Status?: { __typename?: 'QueryLookupsCandidate_Status', many: Array<{ __typename?: 'Candidate_Status', _id: any, name?: string | null }> } | null } | null };

export type CandidateSubstatusesQueryVariables = Exact<{
  sort?: InputMaybe<SortFindManyCandidate_SubstatusInput>;
  filter?: InputMaybe<FilterFindManyCandidate_SubstatusInput>;
}>;


export type CandidateSubstatusesQuery = { __typename?: 'Query', lookups?: { __typename?: 'QueryLookups', Candidate_Substatus?: { __typename?: 'QueryLookupsCandidate_Substatus', many: Array<{ __typename?: 'Candidate_Substatus', _id: any, name?: string | null }> } | null } | null };

export type CandidateTypesQueryVariables = Exact<{
  sort?: InputMaybe<SortFindManyCandidate_TypeInput>;
}>;


export type CandidateTypesQuery = { __typename?: 'Query', lookups?: { __typename?: 'QueryLookups', Candidate_Type?: { __typename?: 'QueryLookupsCandidate_Type', many: Array<{ __typename?: 'Candidate_Type', _id: any, name?: string | null }> } | null } | null };

export type ClearancesQueryVariables = Exact<{
  sort?: InputMaybe<SortFindManyClearanceInput>;
}>;


export type ClearancesQuery = { __typename?: 'Query', lookups?: { __typename?: 'QueryLookups', Clearance?: { __typename?: 'QueryLookupsClearance', many: Array<{ __typename?: 'Clearance', _id: any, name?: string | null }> } | null } | null };

export type ContractStatusesQueryVariables = Exact<{
  sort?: InputMaybe<SortFindManyContract_StatusInput>;
}>;


export type ContractStatusesQuery = { __typename?: 'Query', lookups?: { __typename?: 'QueryLookups', Contract_Status?: { __typename?: 'QueryLookupsContract_Status', many: Array<{ __typename?: 'Contract_Status', _id: any, name?: string | null, order?: string | null }> } | null } | null };

export type ContractTypesQueryVariables = Exact<{
  sort?: InputMaybe<SortFindManyContract_TypeInput>;
}>;


export type ContractTypesQuery = { __typename?: 'Query', lookups?: { __typename?: 'QueryLookups', Contract_Type?: { __typename?: 'QueryLookupsContract_Type', many: Array<{ __typename?: 'Contract_Type', _id: any, name?: string | null }> } | null } | null };

export type ContractVehiclesQueryVariables = Exact<{
  sort?: InputMaybe<SortFindManyContract_VehicleInput>;
}>;


export type ContractVehiclesQuery = { __typename?: 'Query', lookups?: { __typename?: 'QueryLookups', Contract_Vehicle?: { __typename?: 'QueryLookupsContract_Vehicle', many: Array<{ __typename?: 'Contract_Vehicle', _id: any, name?: string | null }> } | null } | null };

export type DistributionCategoriesQueryVariables = Exact<{
  sort?: InputMaybe<SortFindManyDistribution_CategoryInput>;
}>;


export type DistributionCategoriesQuery = { __typename?: 'Query', lookups?: { __typename?: 'QueryLookups', Distribution_Category?: { __typename?: 'QueryLookupsDistribution_Category', many: Array<{ __typename?: 'Distribution_Category', _id: any, name?: string | null }> } | null } | null };

export type DistributionSubcategoryStatusesQueryVariables = Exact<{
  sort?: InputMaybe<SortFindManyDistributionSubcategoryStatusInput>;
}>;


export type DistributionSubcategoryStatusesQuery = { __typename?: 'Query', lookups?: { __typename?: 'QueryLookups', DistributionSubcategoryStatus?: { __typename?: 'QueryLookupsDistributionSubcategoryStatus', many: Array<{ __typename?: 'DistributionSubcategoryStatus', _id: any, name?: string | null }> } | null } | null };

export type HiringManagersQueryVariables = Exact<{
  sort?: InputMaybe<SortFindManyHiring_ManagerInput>;
}>;


export type HiringManagersQuery = { __typename?: 'Query', lookups?: { __typename?: 'QueryLookups', Hiring_Manager?: { __typename?: 'QueryLookupsHiring_Manager', many: Array<{ __typename?: 'Hiring_Manager', _id: any, name?: string | null }> } | null } | null };

export type LookupOptionsQueryVariables = Exact<{
  key: Scalars['String'];
}>;


export type LookupOptionsQuery = { __typename?: 'Query', lookups?: { __typename?: 'QueryLookups', all?: Array<{ __typename?: 'AllLookupQuery', _id: any, abbreviation?: string | null, archived?: boolean | null, color?: string | null, createdAt?: any | null, name?: string | null, oldOrder?: string | null, order?: string | null, status?: any | null, updatedAt?: any | null, relationships?: Array<{ __typename?: 'LookupRelationships', model?: string | null, label?: string | null, count?: number | null }> | null, _createdBy?: { __typename?: 'User', name?: string | null } | null, _updatedBy?: { __typename?: 'User', name?: string | null } | null }> | null } | null };

export type MutateCreateLookupOptionMutationVariables = Exact<{
  key: Scalars['String'];
  record: Scalars['JSON'];
}>;


export type MutateCreateLookupOptionMutation = { __typename?: 'Mutation', lookups?: { __typename?: 'MutationLookups', create?: { __typename?: 'AllLookupQuery', _id: any } | null } | null };

export type MutateDeleteLookupOptionMutationVariables = Exact<{
  key: Scalars['String'];
  id: Scalars['MongoID'];
}>;


export type MutateDeleteLookupOptionMutation = { __typename?: 'Mutation', lookups?: { __typename?: 'MutationLookups', delete?: { __typename?: 'AllLookupMutationDeleteResponse', deletedCount?: number | null } | null } | null };

export type MutateUpdateLookupOptionMutationVariables = Exact<{
  key: Scalars['String'];
  id: Scalars['MongoID'];
  record: Scalars['JSON'];
}>;


export type MutateUpdateLookupOptionMutation = { __typename?: 'Mutation', lookups?: { __typename?: 'MutationLookups', update?: { __typename?: 'AllLookupQuery', _id: any } | null } | null };

export type PortfolioManagersQueryVariables = Exact<{
  sort?: InputMaybe<SortFindManyPortfolio_ManagerInput>;
}>;


export type PortfolioManagersQuery = { __typename?: 'Query', lookups?: { __typename?: 'QueryLookups', Portfolio_Manager?: { __typename?: 'QueryLookupsPortfolio_Manager', many: Array<{ __typename?: 'Portfolio_Manager', _id: any, name?: string | null }> } | null } | null };

export type PositionExemptStatusesQueryVariables = Exact<{
  sort?: InputMaybe<SortFindManyPosition_Exempt_StatusInput>;
}>;


export type PositionExemptStatusesQuery = { __typename?: 'Query', lookups?: { __typename?: 'QueryLookups', Position_Exempt_Status?: { __typename?: 'QueryLookupsPosition_Exempt_Status', many: Array<{ __typename?: 'Position_Exempt_Status', _id: any, name?: string | null }> } | null } | null };

export type PositionFilterLookupsQueryVariables = Exact<{
  ContractFilter?: InputMaybe<FilterFindManyCat_ContractInput>;
  StatusFilter?: InputMaybe<FilterFindManyPosition_StatusInput>;
  ContractTypeFilter?: InputMaybe<FilterFindManyContract_TypeInput>;
  ContractSort?: InputMaybe<SortFindManyCat_ContractInput>;
  StatusSort?: InputMaybe<SortFindManyPosition_StatusInput>;
  ContractTypeSort?: InputMaybe<SortFindManyContract_TypeInput>;
}>;


export type PositionFilterLookupsQuery = { __typename?: 'Query', lookups?: { __typename?: 'QueryLookups', Position_Status?: { __typename?: 'QueryLookupsPosition_Status', many: Array<{ __typename?: 'Position_Status', _id: any, name?: string | null }> } | null, Contract_Type?: { __typename?: 'QueryLookupsContract_Type', many: Array<{ __typename?: 'Contract_Type', _id: any, name?: string | null }> } | null } | null, cat?: { __typename?: 'QueryCat', contract?: { __typename?: 'QueryCatContract', many: Array<{ __typename?: 'Cat_Contract', _id: any, abbreviation?: string | null }> } | null } | null };

export type PositionPrioritiesQueryVariables = Exact<{
  sort?: InputMaybe<SortFindManyPosition_PriorityInput>;
}>;


export type PositionPrioritiesQuery = { __typename?: 'Query', lookups?: { __typename?: 'QueryLookups', Position_Priority?: { __typename?: 'QueryLookupsPosition_Priority', many: Array<{ __typename?: 'Position_Priority', _id: any, name?: string | null }> } | null } | null };

export type PositionStatusesQueryVariables = Exact<{
  sort?: InputMaybe<SortFindManyPosition_StatusInput>;
}>;


export type PositionStatusesQuery = { __typename?: 'Query', lookups?: { __typename?: 'QueryLookups', Position_Status?: { __typename?: 'QueryLookupsPosition_Status', many: Array<{ __typename?: 'Position_Status', _id: any, name?: string | null, order?: string | null, _category?: { __typename?: 'PositionStatusCategory', name?: string | null } | null }> } | null } | null };

export type PositionWorkSettingsQueryVariables = Exact<{
  sort?: InputMaybe<SortFindManyPositionWorkSettingInput>;
}>;


export type PositionWorkSettingsQuery = { __typename?: 'Query', lookups?: { __typename?: 'QueryLookups', PositionWorkSetting?: { __typename?: 'QueryLookupsPositionWorkSetting', many: Array<{ __typename?: 'PositionWorkSetting', _id: any, name?: string | null }> } | null } | null };

export type ProgramManagersQueryVariables = Exact<{
  sort?: InputMaybe<SortFindManyProgram_ManagerInput>;
}>;


export type ProgramManagersQuery = { __typename?: 'Query', lookups?: { __typename?: 'QueryLookups', Program_Manager?: { __typename?: 'QueryLookupsProgram_Manager', many: Array<{ __typename?: 'Program_Manager', _id: any, name?: string | null }> } | null } | null };

export type StaffingAgencyClearedFacilitiesQueryVariables = Exact<{
  sort?: InputMaybe<SortFindManyStaffingAgencyClearedFacilityInput>;
}>;


export type StaffingAgencyClearedFacilitiesQuery = { __typename?: 'Query', lookups?: { __typename?: 'QueryLookups', StaffingAgencyClearedFacility?: { __typename?: 'QueryLookupsStaffingAgencyClearedFacility', many: Array<{ __typename?: 'StaffingAgencyClearedFacility', _id: any, name?: string | null }> } | null } | null };

export type StaffingAgencyHolidaysQueryVariables = Exact<{
  sort?: InputMaybe<SortFindManyStaffingAgencyHolidayInput>;
}>;


export type StaffingAgencyHolidaysQuery = { __typename?: 'Query', lookups?: { __typename?: 'QueryLookups', StaffingAgencyHoliday?: { __typename?: 'QueryLookupsStaffingAgencyHoliday', many: Array<{ __typename?: 'StaffingAgencyHoliday', _id: any, name?: string | null }> } | null } | null };

export type StaffingAgencyPocTypesQueryVariables = Exact<{
  sort?: InputMaybe<SortFindManyStaffingAgencyPocTypeInput>;
}>;


export type StaffingAgencyPocTypesQuery = { __typename?: 'Query', lookups?: { __typename?: 'QueryLookups', StaffingAgencyPocType?: { __typename?: 'QueryLookupsStaffingAgencyPocType', many: Array<{ __typename?: 'StaffingAgencyPocType', _id: any, name?: string | null }> } | null } | null };

export type TimezonesQueryVariables = Exact<{
  sort?: InputMaybe<SortFindManyTimezoneInput>;
}>;


export type TimezonesQuery = { __typename?: 'Query', lookups?: { __typename?: 'QueryLookups', Timezone?: { __typename?: 'QueryLookupsTimezone', many: Array<{ __typename?: 'Timezone', _id: any, name?: string | null }> } | null } | null };

export type MutateCreatePositionMutationVariables = Exact<{
  record: CreateOnePositionInput;
}>;


export type MutateCreatePositionMutation = { __typename?: 'Mutation', cat?: { __typename?: 'MutationCat', position?: { __typename?: 'MutationCatPosition', createOne?: { __typename?: 'CreateOnePositionPayload', recordId?: number | null } | null } | null } | null };

export type MutatePositionByIdMutationVariables = Exact<{
  id: Scalars['Int'];
  record: UpdateByIdPositionInput;
}>;


export type MutatePositionByIdMutation = { __typename?: 'Mutation', cat?: { __typename?: 'MutationCat', position?: { __typename?: 'MutationCatPosition', updateById?: { __typename?: 'UpdateByIdPositionPayload', recordId?: number | null } | null } | null } | null };

export type PositionCreatedUpdatedByIdQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type PositionCreatedUpdatedByIdQuery = { __typename?: 'Query', cat?: { __typename?: 'QueryCat', position?: { __typename?: 'QueryCatPosition', byId?: { __typename?: 'Position', _id: number, createdAt?: any | null, updatedAt?: any | null, _createdBy?: { __typename?: 'User', name?: string | null } | null, _updatedBy?: { __typename?: 'User', name?: string | null } | null } | null } | null } | null };

export type PositionDetailsByIdQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type PositionDetailsByIdQuery = { __typename?: 'Query', cat?: { __typename?: 'QueryCat', position?: { __typename?: 'QueryCatPosition', byId?: { __typename?: 'Position', _id: number, id?: string | null, title?: string | null, status?: any | null, numberOfOpenings?: number | null, exemptStatus?: any | null, filled_date?: any | null, closed_date?: any | null, program_manager?: any | null, hiring_manager?: any | null, required_clearance?: any | null, priority?: any | null, workSetting?: any | null, location?: string | null, contract_type?: any | null, keywords?: string | null, contract?: any | null, backfill?: boolean | null, direct_hire?: boolean | null, temp_to_perm?: boolean | null, _status?: { __typename?: 'Position_Status', name?: string | null, _category?: { __typename?: 'PositionStatusCategory', name?: string | null } | null } | null, _exemptStatus?: { __typename?: 'Position_Exempt_Status', name?: string | null } | null, _program_manager?: { __typename?: 'Program_Manager', name?: string | null } | null, _hiring_manager?: { __typename?: 'Hiring_Manager', name?: string | null } | null, _required_clearance?: { __typename?: 'Clearance', name?: string | null } | null, _priority?: { __typename?: 'Position_Priority', name?: string | null } | null, _workSetting?: { __typename?: 'PositionWorkSetting', name?: string | null } | null, _contract_type?: { __typename?: 'Contract_Type', name?: string | null } | null, _contract?: { __typename?: 'Cat_Contract', _id: any, abbreviation?: string | null } | null } | null } | null } | null };

export type PositionJobDescByIdQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type PositionJobDescByIdQuery = { __typename?: 'Query', cat?: { __typename?: 'QueryCat', position?: { __typename?: 'QueryCatPosition', byId?: { __typename?: 'Position', _id: number, job_desc_received?: any | null, job_desc_finalized?: any | null, job_desc_posted?: any | null } | null } | null } | null };

export type PositionNotesByIdQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type PositionNotesByIdQuery = { __typename?: 'Query', cat?: { __typename?: 'QueryCat', position?: { __typename?: 'QueryCatPosition', byId?: { __typename?: 'Position', _id: number, notes?: string | null } | null } | null } | null };

export type PositionRatesByIdQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type PositionRatesByIdQuery = { __typename?: 'Query', cat?: { __typename?: 'QueryCat', position?: { __typename?: 'QueryCatPosition', byId?: { __typename?: 'Position', _id: number, pricing?: { __typename?: 'PositionPricing', received?: any | null, requested?: any | null } | null, bill_rate?: { __typename?: 'PositionBill_rate', min?: number | null, max?: number | null } | null, salary?: { __typename?: 'PositionSalary', min?: number | null, max?: number | null } | null } | null } | null } | null };

export type PositionsQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyPositionInput>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPositionInput>;
}>;


export type PositionsQuery = { __typename?: 'Query', cat?: { __typename?: 'QueryCat', position?: { __typename?: 'QueryCatPosition', many: Array<{ __typename?: 'Position', _id: number, id?: string | null, title?: string | null, _status?: { __typename?: 'Position_Status', name?: string | null } | null, _contract?: { __typename?: 'Cat_Contract', abbreviation?: string | null } | null, _program_manager?: { __typename?: 'Program_Manager', name?: string | null } | null, bill_rate?: { __typename?: 'PositionBill_rate', min?: number | null, max?: number | null } | null, salary?: { __typename?: 'PositionSalary', min?: number | null, max?: number | null } | null }> } | null } | null };

export type MutateCreateReportBuilderReportMutationVariables = Exact<{
  record: CreateOneReportBuilderReportInput;
}>;


export type MutateCreateReportBuilderReportMutation = { __typename?: 'Mutation', cat?: { __typename?: 'MutationCat', reporting?: { __typename?: 'MutationCatReporting', builder?: { __typename?: 'MutationCatReportingBuilder', report?: { __typename?: 'MutationCatReportingBuilderReport', createOne?: { __typename?: 'CreateOneReportBuilderReportPayload', recordId?: any | null } | null } | null } | null } | null } | null };

export type MutateDeleteReportBuilderReportMutationVariables = Exact<{
  id: Scalars['MongoID'];
}>;


export type MutateDeleteReportBuilderReportMutation = { __typename?: 'Mutation', cat?: { __typename?: 'MutationCat', reporting?: { __typename?: 'MutationCatReporting', builder?: { __typename?: 'MutationCatReportingBuilder', report?: { __typename?: 'MutationCatReportingBuilderReport', deleteById?: { __typename?: 'DeleteByIdReportBuilderReportPayload', recordId?: any | null } | null } | null } | null } | null } | null };

export type MutateReportBuilderReportByIdMutationVariables = Exact<{
  id: Scalars['MongoID'];
  record: UpdateByIdReportBuilderReportInput;
}>;


export type MutateReportBuilderReportByIdMutation = { __typename?: 'Mutation', cat?: { __typename?: 'MutationCat', reporting?: { __typename?: 'MutationCatReporting', builder?: { __typename?: 'MutationCatReportingBuilder', report?: { __typename?: 'MutationCatReportingBuilderReport', updateById?: { __typename?: 'UpdateByIdReportBuilderReportPayload', recordId?: any | null } | null } | null } | null } | null } | null };

export type ReportBuilderReportByIdQueryVariables = Exact<{
  id: Scalars['MongoID'];
}>;


export type ReportBuilderReportByIdQuery = { __typename?: 'Query', cat?: { __typename?: 'QueryCat', reporting?: { __typename?: 'QueryCatReporting', builder?: { __typename?: 'QueryCatReportingBuilder', report?: { __typename?: 'QueryCatReportingBuilderReport', byId?: { __typename?: 'ReportBuilderReport', _id: any, title: string, model?: EnumReportBuilderReportModel | null, query: any, fields?: Array<string | null> | null, createdAt?: any | null, updatedAt?: any | null, _createdBy?: { __typename?: 'User', _id: any, name?: string | null } | null, _updatedBy?: { __typename?: 'User', _id: any, name?: string | null } | null } | null } | null } | null } | null } | null };

export type ReportBuilderReportsQueryVariables = Exact<{ [key: string]: never; }>;


export type ReportBuilderReportsQuery = { __typename?: 'Query', cat?: { __typename?: 'QueryCat', reporting?: { __typename?: 'QueryCatReporting', builder?: { __typename?: 'QueryCatReportingBuilder', report?: { __typename?: 'QueryCatReportingBuilderReport', many: Array<{ __typename?: 'ReportBuilderReport', _id: any, title: string, model?: EnumReportBuilderReportModel | null, fields?: Array<string | null> | null, createdAt?: any | null, updatedAt?: any | null, _createdBy?: { __typename?: 'User', _id: any, name?: string | null } | null, _updatedBy?: { __typename?: 'User', _id: any, name?: string | null } | null }> } | null } | null } | null } | null };

export type ApplicantSourcesQueryVariables = Exact<{
  start: Scalars['Date'];
  end: Scalars['Date'];
}>;


export type ApplicantSourcesQuery = { __typename?: 'Query', reporting?: { __typename?: 'QueryReporting', applicantSources?: Array<{ __typename?: 'ApplicantSource', _id: string, source: string, count: number, category?: { __typename?: 'ApplicantSourceCategory', _id: string, name: string, count: number } | null }> | null } | null };

export type ApplicantStagesQueryVariables = Exact<{
  start: Scalars['Date'];
  end: Scalars['Date'];
}>;


export type ApplicantStagesQuery = { __typename?: 'Query', reporting?: { __typename?: 'QueryReporting', applicantStages?: Array<{ __typename?: 'ApplicantStage', name?: string | null, count?: number | null }> | null } | null };

export type AverageTimeToFillQueryVariables = Exact<{
  start: Scalars['Date'];
  end: Scalars['Date'];
  groupBy?: InputMaybe<AverageTimeToFillGroupBy>;
}>;


export type AverageTimeToFillQuery = { __typename?: 'Query', reporting?: { __typename?: 'QueryReporting', averageTimeToFill?: { __typename?: 'AverageTimeToFill', avg: number, groups?: Array<{ __typename?: 'AverageTimeToFillGroup', group?: string | null, avg?: number | null }> | null } | null } | null };

export type PositionSummaryReportQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type PositionSummaryReportQuery = { __typename?: 'Query', reporting?: { __typename?: 'QueryReporting', positionSummary: { __typename?: 'PositionSummaryReport', _id: string, report: string } } | null };

export type ReportBuilderQueryVariables = Exact<{
  model: Scalars['String'];
  match?: InputMaybe<Scalars['JSON']>;
  pipeline?: InputMaybe<Array<InputMaybe<Scalars['JSON']>> | InputMaybe<Scalars['JSON']>>;
}>;


export type ReportBuilderQuery = { __typename?: 'Query', cat?: { __typename?: 'QueryCat', reporting?: { __typename?: 'QueryCatReporting', builder?: { __typename?: 'QueryCatReportingBuilder', aggregate?: { __typename?: 'ReportBuilderAggregateResult', results?: Array<any | null> | null } | null } | null } | null } | null };

export type MutateCreateStaffingAgencyPocMutationVariables = Exact<{
  record: CreateOneStaffingAgencyPocInput;
}>;


export type MutateCreateStaffingAgencyPocMutation = { __typename?: 'Mutation', cat?: { __typename?: 'MutationCat', staffingAgencyPoc?: { __typename?: 'MutationCatStaffingAgencyPoc', createOne?: { __typename?: 'CreateOneStaffingAgencyPocPayload', recordId?: any | null } | null } | null } | null };

export type MutateDeleteStaffingAgencyPocByIdMutationVariables = Exact<{
  id: Scalars['MongoID'];
}>;


export type MutateDeleteStaffingAgencyPocByIdMutation = { __typename?: 'Mutation', cat?: { __typename?: 'MutationCat', staffingAgencyPoc?: { __typename?: 'MutationCatStaffingAgencyPoc', deleteById?: { __typename?: 'DeleteByIdStaffingAgencyPocPayload', recordId?: any | null } | null } | null } | null };

export type MutateStaffingAgencyPocByIdMutationVariables = Exact<{
  id: Scalars['MongoID'];
  record: UpdateByIdStaffingAgencyPocInput;
}>;


export type MutateStaffingAgencyPocByIdMutation = { __typename?: 'Mutation', cat?: { __typename?: 'MutationCat', staffingAgencyPoc?: { __typename?: 'MutationCatStaffingAgencyPoc', updateById?: { __typename?: 'UpdateByIdStaffingAgencyPocPayload', recordId?: any | null } | null } | null } | null };

export type StaffingAgencyPocByIdQueryVariables = Exact<{
  id: Scalars['MongoID'];
}>;


export type StaffingAgencyPocByIdQuery = { __typename?: 'Query', cat?: { __typename?: 'QueryCat', staffingAgencyPoc?: { __typename?: 'QueryCatStaffingAgencyPoc', byId?: { __typename?: 'StaffingAgencyPoc', _id: any, name?: string | null, title?: string | null, email?: string | null, phone?: string | null, type?: any | null, timezone?: any | null, address?: { __typename?: 'StaffingAgencyPocAddress', street?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null } | null } | null } | null };

export type StaffingAgencyPocsQueryVariables = Exact<{
  sort?: InputMaybe<SortFindManyStaffingAgencyPocInput>;
  filter?: InputMaybe<FilterFindManyStaffingAgencyPocInput>;
}>;


export type StaffingAgencyPocsQuery = { __typename?: 'Query', cat?: { __typename?: 'QueryCat', staffingAgencyPoc?: { __typename?: 'QueryCatStaffingAgencyPoc', many: Array<{ __typename?: 'StaffingAgencyPoc', _id: any, name?: string | null, title?: string | null, email?: string | null, phone?: string | null, _timezone?: { __typename?: 'Timezone', _id: any, name?: string | null, abbreviation?: string | null } | null, _type?: { __typename?: 'StaffingAgencyPocType', _id: any, name?: string | null } | null }> } | null } | null };

export type AllDataMigrationsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllDataMigrationsQuery = { __typename?: 'Query', migrations?: { __typename?: 'QueryMigrations', all?: Array<{ __typename?: 'Migration', name?: string | null, path?: string | null, status?: string | null } | null> | null } | null };

export type MutateDataMigrationDownMutationVariables = Exact<{ [key: string]: never; }>;


export type MutateDataMigrationDownMutation = { __typename?: 'Mutation', migrations?: { __typename?: 'MutationMigrations', down?: Array<{ __typename?: 'Migration', name?: string | null } | null> | null } | null };

export type MutateDataMigrationUpMutationVariables = Exact<{ [key: string]: never; }>;


export type MutateDataMigrationUpMutation = { __typename?: 'Mutation', migrations?: { __typename?: 'MutationMigrations', up?: Array<{ __typename?: 'Migration', name?: string | null } | null> | null } | null };

export type DevUpdateQueryVariables = Exact<{
  id: Scalars['MongoID'];
}>;


export type DevUpdateQuery = { __typename?: 'Query', dev?: { __typename?: 'QueryDev', update?: { __typename?: 'QueryDevUpdate', byId?: { __typename?: 'DevUpdateTracker', _id: any, status?: string | null, database?: { __typename?: 'DevUpdateTrackerDatabase', total?: number | null, copied?: number | null, collections?: Array<{ __typename?: 'DevUpdateTrackerDatabaseCollections', name?: string | null, itemCount?: number | null, status?: string | null } | null> | null } | null, s3?: { __typename?: 'DevUpdateTrackerS3', status?: string | null, total?: number | null, copied?: number | null } | null } | null } | null } | null };

export type UpdateDevMutationVariables = Exact<{
  databaseFrom: Scalars['String'];
  databaseTo: Scalars['String'];
  bucketFrom: Scalars['String'];
  bucketTo: Scalars['String'];
}>;


export type UpdateDevMutation = { __typename?: 'Mutation', dev?: { __typename?: 'MutationDev', update?: { __typename?: 'DevUpdateTracker', _id: any } | null } | null };


export const AttachmentByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"attachmentById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MongoID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"byId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"subtype"}}]}}]}}]}}]} as unknown as DocumentNode<AttachmentByIdQuery, AttachmentByIdQueryVariables>;
export const SearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Search"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"GlobalSearchFilterArgs"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"search"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"perPage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"badges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"itemCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageCount"}},{"kind":"Field","name":{"kind":"Name","value":"perPage"}}]}}]}}]}}]} as unknown as DocumentNode<SearchQuery, SearchQueryVariables>;
export const UserSelfDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserSelf"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"self"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"_role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"defaultPage"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"_permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"defaultPage"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"}}]}}]}}]}}]} as unknown as DocumentNode<UserSelfQuery, UserSelfQueryVariables>;
export const MutateAnalyticsCreateOneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"mutateAnalyticsCreateOne"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"record"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateOneAnalyticsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"analytics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"record"},"value":{"kind":"Variable","name":{"kind":"Name","value":"record"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recordId"}}]}}]}}]}}]} as unknown as DocumentNode<MutateAnalyticsCreateOneMutation, MutateAnalyticsCreateOneMutationVariables>;
export const AttachmentSubtypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"attachmentSubtypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterFindManyAttachment_SubtypeInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attachmentSubtypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"many"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<AttachmentSubtypesQuery, AttachmentSubtypesQueryVariables>;
export const AttachmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"attachments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterFindManyAttachmentInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SortFindManyAttachmentInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"many"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"_subtype"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"_link"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Position"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"keywords"}},{"kind":"Field","name":{"kind":"Name","value":"_contract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"_updatedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AttachmentsQuery, AttachmentsQueryVariables>;
export const MutateRemoveAttachmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"mutateRemoveAttachment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MongoID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recordId"}}]}}]}}]}}]} as unknown as DocumentNode<MutateRemoveAttachmentMutation, MutateRemoveAttachmentMutationVariables>;
export const MutateUpdateAttachmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"mutateUpdateAttachment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MongoID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"record"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateByIdAttachmentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"record"},"value":{"kind":"Variable","name":{"kind":"Name","value":"record"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recordId"}}]}}]}}]}}]} as unknown as DocumentNode<MutateUpdateAttachmentMutation, MutateUpdateAttachmentMutationVariables>;
export const CandidateContractualDocumentByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"candidateContractualDocumentById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MongoID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"candidate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"byId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"nda_signed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"staffing_agency"}},{"kind":"Field","name":{"kind":"Name","value":"candidate"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CandidateContractualDocumentByIdQuery, CandidateContractualDocumentByIdQueryVariables>;
export const CandidateCreatedUpdatedByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"candidateCreatedUpdatedById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MongoID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"candidate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"byId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"_createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_updatedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CandidateCreatedUpdatedByIdQuery, CandidateCreatedUpdatedByIdQueryVariables>;
export const CandidateDetailsByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"candidateDetailsById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MongoID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"candidate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"byId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first"}},{"kind":"Field","name":{"kind":"Name","value":"last"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastFirstName"}},{"kind":"Field","name":{"kind":"Name","value":"_position"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}}]}},{"kind":"Field","name":{"kind":"Name","value":"received_on"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clearance"}},{"kind":"Field","name":{"kind":"Name","value":"_clearance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reapply"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"_status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"substatus"}},{"kind":"Field","name":{"kind":"Name","value":"_substatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rejection_date"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CandidateDetailsByIdQuery, CandidateDetailsByIdQueryVariables>;
export const CandidateExhibitByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"candidateExhibitById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MongoID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"candidate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"byId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"exhibit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sent_for_review"}},{"kind":"Field","name":{"kind":"Name","value":"hm_approved"}},{"kind":"Field","name":{"kind":"Name","value":"contracts_approved"}},{"kind":"Field","name":{"kind":"Name","value":"extended"}},{"kind":"Field","name":{"kind":"Name","value":"signed"}},{"kind":"Field","name":{"kind":"Name","value":"pmo_approved"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CandidateExhibitByIdQuery, CandidateExhibitByIdQueryVariables>;
export const CandidateInterviewByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"candidateInterviewById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MongoID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"candidate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"byId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"round_1"}},{"kind":"Field","name":{"kind":"Name","value":"round_2"}},{"kind":"Field","name":{"kind":"Name","value":"round_3"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CandidateInterviewByIdQuery, CandidateInterviewByIdQueryVariables>;
export const CandidateNotesByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"candidateNotesById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MongoID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"candidate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"byId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CandidateNotesByIdQuery, CandidateNotesByIdQueryVariables>;
export const CandidateOfferLetterByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"candidateOfferLetterById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MongoID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"candidate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"byId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"offer_letter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approved"}},{"kind":"Field","name":{"kind":"Name","value":"extended"}},{"kind":"Field","name":{"kind":"Name","value":"signed"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CandidateOfferLetterByIdQuery, CandidateOfferLetterByIdQueryVariables>;
export const CandidatePositionDetailsByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"candidatePositionDetailsById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MongoID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"candidate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"byId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"_position"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"_contract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"distribution"}},{"kind":"Field","name":{"kind":"Name","value":"_distribution"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_subcategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CandidatePositionDetailsByIdQuery, CandidatePositionDetailsByIdQueryVariables>;
export const CandidateRatesByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"candidateRatesById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MongoID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"candidate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"byId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"bill_rate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}}]}},{"kind":"Field","name":{"kind":"Name","value":"salary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_position"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bill_rate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}}]}},{"kind":"Field","name":{"kind":"Name","value":"salary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CandidateRatesByIdQuery, CandidateRatesByIdQueryVariables>;
export const CandidateResumeReviewByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"candidateResumeReviewById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MongoID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"candidate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"byId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"resume"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sent"}},{"kind":"Field","name":{"kind":"Name","value":"reviewed"}},{"kind":"Field","name":{"kind":"Name","value":"reviewed_by"}},{"kind":"Field","name":{"kind":"Name","value":"_reviewed_by"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"_rank"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CandidateResumeReviewByIdQuery, CandidateResumeReviewByIdQueryVariables>;
export const CandidatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"candidates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterFindManyCandidateInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"candidate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"many"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"attachments_count"}},{"kind":"Field","name":{"kind":"Name","value":"resume"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sent"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first"}},{"kind":"Field","name":{"kind":"Name","value":"last"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_distribution"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_subcategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"_status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_substatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bill_rate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}}]}},{"kind":"Field","name":{"kind":"Name","value":"salary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}}]}},{"kind":"Field","name":{"kind":"Name","value":"round_1"}},{"kind":"Field","name":{"kind":"Name","value":"round_2"}},{"kind":"Field","name":{"kind":"Name","value":"round_3"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CandidatesQuery, CandidatesQueryVariables>;
export const CandidatesByNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"candidatesByName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterFindManyCandidateInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"candidate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"many"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first"}},{"kind":"Field","name":{"kind":"Name","value":"last"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_position"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CandidatesByNameQuery, CandidatesByNameQueryVariables>;
export const MutateCandidateByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"mutateCandidateById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MongoID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"record"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateByIdCandidateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"candidate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"record"},"value":{"kind":"Variable","name":{"kind":"Name","value":"record"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recordId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MutateCandidateByIdMutation, MutateCandidateByIdMutationVariables>;
export const MutateCopyCandidateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"mutateCopyCandidate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MongoID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"position"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"distribution"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MongoID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CopyCandidateNameInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"details"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contact"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rates"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notes"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"attachments"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"candidate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"copy"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"position"},"value":{"kind":"Variable","name":{"kind":"Name","value":"position"}}},{"kind":"Argument","name":{"kind":"Name","value":"distribution"},"value":{"kind":"Variable","name":{"kind":"Name","value":"distribution"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"details"},"value":{"kind":"Variable","name":{"kind":"Name","value":"details"}}},{"kind":"Argument","name":{"kind":"Name","value":"contact"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contact"}}},{"kind":"Argument","name":{"kind":"Name","value":"rates"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rates"}}},{"kind":"Argument","name":{"kind":"Name","value":"notes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notes"}}},{"kind":"Argument","name":{"kind":"Name","value":"attachments"},"value":{"kind":"Variable","name":{"kind":"Name","value":"attachments"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recordId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MutateCopyCandidateMutation, MutateCopyCandidateMutationVariables>;
export const MutateCreateCandidateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"mutateCreateCandidate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"record"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateOneCandidateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"candidate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"record"},"value":{"kind":"Variable","name":{"kind":"Name","value":"record"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recordId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MutateCreateCandidateMutation, MutateCreateCandidateMutationVariables>;
export const MutateRemoveCandidateByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"mutateRemoveCandidateById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MongoID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"candidate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recordId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MutateRemoveCandidateByIdMutation, MutateRemoveCandidateByIdMutationVariables>;
export const ContractDetailsByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"contractDetailsById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MongoID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"byId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"teamSize"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"prime"}},{"kind":"Field","name":{"kind":"Name","value":"subcontractor"}},{"kind":"Field","name":{"kind":"Name","value":"vehicle"}},{"kind":"Field","name":{"kind":"Name","value":"_vehicle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"portfolio_manager"}},{"kind":"Field","name":{"kind":"Name","value":"_portfolio_manager"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"program_manager"}},{"kind":"Field","name":{"kind":"Name","value":"_program_manager"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primary_address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ContractDetailsByIdQuery, ContractDetailsByIdQueryVariables>;
export const ContractNotesByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ContractNotesById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MongoID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"byId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ContractNotesByIdQuery, ContractNotesByIdQueryVariables>;
export const ContractOnboardingByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"contractOnboardingById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MongoID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"byId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"onboarding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"clearanceReqs"}},{"kind":"Field","name":{"kind":"Name","value":"biProcessTimeframe"}},{"kind":"Field","name":{"kind":"Name","value":"gfeProvided"}},{"kind":"Field","name":{"kind":"Name","value":"imcEquipment"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ContractOnboardingByIdQuery, ContractOnboardingByIdQueryVariables>;
export const ContractPopByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"contractPopById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MongoID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"byId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"pop"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"base"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}},{"kind":"Field","name":{"kind":"Name","value":"extensions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ContractPopByIdQuery, ContractPopByIdQueryVariables>;
export const ContractPositionCountsByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"contractPositionCountsById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MongoID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countByPositionStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ContractPositionCountsByIdQuery, ContractPositionCountsByIdQueryVariables>;
export const ContractsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"contracts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SortFindManyCat_ContractInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"withPositionCount"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"many"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"_status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_portfolio_manager"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_program_manager"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"position_count"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"withPositionCount"}}}]}]}]}}]}}]}}]}}]} as unknown as DocumentNode<ContractsQuery, ContractsQueryVariables>;
export const MutateContractByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"mutateContractById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MongoID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"record"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateByIdCat_ContractInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"record"},"value":{"kind":"Variable","name":{"kind":"Name","value":"record"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recordId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MutateContractByIdMutation, MutateContractByIdMutationVariables>;
export const MutateCreateContractDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"mutateCreateContract"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"record"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateOneCat_ContractInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"record"},"value":{"kind":"Variable","name":{"kind":"Name","value":"record"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recordId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MutateCreateContractMutation, MutateCreateContractMutationVariables>;
export const ContractInterviewerByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"contractInterviewerById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MongoID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractInterviewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"byId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ContractInterviewerByIdQuery, ContractInterviewerByIdQueryVariables>;
export const ContractInterviewersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"contractInterviewers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SortFindManyContractInterviewerInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterFindManyContractInterviewerInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractInterviewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"many"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ContractInterviewersQuery, ContractInterviewersQueryVariables>;
export const MutateContractInterviewerByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"mutateContractInterviewerById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MongoID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"record"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateByIdContractInterviewerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractInterviewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"record"},"value":{"kind":"Variable","name":{"kind":"Name","value":"record"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recordId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MutateContractInterviewerByIdMutation, MutateContractInterviewerByIdMutationVariables>;
export const MutateCreateContractInterviewerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"mutateCreateContractInterviewer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"record"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateOneContractInterviewerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractInterviewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"record"},"value":{"kind":"Variable","name":{"kind":"Name","value":"record"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recordId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MutateCreateContractInterviewerMutation, MutateCreateContractInterviewerMutationVariables>;
export const MutateDeleteContractInterviewerByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"mutateDeleteContractInterviewerById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MongoID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractInterviewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recordId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MutateDeleteContractInterviewerByIdMutation, MutateDeleteContractInterviewerByIdMutationVariables>;
export const DistributionCreatedUpdatedByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"distributionCreatedUpdatedById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MongoID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distribution"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"byId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"_createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_updatedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DistributionCreatedUpdatedByIdQuery, DistributionCreatedUpdatedByIdQueryVariables>;
export const DistributionDetailsByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"distributionDetailsById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MongoID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distribution"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"byId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subcategory"}},{"kind":"Field","name":{"kind":"Name","value":"_subcategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"_position"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"_contract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"date_posted"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DistributionDetailsByIdQuery, DistributionDetailsByIdQueryVariables>;
export const DistributionNotesByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"distributionNotesById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MongoID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distribution"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"byId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DistributionNotesByIdQuery, DistributionNotesByIdQueryVariables>;
export const DistributionsByPositionIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"distributionsByPositionId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterFindManyDistributionInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distribution"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"many"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"attachments_count"}},{"kind":"Field","name":{"kind":"Name","value":"_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_subcategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"date_posted"}},{"kind":"Field","name":{"kind":"Name","value":"candidate_count"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DistributionsByPositionIdQuery, DistributionsByPositionIdQueryVariables>;
export const DistributionsOverviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"distributionsOverview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterFindManyDistributionInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distribution"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"many"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_subcategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"date_posted"}},{"kind":"Field","name":{"kind":"Name","value":"candidate_count"}},{"kind":"Field","name":{"kind":"Name","value":"_position"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"bill_rate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"max"}}]}},{"kind":"Field","name":{"kind":"Name","value":"salary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"max"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_contract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<DistributionsOverviewQuery, DistributionsOverviewQueryVariables>;
export const MutateCreateManyDistributionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"mutateCreateManyDistributions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"records"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateManyDistributionInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distribution"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createMany"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"records"},"value":{"kind":"Variable","name":{"kind":"Name","value":"records"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recordIds"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MutateCreateManyDistributionsMutation, MutateCreateManyDistributionsMutationVariables>;
export const MutateDistributionByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"mutateDistributionById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MongoID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"record"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateByIdDistributionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distribution"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"record"},"value":{"kind":"Variable","name":{"kind":"Name","value":"record"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recordId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MutateDistributionByIdMutation, MutateDistributionByIdMutationVariables>;
export const MutateRemoveDistributionByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"mutateRemoveDistributionById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MongoID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distribution"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recordId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MutateRemoveDistributionByIdMutation, MutateRemoveDistributionByIdMutationVariables>;
export const StaffingAgenciesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"staffingAgencies"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SortFindManyDistribution_SubcategoryInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterFindManyDistribution_SubcategoryInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distributionSubcategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"many"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"_status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"staffingAgency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sdvosb"}}]}},{"kind":"Field","name":{"kind":"Name","value":"position_count"}}]}}]}}]}}]}}]} as unknown as DocumentNode<StaffingAgenciesQuery, StaffingAgenciesQueryVariables>;
export const StaffingAgencyBenefitsByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"staffingAgencyBenefitsById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MongoID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distributionSubcategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"byId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"staffingAgency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"benefits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payrollRunTime"}},{"kind":"Field","name":{"kind":"Name","value":"healthBenefits"}},{"kind":"Field","name":{"kind":"Name","value":"pto"}},{"kind":"Field","name":{"kind":"Name","value":"holidays"}},{"kind":"Field","name":{"kind":"Name","value":"_holidays"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<StaffingAgencyBenefitsByIdQuery, StaffingAgencyBenefitsByIdQueryVariables>;
export const StaffingAgencyDetailsByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"staffingAgencyDetailsById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MongoID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distributionSubcategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"byId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"_status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"staffingAgency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sdvosb"}},{"kind":"Field","name":{"kind":"Name","value":"clearedFacility"}},{"kind":"Field","name":{"kind":"Name","value":"_clearedFacility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<StaffingAgencyDetailsByIdQuery, StaffingAgencyDetailsByIdQueryVariables>;
export const StaffingAgencyMsaByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"staffingAgencyMsaById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MongoID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distributionSubcategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"byId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"staffingAgency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"msa"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dateSigned"}},{"kind":"Field","name":{"kind":"Name","value":"conversionTimeframe"}},{"kind":"Field","name":{"kind":"Name","value":"conversionFees"}},{"kind":"Field","name":{"kind":"Name","value":"dhAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"dhWarranty"}},{"kind":"Field","name":{"kind":"Name","value":"nonSolicitationDuration"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<StaffingAgencyMsaByIdQuery, StaffingAgencyMsaByIdQueryVariables>;
export const StaffingAgencyRemitDetailsByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"staffingAgencyRemitDetailsById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MongoID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distributionSubcategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"byId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"staffingAgency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"remit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentDetails"}},{"kind":"Field","name":{"kind":"Name","value":"paymentTerms"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<StaffingAgencyRemitDetailsByIdQuery, StaffingAgencyRemitDetailsByIdQueryVariables>;
export const DistributionSubcategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"distributionSubcategories"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterFindManyDistribution_SubcategoryInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SortFindManyDistribution_SubcategoryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distributionSubcategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"many"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DistributionSubcategoriesQuery, DistributionSubcategoriesQueryVariables>;
export const DistributionSubcategoriesAndCategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"distributionSubcategoriesAndCategories"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterFindManyDistribution_SubcategoryInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SortFindManyDistribution_SubcategoryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distributionSubcategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"many"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<DistributionSubcategoriesAndCategoriesQuery, DistributionSubcategoriesAndCategoriesQueryVariables>;
export const DistributionSubcategoryCreatedUpdatedByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"distributionSubcategoryCreatedUpdatedById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MongoID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distributionSubcategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"byId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"_createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_updatedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DistributionSubcategoryCreatedUpdatedByIdQuery, DistributionSubcategoryCreatedUpdatedByIdQueryVariables>;
export const DistributionSubcategoryNotesByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"distributionSubcategoryNotesById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MongoID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distributionSubcategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"byId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DistributionSubcategoryNotesByIdQuery, DistributionSubcategoryNotesByIdQueryVariables>;
export const MutateDistributionSubcategoryByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"mutateDistributionSubcategoryById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MongoID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"record"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateByIdDistribution_SubcategoryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distributionSubcategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"record"},"value":{"kind":"Variable","name":{"kind":"Name","value":"record"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recordId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MutateDistributionSubcategoryByIdMutation, MutateDistributionSubcategoryByIdMutationVariables>;
export const EeocByCandidateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"eeocByCandidate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"candidate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MongoID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eeoc"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findEeocByCandidate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"candidate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"candidate"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"signedOn"}},{"kind":"Field","name":{"kind":"Name","value":"documents"}},{"kind":"Field","name":{"kind":"Name","value":"voidedOn"}},{"kind":"Field","name":{"kind":"Name","value":"voidReason"}}]}}]}}]}}]}}]} as unknown as DocumentNode<EeocByCandidateQuery, EeocByCandidateQueryVariables>;
export const EeocDocByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"eeocDocById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MongoID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eeoc"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"byId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"envelope"}},{"kind":"Field","name":{"kind":"Name","value":"documents"}},{"kind":"Field","name":{"kind":"Name","value":"_candidate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lastFirstName"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<EeocDocByIdQuery, EeocDocByIdQueryVariables>;
export const EeocsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Eeocs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterFindManyEeocInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SortFindManyEeocInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eeoc"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"many"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"candidate"}},{"kind":"Field","name":{"kind":"Name","value":"_candidate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"lastFirstName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"signedOn"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"documentData"}},{"kind":"Field","name":{"kind":"Name","value":"voidReason"}},{"kind":"Field","name":{"kind":"Name","value":"voidedOn"}}]}}]}}]}}]}}]} as unknown as DocumentNode<EeocsQuery, EeocsQueryVariables>;
export const MutateSendEeocByCandidateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"mutateSendEeocByCandidate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"candidate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MongoID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"voidReason"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eeoc"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendEeocByCandidate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"candidate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"candidate"}}},{"kind":"Argument","name":{"kind":"Name","value":"voidReason"},"value":{"kind":"Variable","name":{"kind":"Name","value":"voidReason"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"candidate"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MutateSendEeocByCandidateMutation, MutateSendEeocByCandidateMutationVariables>;
export const MutateVoidEeocByCandidateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"mutateVoidEeocByCandidate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"candidate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MongoID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"voidReason"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eeoc"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"voidEeocByCandidate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"candidate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"candidate"}}},{"kind":"Argument","name":{"kind":"Name","value":"voidReason"},"value":{"kind":"Variable","name":{"kind":"Name","value":"voidReason"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"candidate"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MutateVoidEeocByCandidateMutation, MutateVoidEeocByCandidateMutationVariables>;
export const LookupConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"lookupConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lookups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"config"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"byId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"component"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"props"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"relationships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<LookupConfigQuery, LookupConfigQueryVariables>;
export const LookupConfigsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"lookupConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lookups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"config"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"many"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"component"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"props"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"optionsCount"}},{"kind":"Field","name":{"kind":"Name","value":"relationships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<LookupConfigsQuery, LookupConfigsQueryVariables>;
export const LookupRelationshipsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LookupRelationships"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"key"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"relationshipModel"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MongoID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lookups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"relationships"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"Variable","name":{"kind":"Name","value":"key"}}},{"kind":"Argument","name":{"kind":"Name","value":"relationshipModel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"relationshipModel"}}},{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"pageCount"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]}}]} as unknown as DocumentNode<LookupRelationshipsQuery, LookupRelationshipsQueryVariables>;
export const CandidateRanksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"candidateRanks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SortFindManyCandidate_RankInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lookups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Candidate_Rank"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"many"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CandidateRanksQuery, CandidateRanksQueryVariables>;
export const CandidateStatusesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"candidateStatuses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SortFindManyCandidate_StatusInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lookups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Candidate_Status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"many"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CandidateStatusesQuery, CandidateStatusesQueryVariables>;
export const CandidateSubstatusesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"candidateSubstatuses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SortFindManyCandidate_SubstatusInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterFindManyCandidate_SubstatusInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lookups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Candidate_Substatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"many"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CandidateSubstatusesQuery, CandidateSubstatusesQueryVariables>;
export const CandidateTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"candidateTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SortFindManyCandidate_TypeInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lookups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Candidate_Type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"many"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CandidateTypesQuery, CandidateTypesQueryVariables>;
export const ClearancesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"clearances"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SortFindManyClearanceInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lookups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Clearance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"many"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ClearancesQuery, ClearancesQueryVariables>;
export const ContractStatusesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ContractStatuses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SortFindManyContract_StatusInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lookups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Contract_Status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"many"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ContractStatusesQuery, ContractStatusesQueryVariables>;
export const ContractTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"contractTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SortFindManyContract_TypeInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lookups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Contract_Type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"many"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ContractTypesQuery, ContractTypesQueryVariables>;
export const ContractVehiclesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"contractVehicles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SortFindManyContract_VehicleInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lookups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Contract_Vehicle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"many"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ContractVehiclesQuery, ContractVehiclesQueryVariables>;
export const DistributionCategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"distributionCategories"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SortFindManyDistribution_CategoryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lookups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Distribution_Category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"many"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DistributionCategoriesQuery, DistributionCategoriesQueryVariables>;
export const DistributionSubcategoryStatusesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"distributionSubcategoryStatuses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SortFindManyDistributionSubcategoryStatusInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lookups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"DistributionSubcategoryStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"many"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DistributionSubcategoryStatusesQuery, DistributionSubcategoryStatusesQueryVariables>;
export const HiringManagersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"hiringManagers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SortFindManyHiring_ManagerInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lookups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Hiring_Manager"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"many"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<HiringManagersQuery, HiringManagersQueryVariables>;
export const LookupOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"lookupOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"key"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lookups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"all"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"Variable","name":{"kind":"Name","value":"key"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"oldOrder"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"relationships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_updatedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<LookupOptionsQuery, LookupOptionsQueryVariables>;
export const MutateCreateLookupOptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"mutateCreateLookupOption"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"key"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"record"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lookups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"create"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"Variable","name":{"kind":"Name","value":"key"}}},{"kind":"Argument","name":{"kind":"Name","value":"record"},"value":{"kind":"Variable","name":{"kind":"Name","value":"record"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]}}]} as unknown as DocumentNode<MutateCreateLookupOptionMutation, MutateCreateLookupOptionMutationVariables>;
export const MutateDeleteLookupOptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"mutateDeleteLookupOption"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"key"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MongoID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lookups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"Variable","name":{"kind":"Name","value":"key"}}},{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletedCount"}}]}}]}}]}}]} as unknown as DocumentNode<MutateDeleteLookupOptionMutation, MutateDeleteLookupOptionMutationVariables>;
export const MutateUpdateLookupOptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"mutateUpdateLookupOption"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"key"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MongoID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"record"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lookups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"Variable","name":{"kind":"Name","value":"key"}}},{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"record"},"value":{"kind":"Variable","name":{"kind":"Name","value":"record"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]}}]} as unknown as DocumentNode<MutateUpdateLookupOptionMutation, MutateUpdateLookupOptionMutationVariables>;
export const PortfolioManagersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"portfolioManagers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SortFindManyPortfolio_ManagerInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lookups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Portfolio_Manager"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"many"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PortfolioManagersQuery, PortfolioManagersQueryVariables>;
export const PositionExemptStatusesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"positionExemptStatuses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SortFindManyPosition_Exempt_StatusInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lookups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Position_Exempt_Status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"many"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PositionExemptStatusesQuery, PositionExemptStatusesQueryVariables>;
export const PositionFilterLookupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"positionFilterLookups"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ContractFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterFindManyCat_ContractInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"StatusFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterFindManyPosition_StatusInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ContractTypeFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterFindManyContract_TypeInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ContractSort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SortFindManyCat_ContractInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"StatusSort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SortFindManyPosition_StatusInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ContractTypeSort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SortFindManyContract_TypeInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lookups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Position_Status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"many"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"StatusFilter"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"StatusSort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"Contract_Type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"many"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ContractTypeFilter"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ContractTypeSort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"many"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ContractFilter"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ContractSort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PositionFilterLookupsQuery, PositionFilterLookupsQueryVariables>;
export const PositionPrioritiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"positionPriorities"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SortFindManyPosition_PriorityInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lookups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Position_Priority"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"many"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PositionPrioritiesQuery, PositionPrioritiesQueryVariables>;
export const PositionStatusesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"positionStatuses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SortFindManyPosition_StatusInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lookups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Position_Status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"many"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<PositionStatusesQuery, PositionStatusesQueryVariables>;
export const PositionWorkSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"positionWorkSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SortFindManyPositionWorkSettingInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lookups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"PositionWorkSetting"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"many"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PositionWorkSettingsQuery, PositionWorkSettingsQueryVariables>;
export const ProgramManagersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"programManagers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SortFindManyProgram_ManagerInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lookups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Program_Manager"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"many"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProgramManagersQuery, ProgramManagersQueryVariables>;
export const StaffingAgencyClearedFacilitiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"staffingAgencyClearedFacilities"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SortFindManyStaffingAgencyClearedFacilityInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lookups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"StaffingAgencyClearedFacility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"many"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<StaffingAgencyClearedFacilitiesQuery, StaffingAgencyClearedFacilitiesQueryVariables>;
export const StaffingAgencyHolidaysDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"staffingAgencyHolidays"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SortFindManyStaffingAgencyHolidayInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lookups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"StaffingAgencyHoliday"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"many"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<StaffingAgencyHolidaysQuery, StaffingAgencyHolidaysQueryVariables>;
export const StaffingAgencyPocTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"staffingAgencyPocTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SortFindManyStaffingAgencyPocTypeInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lookups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"StaffingAgencyPocType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"many"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<StaffingAgencyPocTypesQuery, StaffingAgencyPocTypesQueryVariables>;
export const TimezonesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"timezones"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SortFindManyTimezoneInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lookups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Timezone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"many"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<TimezonesQuery, TimezonesQueryVariables>;
export const MutateCreatePositionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"mutateCreatePosition"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"record"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateOnePositionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"position"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"record"},"value":{"kind":"Variable","name":{"kind":"Name","value":"record"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recordId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MutateCreatePositionMutation, MutateCreatePositionMutationVariables>;
export const MutatePositionByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"mutatePositionById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"record"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateByIdPositionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"position"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"record"},"value":{"kind":"Variable","name":{"kind":"Name","value":"record"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recordId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MutatePositionByIdMutation, MutatePositionByIdMutationVariables>;
export const PositionCreatedUpdatedByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"positionCreatedUpdatedById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"position"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"byId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"_createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_updatedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PositionCreatedUpdatedByIdQuery, PositionCreatedUpdatedByIdQueryVariables>;
export const PositionDetailsByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"positionDetailsById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"position"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"byId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"_status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"numberOfOpenings"}},{"kind":"Field","name":{"kind":"Name","value":"exemptStatus"}},{"kind":"Field","name":{"kind":"Name","value":"_exemptStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"filled_date"}},{"kind":"Field","name":{"kind":"Name","value":"closed_date"}},{"kind":"Field","name":{"kind":"Name","value":"program_manager"}},{"kind":"Field","name":{"kind":"Name","value":"_program_manager"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hiring_manager"}},{"kind":"Field","name":{"kind":"Name","value":"_hiring_manager"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"required_clearance"}},{"kind":"Field","name":{"kind":"Name","value":"_required_clearance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"_priority"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workSetting"}},{"kind":"Field","name":{"kind":"Name","value":"_workSetting"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"contract_type"}},{"kind":"Field","name":{"kind":"Name","value":"_contract_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"keywords"}},{"kind":"Field","name":{"kind":"Name","value":"contract"}},{"kind":"Field","name":{"kind":"Name","value":"_contract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"backfill"}},{"kind":"Field","name":{"kind":"Name","value":"direct_hire"}},{"kind":"Field","name":{"kind":"Name","value":"temp_to_perm"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PositionDetailsByIdQuery, PositionDetailsByIdQueryVariables>;
export const PositionJobDescByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"positionJobDescById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"position"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"byId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"job_desc_received"}},{"kind":"Field","name":{"kind":"Name","value":"job_desc_finalized"}},{"kind":"Field","name":{"kind":"Name","value":"job_desc_posted"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PositionJobDescByIdQuery, PositionJobDescByIdQueryVariables>;
export const PositionNotesByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"positionNotesById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"position"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"byId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PositionNotesByIdQuery, PositionNotesByIdQueryVariables>;
export const PositionRatesByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"positionRatesById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"position"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"byId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"received"}},{"kind":"Field","name":{"kind":"Name","value":"requested"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bill_rate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}}]}},{"kind":"Field","name":{"kind":"Name","value":"salary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<PositionRatesByIdQuery, PositionRatesByIdQueryVariables>;
export const PositionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"positions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterFindManyPositionInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SortFindManyPositionInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"position"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"many"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"_status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_contract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_program_manager"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bill_rate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}}]}},{"kind":"Field","name":{"kind":"Name","value":"salary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<PositionsQuery, PositionsQueryVariables>;
export const MutateCreateReportBuilderReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"mutateCreateReportBuilderReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"record"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateOneReportBuilderReportInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reporting"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"builder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"record"},"value":{"kind":"Variable","name":{"kind":"Name","value":"record"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recordId"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<MutateCreateReportBuilderReportMutation, MutateCreateReportBuilderReportMutationVariables>;
export const MutateDeleteReportBuilderReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"mutateDeleteReportBuilderReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MongoID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reporting"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"builder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recordId"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<MutateDeleteReportBuilderReportMutation, MutateDeleteReportBuilderReportMutationVariables>;
export const MutateReportBuilderReportByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"mutateReportBuilderReportById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MongoID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"record"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateByIdReportBuilderReportInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reporting"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"builder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"record"},"value":{"kind":"Variable","name":{"kind":"Name","value":"record"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recordId"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<MutateReportBuilderReportByIdMutation, MutateReportBuilderReportByIdMutationVariables>;
export const ReportBuilderReportByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"reportBuilderReportById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MongoID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reporting"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"builder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"byId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"query"}},{"kind":"Field","name":{"kind":"Name","value":"fields"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"_createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_updatedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ReportBuilderReportByIdQuery, ReportBuilderReportByIdQueryVariables>;
export const ReportBuilderReportsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"reportBuilderReports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reporting"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"builder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"many"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"fields"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"_createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_updatedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ReportBuilderReportsQuery, ReportBuilderReportsQueryVariables>;
export const ApplicantSourcesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"applicantSources"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reporting"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"applicantSources"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}},{"kind":"Argument","name":{"kind":"Name","value":"end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ApplicantSourcesQuery, ApplicantSourcesQueryVariables>;
export const ApplicantStagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"applicantStages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reporting"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"applicantStages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}},{"kind":"Argument","name":{"kind":"Name","value":"end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<ApplicantStagesQuery, ApplicantStagesQueryVariables>;
export const AverageTimeToFillDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"averageTimeToFill"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AverageTimeToFillGroupBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reporting"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"averageTimeToFill"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}},{"kind":"Argument","name":{"kind":"Name","value":"end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}},{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avg"}},{"kind":"Field","name":{"kind":"Name","value":"groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"group"}},{"kind":"Field","name":{"kind":"Name","value":"avg"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AverageTimeToFillQuery, AverageTimeToFillQueryVariables>;
export const PositionSummaryReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"positionSummaryReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reporting"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"positionSummary"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"report"}}]}}]}}]}}]} as unknown as DocumentNode<PositionSummaryReportQuery, PositionSummaryReportQueryVariables>;
export const ReportBuilderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"reportBuilder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"model"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"match"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pipeline"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reporting"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"builder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"model"},"value":{"kind":"Variable","name":{"kind":"Name","value":"model"}}},{"kind":"Argument","name":{"kind":"Name","value":"match"},"value":{"kind":"Variable","name":{"kind":"Name","value":"match"}}},{"kind":"Argument","name":{"kind":"Name","value":"pipeline"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pipeline"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"results"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ReportBuilderQuery, ReportBuilderQueryVariables>;
export const MutateCreateStaffingAgencyPocDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"mutateCreateStaffingAgencyPoc"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"record"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateOneStaffingAgencyPocInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"staffingAgencyPoc"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"record"},"value":{"kind":"Variable","name":{"kind":"Name","value":"record"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recordId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MutateCreateStaffingAgencyPocMutation, MutateCreateStaffingAgencyPocMutationVariables>;
export const MutateDeleteStaffingAgencyPocByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"mutateDeleteStaffingAgencyPocById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MongoID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"staffingAgencyPoc"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recordId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MutateDeleteStaffingAgencyPocByIdMutation, MutateDeleteStaffingAgencyPocByIdMutationVariables>;
export const MutateStaffingAgencyPocByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"mutateStaffingAgencyPocById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MongoID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"record"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateByIdStaffingAgencyPocInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"staffingAgencyPoc"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"record"},"value":{"kind":"Variable","name":{"kind":"Name","value":"record"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recordId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MutateStaffingAgencyPocByIdMutation, MutateStaffingAgencyPocByIdMutationVariables>;
export const StaffingAgencyPocByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"staffingAgencyPocById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MongoID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"staffingAgencyPoc"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"byId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}}]}}]}}]}}]}}]} as unknown as DocumentNode<StaffingAgencyPocByIdQuery, StaffingAgencyPocByIdQueryVariables>;
export const StaffingAgencyPocsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"staffingAgencyPocs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SortFindManyStaffingAgencyPocInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterFindManyStaffingAgencyPocInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"staffingAgencyPoc"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"many"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"_timezone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<StaffingAgencyPocsQuery, StaffingAgencyPocsQueryVariables>;
export const AllDataMigrationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllDataMigrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"migrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"all"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<AllDataMigrationsQuery, AllDataMigrationsQueryVariables>;
export const MutateDataMigrationDownDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"mutateDataMigrationDown"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"migrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"down"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<MutateDataMigrationDownMutation, MutateDataMigrationDownMutationVariables>;
export const MutateDataMigrationUpDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"mutateDataMigrationUp"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"migrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"up"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<MutateDataMigrationUpMutation, MutateDataMigrationUpMutationVariables>;
export const DevUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DevUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MongoID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dev"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"byId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"database"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"copied"}},{"kind":"Field","name":{"kind":"Name","value":"collections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"itemCount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"s3"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"copied"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<DevUpdateQuery, DevUpdateQueryVariables>;
export const UpdateDevDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateDev"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"databaseFrom"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"databaseTo"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bucketFrom"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bucketTo"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dev"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"databaseFrom"},"value":{"kind":"Variable","name":{"kind":"Name","value":"databaseFrom"}}},{"kind":"Argument","name":{"kind":"Name","value":"databaseTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"databaseTo"}}},{"kind":"Argument","name":{"kind":"Name","value":"bucketFrom"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bucketFrom"}}},{"kind":"Argument","name":{"kind":"Name","value":"bucketTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bucketTo"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateDevMutation, UpdateDevMutationVariables>;